var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385, _circle386, _circle387, _circle388, _circle389, _circle390, _circle391, _circle392, _circle393, _circle394, _circle395, _circle396, _circle397, _circle398, _circle399, _circle400, _circle401, _circle402, _circle403, _circle404, _circle405, _circle406, _circle407, _circle408, _circle409, _circle410, _circle411, _circle412, _circle413, _circle414, _circle415, _circle416, _circle417, _circle418, _circle419, _circle420, _circle421, _circle422, _circle423, _circle424, _circle425, _circle426, _circle427, _circle428, _circle429, _circle430, _circle431, _circle432, _circle433, _circle434, _circle435, _circle436, _circle437, _circle438, _circle439, _circle440, _circle441, _circle442, _circle443, _circle444, _circle445, _circle446, _circle447, _circle448, _circle449, _circle450, _circle451, _circle452, _circle453, _circle454, _circle455, _circle456, _circle457, _circle458, _circle459, _circle460, _circle461, _circle462, _circle463, _circle464, _circle465, _circle466, _circle467, _circle468, _circle469, _circle470, _circle471, _circle472, _circle473, _circle474, _circle475, _circle476, _circle477, _circle478, _circle479, _circle480, _circle481, _circle482, _circle483, _circle484, _circle485, _circle486, _circle487, _circle488, _circle489, _circle490, _circle491, _circle492, _circle493, _circle494, _circle495, _circle496, _circle497, _circle498, _circle499, _circle500, _circle501, _circle502, _circle503, _circle504, _circle505, _circle506, _circle507, _circle508, _circle509, _circle510, _circle511, _circle512, _circle513, _circle514, _circle515, _circle516, _circle517, _circle518, _circle519, _circle520, _circle521, _circle522, _circle523, _circle524, _circle525, _circle526, _circle527, _circle528, _circle529, _circle530, _circle531, _circle532, _circle533, _circle534, _circle535, _circle536, _circle537, _circle538, _circle539, _circle540, _circle541, _circle542, _circle543, _circle544, _circle545, _circle546, _circle547, _circle548, _circle549, _circle550, _circle551, _circle552, _circle553, _circle554, _circle555, _circle556, _circle557, _circle558, _circle559, _circle560, _circle561, _circle562, _circle563, _circle564, _circle565, _circle566, _circle567, _circle568, _circle569, _circle570, _circle571, _circle572, _circle573, _circle574, _circle575, _circle576, _circle577, _circle578, _circle579, _circle580, _circle581, _circle582, _circle583, _circle584, _circle585, _circle586, _circle587, _circle588, _circle589, _circle590, _circle591, _circle592, _circle593, _circle594, _circle595, _circle596, _circle597, _circle598, _circle599, _circle600, _circle601, _circle602, _circle603, _circle604, _circle605, _circle606, _circle607, _circle608, _circle609, _circle610, _circle611, _circle612, _circle613, _circle614, _circle615, _circle616, _circle617, _circle618, _circle619, _circle620, _circle621, _circle622, _circle623, _circle624, _circle625, _circle626, _circle627, _circle628, _circle629, _circle630, _circle631, _circle632, _circle633, _circle634, _circle635, _circle636, _circle637, _circle638, _circle639, _circle640, _circle641, _circle642, _circle643, _circle644, _circle645, _circle646, _circle647, _circle648, _circle649, _circle650, _circle651, _circle652, _circle653, _circle654, _circle655, _circle656, _circle657, _circle658, _circle659, _circle660, _circle661, _circle662, _circle663, _circle664, _circle665, _circle666, _circle667, _circle668, _circle669, _circle670, _circle671, _circle672, _circle673, _circle674, _circle675, _circle676, _circle677, _circle678, _circle679, _circle680, _circle681, _circle682, _circle683, _circle684, _circle685, _circle686, _circle687, _circle688, _circle689, _circle690, _circle691, _circle692, _circle693, _circle694, _circle695, _circle696, _circle697, _circle698, _circle699, _circle700, _circle701, _circle702, _circle703, _circle704, _circle705, _circle706, _circle707, _circle708, _circle709, _circle710, _circle711, _circle712, _circle713, _circle714, _circle715, _circle716, _circle717, _circle718, _circle719, _circle720, _circle721, _circle722, _circle723, _circle724, _circle725, _circle726, _circle727, _circle728, _circle729, _circle730, _circle731, _circle732, _circle733, _circle734, _circle735, _circle736, _circle737, _circle738, _circle739, _circle740, _circle741, _circle742, _circle743, _circle744, _circle745, _circle746, _circle747, _circle748, _circle749, _circle750, _circle751, _circle752, _circle753, _circle754, _circle755, _circle756, _circle757, _circle758, _circle759, _circle760, _circle761, _circle762, _circle763, _circle764, _circle765, _circle766, _circle767, _circle768, _circle769, _circle770, _circle771, _circle772, _circle773, _circle774, _circle775, _circle776, _circle777, _circle778, _circle779, _circle780, _circle781, _circle782, _circle783, _circle784, _circle785, _circle786, _circle787, _circle788, _circle789, _circle790, _circle791, _circle792, _circle793, _circle794, _circle795, _circle796, _circle797, _circle798, _circle799, _circle800, _circle801, _circle802, _circle803, _circle804, _circle805, _circle806, _circle807, _circle808, _circle809, _circle810, _circle811, _circle812, _circle813, _circle814, _circle815, _circle816, _circle817, _circle818, _circle819, _circle820, _circle821, _circle822, _circle823, _circle824, _circle825, _circle826, _circle827, _circle828, _circle829, _circle830, _circle831, _circle832, _circle833, _circle834, _circle835, _circle836, _circle837, _circle838, _circle839, _circle840, _circle841, _circle842, _circle843, _circle844, _circle845, _circle846, _circle847, _circle848, _circle849, _circle850, _circle851, _circle852, _circle853, _circle854, _circle855, _circle856, _circle857, _circle858, _circle859, _circle860, _circle861, _circle862, _circle863, _circle864, _circle865, _circle866, _circle867, _circle868, _circle869, _circle870, _circle871, _circle872, _circle873, _circle874, _circle875, _circle876, _circle877, _circle878, _circle879, _circle880, _circle881, _circle882, _circle883, _circle884, _circle885, _circle886, _circle887, _circle888, _circle889, _circle890, _circle891, _circle892, _circle893, _circle894, _circle895, _circle896, _circle897, _circle898, _circle899, _circle900, _circle901, _circle902, _circle903, _circle904, _circle905, _circle906, _circle907, _circle908, _circle909, _circle910, _circle911, _circle912, _circle913, _circle914, _circle915, _circle916, _circle917, _circle918, _circle919, _circle920, _circle921, _circle922, _circle923, _circle924, _circle925, _circle926, _circle927, _circle928, _circle929, _circle930, _circle931, _circle932, _circle933, _circle934, _circle935, _circle936, _circle937, _circle938, _circle939, _circle940, _circle941, _circle942, _circle943, _circle944, _circle945, _circle946, _circle947, _circle948, _circle949, _circle950, _circle951, _circle952, _circle953, _circle954, _circle955, _circle956, _circle957, _circle958, _circle959, _circle960, _circle961, _circle962, _circle963, _circle964, _circle965, _circle966, _circle967, _circle968, _circle969, _circle970, _circle971, _circle972, _circle973, _circle974, _circle975, _circle976, _circle977, _circle978, _circle979, _circle980, _circle981, _circle982, _circle983, _circle984, _circle985, _circle986, _circle987, _circle988, _circle989, _circle990, _circle991, _circle992, _circle993, _circle994, _circle995, _circle996, _circle997, _circle998, _circle999, _circle1000, _circle1001, _circle1002, _circle1003, _circle1004, _circle1005, _circle1006, _circle1007, _circle1008, _circle1009, _circle1010, _circle1011, _circle1012, _circle1013, _circle1014, _circle1015, _circle1016, _circle1017, _circle1018, _circle1019, _circle1020, _circle1021, _circle1022, _circle1023, _circle1024, _circle1025, _circle1026, _circle1027, _circle1028, _circle1029, _circle1030, _circle1031, _circle1032, _circle1033, _circle1034, _circle1035, _circle1036, _circle1037, _circle1038, _circle1039, _circle1040, _circle1041, _circle1042, _circle1043, _circle1044, _circle1045, _circle1046, _circle1047, _circle1048, _circle1049, _circle1050, _circle1051, _circle1052, _circle1053, _circle1054, _circle1055, _circle1056, _circle1057, _circle1058, _circle1059, _circle1060, _circle1061, _circle1062, _circle1063, _circle1064, _circle1065, _circle1066, _circle1067, _circle1068, _circle1069, _circle1070, _circle1071, _circle1072, _circle1073, _circle1074, _circle1075, _circle1076, _circle1077, _circle1078, _circle1079, _circle1080, _circle1081, _circle1082, _circle1083, _circle1084, _circle1085, _circle1086, _circle1087, _circle1088, _circle1089, _circle1090, _circle1091, _circle1092, _circle1093, _circle1094, _circle1095, _circle1096, _circle1097, _circle1098, _circle1099, _circle1100, _circle1101, _circle1102, _circle1103, _circle1104, _circle1105, _circle1106, _circle1107, _circle1108, _circle1109, _circle1110, _circle1111, _circle1112, _circle1113, _circle1114, _circle1115, _circle1116, _circle1117, _circle1118, _circle1119, _circle1120, _circle1121, _circle1122, _circle1123, _circle1124, _circle1125, _circle1126, _circle1127, _circle1128, _circle1129, _circle1130, _circle1131, _circle1132, _circle1133, _circle1134, _circle1135, _circle1136, _circle1137, _circle1138, _circle1139, _circle1140, _circle1141, _circle1142, _circle1143, _circle1144, _circle1145, _circle1146, _circle1147, _circle1148, _circle1149, _circle1150, _circle1151, _circle1152, _circle1153, _circle1154, _circle1155, _circle1156, _circle1157, _circle1158, _circle1159, _circle1160, _circle1161, _circle1162, _circle1163, _circle1164, _circle1165, _circle1166, _circle1167, _circle1168, _circle1169, _circle1170, _circle1171, _circle1172, _circle1173, _circle1174, _circle1175, _circle1176, _circle1177, _circle1178, _circle1179, _circle1180, _circle1181, _circle1182, _circle1183, _circle1184, _circle1185, _circle1186, _circle1187, _circle1188, _circle1189, _circle1190, _circle1191, _circle1192, _circle1193, _circle1194, _circle1195, _circle1196, _circle1197, _circle1198, _circle1199, _circle1200, _circle1201, _circle1202, _circle1203, _circle1204, _circle1205, _circle1206, _circle1207, _circle1208, _circle1209, _circle1210, _circle1211, _circle1212, _circle1213, _circle1214, _circle1215, _circle1216, _circle1217, _circle1218, _circle1219, _circle1220, _circle1221, _circle1222, _circle1223, _circle1224, _circle1225, _circle1226, _circle1227, _circle1228, _circle1229, _circle1230, _circle1231, _circle1232, _circle1233, _circle1234, _circle1235, _circle1236, _circle1237, _circle1238, _circle1239, _circle1240, _circle1241, _circle1242, _circle1243, _circle1244, _circle1245, _circle1246, _circle1247, _circle1248, _circle1249, _circle1250, _circle1251, _circle1252, _circle1253, _circle1254, _circle1255, _circle1256, _circle1257, _circle1258, _circle1259, _circle1260, _circle1261, _circle1262, _circle1263, _circle1264, _circle1265, _circle1266, _circle1267, _circle1268, _circle1269, _circle1270, _circle1271, _circle1272, _circle1273, _circle1274, _circle1275, _circle1276, _circle1277, _circle1278, _circle1279, _circle1280, _circle1281, _circle1282, _circle1283, _circle1284, _circle1285, _circle1286, _circle1287, _circle1288, _circle1289, _circle1290, _circle1291, _circle1292, _circle1293, _circle1294, _circle1295, _circle1296, _circle1297, _circle1298, _circle1299, _circle1300, _circle1301, _circle1302, _circle1303, _circle1304, _circle1305, _circle1306, _circle1307, _circle1308, _circle1309, _circle1310, _circle1311, _circle1312, _circle1313, _circle1314, _circle1315, _circle1316, _circle1317, _circle1318, _circle1319, _circle1320, _circle1321, _circle1322, _circle1323, _circle1324, _circle1325, _circle1326, _circle1327, _circle1328, _circle1329, _circle1330, _circle1331, _circle1332, _circle1333, _circle1334, _circle1335, _circle1336, _circle1337, _circle1338, _circle1339, _circle1340, _circle1341, _circle1342, _circle1343, _circle1344, _circle1345, _circle1346, _circle1347, _circle1348, _circle1349, _circle1350, _circle1351, _circle1352, _circle1353, _circle1354, _circle1355, _circle1356, _circle1357, _circle1358, _circle1359, _circle1360, _circle1361, _circle1362, _circle1363, _circle1364, _circle1365, _circle1366, _circle1367, _circle1368, _circle1369, _circle1370, _circle1371, _circle1372, _circle1373, _circle1374, _circle1375, _circle1376, _circle1377, _circle1378, _circle1379, _circle1380, _circle1381, _circle1382, _circle1383, _circle1384, _circle1385, _circle1386, _circle1387, _circle1388, _circle1389, _circle1390, _circle1391, _circle1392, _circle1393, _circle1394, _circle1395, _circle1396, _circle1397, _circle1398, _circle1399, _circle1400, _circle1401, _circle1402, _circle1403, _circle1404, _circle1405, _circle1406, _circle1407, _circle1408, _circle1409, _circle1410, _circle1411, _circle1412, _circle1413, _circle1414, _circle1415, _circle1416, _circle1417, _circle1418, _circle1419, _circle1420, _circle1421, _circle1422, _circle1423, _circle1424, _circle1425, _circle1426, _circle1427, _circle1428, _circle1429, _circle1430, _circle1431, _circle1432, _circle1433, _circle1434, _circle1435, _circle1436, _circle1437, _circle1438, _circle1439, _circle1440, _circle1441, _circle1442, _circle1443, _circle1444, _circle1445, _circle1446, _circle1447, _circle1448, _circle1449, _circle1450, _circle1451, _circle1452, _circle1453, _circle1454, _circle1455, _circle1456, _circle1457, _circle1458, _circle1459, _circle1460, _circle1461, _circle1462, _circle1463, _circle1464, _circle1465, _circle1466, _circle1467, _circle1468, _circle1469, _circle1470, _circle1471, _circle1472, _circle1473, _circle1474, _circle1475, _circle1476, _circle1477, _circle1478, _circle1479, _circle1480, _circle1481, _circle1482, _circle1483, _circle1484, _circle1485, _circle1486, _circle1487, _circle1488, _circle1489, _circle1490, _circle1491, _circle1492, _circle1493, _circle1494, _circle1495, _circle1496, _circle1497, _circle1498, _circle1499, _circle1500, _circle1501, _circle1502, _circle1503, _circle1504, _circle1505, _circle1506, _circle1507, _circle1508, _circle1509, _circle1510, _circle1511, _circle1512, _circle1513, _circle1514, _circle1515, _circle1516, _circle1517, _circle1518, _circle1519, _circle1520, _circle1521, _circle1522, _circle1523, _circle1524, _circle1525, _circle1526, _circle1527, _circle1528, _circle1529, _circle1530, _circle1531, _circle1532, _circle1533, _circle1534, _circle1535, _circle1536, _circle1537, _circle1538, _circle1539, _circle1540, _circle1541, _circle1542, _circle1543, _circle1544, _circle1545, _circle1546, _circle1547, _circle1548, _circle1549, _circle1550, _circle1551, _circle1552, _circle1553, _circle1554, _circle1555, _circle1556, _circle1557, _circle1558, _circle1559, _circle1560, _circle1561, _circle1562, _circle1563, _circle1564, _circle1565, _circle1566, _circle1567, _circle1568, _circle1569, _circle1570, _circle1571, _circle1572, _circle1573, _circle1574, _circle1575, _circle1576, _circle1577, _circle1578, _circle1579, _circle1580, _circle1581, _circle1582, _circle1583, _circle1584, _circle1585, _circle1586, _circle1587, _circle1588, _circle1589, _circle1590, _circle1591, _circle1592, _circle1593, _circle1594, _circle1595, _circle1596, _circle1597, _circle1598, _circle1599, _circle1600, _circle1601, _circle1602, _circle1603, _circle1604, _circle1605, _circle1606, _circle1607, _circle1608, _circle1609, _circle1610, _circle1611, _circle1612, _circle1613, _circle1614, _circle1615, _circle1616, _circle1617, _circle1618, _circle1619, _circle1620, _circle1621, _circle1622, _circle1623, _circle1624, _circle1625, _circle1626, _circle1627, _circle1628, _circle1629, _circle1630, _circle1631, _circle1632, _circle1633, _circle1634, _circle1635, _circle1636, _circle1637, _circle1638, _circle1639, _circle1640, _circle1641, _circle1642, _circle1643, _circle1644, _circle1645, _circle1646, _circle1647, _circle1648, _circle1649, _circle1650, _circle1651, _circle1652, _circle1653, _circle1654, _circle1655, _circle1656, _circle1657, _circle1658, _circle1659, _circle1660, _circle1661, _circle1662, _circle1663, _circle1664, _circle1665, _circle1666, _circle1667, _circle1668, _circle1669, _circle1670, _circle1671, _circle1672, _circle1673, _circle1674, _circle1675, _circle1676, _circle1677, _circle1678, _circle1679, _circle1680, _circle1681, _circle1682, _circle1683, _circle1684, _circle1685, _circle1686, _circle1687, _circle1688, _circle1689, _circle1690, _circle1691, _circle1692, _circle1693, _circle1694, _circle1695, _circle1696, _circle1697, _circle1698, _circle1699, _circle1700, _circle1701, _circle1702, _circle1703, _circle1704, _circle1705, _circle1706, _circle1707, _circle1708, _circle1709, _circle1710, _circle1711, _circle1712, _circle1713, _circle1714, _circle1715, _circle1716, _circle1717, _circle1718, _circle1719, _circle1720, _circle1721, _circle1722, _circle1723, _circle1724, _circle1725, _circle1726, _circle1727, _circle1728, _circle1729, _circle1730, _circle1731, _circle1732, _circle1733, _circle1734, _circle1735, _circle1736, _circle1737, _circle1738, _circle1739, _circle1740, _circle1741, _circle1742, _circle1743, _circle1744, _circle1745, _circle1746, _circle1747, _circle1748, _circle1749, _circle1750, _circle1751, _circle1752, _circle1753, _circle1754, _circle1755, _circle1756, _circle1757, _circle1758, _circle1759, _circle1760, _circle1761, _circle1762, _circle1763, _circle1764, _circle1765, _circle1766, _circle1767, _circle1768, _circle1769, _circle1770, _circle1771, _circle1772, _circle1773, _circle1774, _circle1775, _circle1776, _circle1777, _circle1778, _circle1779, _circle1780, _circle1781, _circle1782, _circle1783, _circle1784, _circle1785, _circle1786, _circle1787, _circle1788, _circle1789, _circle1790, _circle1791, _circle1792, _circle1793, _circle1794, _circle1795, _circle1796, _circle1797, _circle1798, _circle1799, _circle1800, _circle1801, _circle1802, _circle1803, _circle1804, _circle1805, _circle1806, _circle1807, _circle1808, _circle1809, _circle1810, _circle1811, _circle1812, _circle1813, _circle1814, _circle1815, _circle1816, _circle1817, _circle1818, _circle1819, _circle1820, _circle1821, _circle1822, _circle1823, _circle1824, _circle1825, _circle1826, _circle1827, _circle1828, _circle1829, _circle1830, _circle1831, _circle1832, _circle1833, _circle1834, _circle1835, _circle1836, _circle1837, _circle1838, _circle1839, _circle1840, _circle1841, _circle1842, _circle1843, _circle1844, _circle1845, _circle1846, _circle1847, _circle1848, _circle1849, _circle1850, _circle1851, _circle1852, _circle1853, _circle1854, _circle1855, _circle1856, _circle1857, _circle1858, _circle1859, _circle1860, _circle1861, _circle1862, _circle1863, _circle1864, _circle1865, _circle1866, _circle1867, _circle1868, _circle1869, _circle1870, _circle1871, _circle1872, _circle1873, _circle1874, _circle1875, _circle1876, _circle1877, _circle1878, _circle1879, _circle1880, _circle1881, _circle1882, _circle1883, _circle1884, _circle1885, _circle1886, _circle1887, _circle1888, _circle1889, _circle1890, _circle1891, _circle1892, _circle1893, _circle1894, _circle1895, _circle1896, _circle1897, _circle1898, _circle1899, _circle1900, _circle1901, _circle1902, _circle1903, _circle1904, _circle1905, _circle1906, _circle1907, _circle1908, _circle1909, _circle1910, _circle1911, _circle1912, _circle1913, _circle1914, _circle1915, _circle1916, _circle1917, _circle1918, _circle1919, _circle1920, _circle1921, _circle1922, _circle1923, _circle1924, _circle1925, _circle1926, _circle1927, _circle1928, _circle1929, _circle1930, _circle1931, _circle1932, _circle1933, _circle1934, _circle1935, _circle1936, _circle1937, _circle1938, _circle1939, _circle1940, _circle1941, _circle1942, _circle1943, _circle1944, _circle1945, _circle1946, _circle1947, _circle1948, _circle1949, _circle1950, _circle1951, _circle1952, _circle1953, _circle1954, _circle1955, _circle1956, _circle1957, _circle1958, _circle1959, _circle1960, _circle1961, _circle1962, _circle1963, _circle1964, _circle1965, _circle1966, _circle1967, _circle1968, _circle1969, _circle1970, _circle1971, _circle1972, _circle1973, _circle1974, _circle1975, _circle1976, _circle1977, _circle1978, _circle1979, _circle1980, _circle1981, _circle1982, _circle1983, _circle1984, _circle1985, _circle1986, _circle1987, _circle1988, _circle1989, _circle1990, _circle1991, _circle1992, _circle1993, _circle1994, _circle1995, _circle1996, _circle1997, _circle1998, _circle1999, _circle2000, _circle2001, _circle2002, _circle2003, _circle2004, _circle2005, _circle2006, _circle2007, _circle2008, _circle2009, _circle2010, _circle2011, _circle2012, _circle2013, _circle2014, _circle2015, _circle2016, _circle2017, _circle2018, _circle2019, _circle2020, _circle2021, _circle2022, _circle2023, _circle2024, _circle2025, _circle2026, _circle2027, _circle2028, _circle2029, _circle2030, _circle2031, _circle2032, _circle2033, _circle2034, _circle2035, _circle2036, _circle2037, _circle2038, _circle2039, _circle2040, _circle2041, _circle2042, _circle2043, _circle2044, _circle2045, _circle2046, _circle2047, _circle2048, _circle2049, _circle2050, _circle2051, _circle2052, _circle2053, _circle2054, _circle2055, _circle2056, _circle2057, _circle2058, _circle2059, _circle2060, _circle2061, _circle2062, _circle2063, _circle2064, _circle2065, _circle2066, _circle2067, _circle2068, _circle2069, _circle2070, _circle2071, _circle2072, _circle2073, _circle2074, _circle2075, _circle2076, _circle2077, _circle2078, _circle2079, _circle2080, _circle2081, _circle2082, _circle2083, _circle2084, _circle2085, _circle2086, _circle2087, _circle2088, _circle2089, _circle2090, _circle2091, _circle2092, _circle2093, _circle2094, _circle2095, _circle2096, _circle2097, _circle2098, _circle2099, _circle2100, _circle2101, _circle2102, _circle2103, _circle2104, _circle2105, _circle2106, _circle2107, _circle2108, _circle2109, _circle2110, _circle2111, _circle2112, _circle2113, _circle2114, _circle2115, _circle2116, _circle2117, _circle2118, _circle2119, _circle2120, _circle2121, _circle2122, _circle2123, _circle2124, _circle2125, _circle2126, _circle2127, _circle2128, _circle2129, _circle2130, _circle2131, _circle2132, _circle2133, _circle2134, _circle2135, _circle2136, _circle2137, _circle2138, _circle2139, _circle2140, _circle2141, _circle2142, _circle2143, _circle2144, _circle2145, _circle2146, _circle2147, _circle2148, _circle2149, _circle2150, _circle2151, _circle2152, _circle2153, _circle2154, _circle2155, _circle2156, _circle2157, _circle2158, _circle2159, _circle2160, _circle2161, _circle2162, _circle2163, _circle2164, _circle2165, _circle2166, _circle2167, _circle2168, _circle2169, _circle2170, _circle2171, _circle2172, _circle2173, _circle2174, _circle2175, _circle2176, _circle2177, _circle2178, _circle2179, _circle2180, _circle2181, _circle2182, _circle2183, _circle2184, _circle2185, _circle2186, _circle2187, _circle2188, _circle2189, _circle2190, _circle2191, _circle2192, _circle2193, _circle2194, _circle2195, _circle2196, _circle2197, _circle2198, _circle2199, _circle2200, _circle2201, _circle2202, _circle2203, _circle2204, _circle2205, _circle2206, _circle2207, _circle2208, _circle2209, _circle2210, _circle2211, _circle2212, _circle2213, _circle2214, _circle2215, _circle2216, _circle2217, _circle2218, _circle2219, _circle2220, _circle2221, _circle2222, _circle2223, _circle2224, _circle2225, _circle2226, _circle2227, _circle2228, _circle2229, _circle2230, _circle2231, _circle2232, _circle2233, _circle2234, _circle2235, _circle2236, _circle2237, _circle2238, _circle2239, _circle2240, _circle2241, _circle2242, _circle2243, _circle2244, _circle2245, _circle2246, _circle2247, _circle2248, _circle2249, _circle2250, _circle2251, _circle2252, _circle2253, _circle2254, _circle2255, _circle2256, _circle2257, _circle2258, _circle2259, _circle2260, _circle2261, _circle2262, _circle2263, _circle2264, _circle2265, _circle2266, _circle2267, _circle2268, _circle2269, _circle2270, _circle2271, _circle2272, _circle2273, _circle2274, _circle2275, _circle2276, _circle2277, _circle2278, _circle2279, _circle2280, _circle2281, _circle2282, _circle2283, _circle2284, _circle2285, _circle2286, _circle2287, _circle2288, _circle2289, _circle2290, _circle2291, _circle2292, _circle2293, _circle2294, _circle2295, _circle2296, _circle2297, _circle2298, _circle2299, _circle2300, _circle2301, _circle2302, _circle2303, _circle2304, _circle2305, _circle2306, _circle2307, _circle2308, _circle2309, _circle2310, _circle2311, _circle2312, _circle2313, _circle2314, _circle2315, _circle2316, _circle2317, _circle2318, _circle2319, _circle2320, _circle2321, _circle2322, _circle2323, _circle2324, _circle2325, _circle2326, _circle2327, _circle2328, _circle2329, _circle2330, _circle2331, _circle2332, _circle2333, _circle2334, _circle2335, _circle2336, _circle2337, _circle2338, _circle2339, _circle2340, _circle2341, _circle2342, _circle2343, _circle2344, _circle2345, _circle2346, _circle2347, _circle2348, _circle2349, _circle2350, _circle2351, _circle2352, _circle2353, _circle2354, _circle2355, _circle2356, _circle2357, _circle2358, _circle2359, _circle2360, _circle2361, _circle2362, _circle2363, _circle2364, _circle2365, _circle2366, _circle2367, _circle2368, _circle2369, _circle2370, _circle2371, _circle2372, _circle2373, _circle2374, _circle2375, _circle2376, _circle2377, _circle2378, _circle2379, _circle2380, _circle2381, _circle2382, _circle2383, _circle2384, _circle2385, _circle2386, _circle2387, _circle2388, _circle2389, _circle2390, _circle2391, _circle2392, _circle2393, _circle2394, _circle2395, _circle2396, _circle2397, _circle2398, _circle2399, _circle2400, _circle2401, _circle2402, _circle2403, _circle2404, _circle2405, _circle2406, _circle2407, _circle2408, _circle2409, _circle2410, _circle2411, _circle2412, _circle2413, _circle2414, _circle2415, _circle2416, _circle2417, _circle2418, _circle2419, _circle2420, _circle2421, _circle2422, _circle2423, _circle2424, _circle2425, _circle2426, _circle2427, _circle2428, _circle2429, _circle2430, _circle2431, _circle2432, _circle2433, _circle2434, _circle2435, _circle2436, _circle2437, _circle2438, _circle2439, _circle2440, _circle2441, _circle2442, _circle2443, _circle2444, _circle2445, _circle2446, _circle2447, _circle2448, _circle2449, _circle2450, _circle2451, _circle2452, _circle2453, _circle2454, _circle2455, _circle2456, _circle2457, _circle2458, _circle2459, _circle2460, _circle2461, _circle2462, _circle2463, _circle2464, _circle2465, _circle2466, _circle2467, _circle2468, _circle2469, _circle2470, _circle2471, _circle2472, _circle2473, _circle2474, _circle2475, _circle2476, _circle2477, _circle2478, _circle2479, _circle2480, _circle2481, _circle2482, _circle2483, _circle2484, _circle2485, _circle2486, _circle2487, _circle2488, _circle2489, _circle2490, _circle2491, _circle2492, _circle2493, _circle2494, _circle2495, _circle2496, _circle2497, _circle2498, _circle2499, _circle2500, _circle2501, _circle2502, _circle2503, _circle2504, _circle2505, _circle2506, _circle2507, _circle2508, _circle2509, _circle2510, _circle2511, _circle2512, _circle2513, _circle2514, _circle2515, _circle2516, _circle2517, _circle2518, _circle2519, _circle2520, _circle2521, _circle2522, _circle2523, _circle2524, _circle2525, _circle2526, _circle2527, _circle2528, _circle2529, _circle2530, _circle2531, _circle2532, _circle2533, _circle2534, _circle2535, _circle2536, _circle2537, _circle2538, _circle2539, _circle2540, _circle2541, _circle2542, _circle2543, _circle2544, _circle2545, _circle2546, _circle2547, _circle2548, _circle2549, _circle2550, _circle2551, _circle2552, _circle2553, _circle2554, _circle2555, _circle2556, _circle2557, _circle2558, _circle2559, _circle2560, _circle2561, _circle2562, _circle2563, _circle2564, _circle2565, _circle2566, _circle2567, _circle2568, _circle2569, _circle2570, _circle2571, _circle2572, _circle2573, _circle2574, _circle2575, _circle2576, _circle2577, _circle2578, _circle2579, _circle2580, _circle2581, _circle2582, _circle2583, _circle2584, _circle2585, _circle2586, _circle2587, _circle2588, _circle2589, _circle2590, _circle2591, _circle2592, _circle2593, _circle2594, _circle2595, _circle2596, _circle2597, _circle2598, _circle2599, _circle2600, _circle2601, _circle2602, _circle2603, _circle2604, _circle2605, _circle2606, _circle2607, _circle2608, _circle2609, _circle2610, _circle2611, _circle2612, _circle2613, _circle2614, _circle2615, _circle2616, _circle2617, _circle2618, _circle2619, _circle2620, _circle2621, _circle2622, _circle2623, _circle2624, _circle2625, _circle2626, _circle2627, _circle2628, _circle2629, _circle2630, _circle2631, _circle2632, _circle2633, _circle2634, _circle2635, _circle2636, _circle2637, _circle2638, _circle2639, _circle2640, _circle2641, _circle2642, _circle2643, _circle2644, _circle2645, _circle2646, _circle2647, _circle2648, _circle2649, _circle2650, _circle2651, _circle2652, _circle2653, _circle2654, _circle2655, _circle2656, _circle2657, _circle2658, _circle2659, _circle2660, _circle2661, _circle2662, _circle2663, _circle2664, _circle2665, _circle2666, _circle2667, _circle2668, _circle2669, _circle2670, _circle2671, _circle2672, _circle2673, _circle2674, _circle2675, _circle2676, _circle2677, _circle2678, _circle2679, _circle2680, _circle2681, _circle2682, _circle2683, _circle2684, _circle2685, _circle2686, _circle2687, _circle2688, _circle2689, _circle2690, _circle2691, _circle2692, _circle2693, _circle2694, _circle2695, _circle2696, _circle2697, _circle2698, _circle2699, _circle2700, _circle2701, _circle2702, _circle2703, _circle2704, _circle2705, _circle2706, _circle2707, _circle2708, _circle2709, _circle2710, _circle2711, _circle2712, _circle2713, _circle2714, _circle2715, _circle2716, _circle2717, _circle2718, _circle2719, _circle2720, _circle2721, _circle2722, _circle2723, _circle2724, _circle2725, _circle2726, _circle2727, _circle2728, _circle2729, _circle2730, _circle2731, _circle2732, _circle2733, _circle2734, _circle2735, _circle2736, _circle2737, _circle2738, _circle2739, _circle2740, _circle2741, _circle2742, _circle2743, _circle2744, _circle2745, _circle2746, _circle2747, _circle2748, _circle2749, _circle2750, _circle2751, _circle2752, _circle2753, _circle2754, _circle2755, _circle2756, _circle2757, _circle2758, _circle2759, _circle2760, _circle2761, _circle2762, _circle2763, _circle2764, _circle2765, _circle2766, _circle2767, _circle2768, _circle2769, _circle2770, _circle2771, _circle2772, _circle2773, _circle2774, _circle2775, _circle2776, _circle2777, _circle2778, _circle2779, _circle2780, _circle2781, _circle2782, _circle2783, _circle2784, _circle2785, _circle2786, _circle2787, _circle2788, _circle2789, _circle2790, _circle2791, _circle2792, _circle2793, _circle2794, _circle2795, _circle2796, _circle2797, _circle2798, _circle2799, _circle2800, _circle2801, _circle2802, _circle2803, _circle2804, _circle2805, _circle2806, _circle2807, _circle2808, _circle2809, _circle2810, _circle2811, _circle2812, _circle2813, _circle2814, _circle2815, _circle2816, _circle2817, _circle2818, _circle2819, _circle2820, _circle2821, _circle2822, _circle2823, _circle2824, _circle2825, _circle2826, _circle2827, _circle2828, _circle2829, _circle2830, _circle2831, _circle2832, _circle2833, _circle2834, _circle2835, _circle2836, _circle2837, _circle2838, _circle2839, _circle2840, _circle2841, _circle2842, _circle2843, _circle2844, _circle2845, _circle2846, _circle2847, _circle2848, _circle2849, _circle2850, _circle2851, _circle2852, _circle2853, _circle2854, _circle2855, _circle2856, _circle2857, _circle2858, _circle2859, _circle2860, _circle2861, _circle2862, _circle2863, _circle2864, _circle2865, _circle2866, _circle2867, _circle2868, _circle2869, _circle2870, _circle2871, _circle2872, _circle2873, _circle2874, _circle2875, _circle2876, _circle2877, _circle2878, _circle2879, _circle2880, _circle2881, _circle2882, _circle2883, _circle2884, _circle2885, _circle2886, _circle2887, _circle2888, _circle2889, _circle2890, _circle2891, _circle2892, _circle2893, _circle2894, _circle2895, _circle2896, _circle2897, _circle2898, _circle2899, _circle2900, _circle2901, _circle2902, _circle2903, _circle2904, _circle2905, _circle2906, _circle2907, _circle2908, _circle2909, _circle2910, _circle2911, _circle2912, _circle2913, _circle2914, _circle2915, _circle2916, _circle2917, _circle2918, _circle2919, _circle2920, _circle2921, _circle2922, _circle2923, _circle2924, _circle2925, _circle2926, _circle2927, _circle2928, _circle2929, _circle2930, _circle2931, _circle2932, _circle2933, _circle2934, _circle2935, _circle2936, _circle2937, _circle2938, _circle2939, _circle2940, _circle2941, _circle2942, _circle2943, _circle2944, _circle2945, _circle2946, _circle2947, _circle2948, _circle2949, _circle2950, _circle2951, _circle2952, _circle2953, _circle2954, _circle2955, _circle2956, _circle2957, _circle2958, _circle2959, _circle2960, _circle2961, _circle2962, _circle2963, _circle2964, _circle2965, _circle2966, _circle2967, _circle2968, _circle2969, _circle2970, _circle2971, _circle2972, _circle2973, _circle2974, _circle2975, _circle2976, _circle2977, _circle2978, _circle2979, _circle2980, _circle2981, _circle2982, _circle2983, _circle2984, _circle2985, _circle2986, _circle2987, _circle2988, _circle2989, _circle2990, _circle2991, _circle2992, _circle2993, _circle2994, _circle2995, _circle2996, _circle2997, _circle2998, _circle2999, _circle3000, _circle3001, _circle3002, _circle3003, _circle3004, _circle3005, _circle3006, _circle3007, _circle3008, _circle3009, _circle3010, _circle3011, _circle3012, _circle3013, _circle3014, _circle3015, _circle3016, _circle3017, _circle3018, _circle3019, _circle3020, _circle3021, _circle3022, _circle3023, _circle3024, _circle3025, _circle3026, _circle3027, _circle3028, _circle3029, _circle3030, _circle3031, _circle3032, _circle3033, _circle3034, _circle3035, _circle3036, _circle3037, _circle3038, _circle3039, _circle3040, _circle3041, _circle3042, _circle3043, _circle3044, _circle3045, _circle3046, _circle3047, _circle3048, _circle3049, _circle3050, _circle3051, _circle3052, _circle3053, _circle3054, _circle3055, _circle3056, _circle3057, _circle3058, _circle3059, _circle3060, _circle3061, _circle3062, _circle3063, _circle3064, _circle3065, _circle3066, _circle3067, _circle3068, _circle3069, _circle3070, _circle3071, _circle3072, _circle3073, _circle3074, _circle3075, _circle3076, _circle3077, _circle3078, _circle3079, _circle3080, _circle3081, _circle3082, _circle3083, _circle3084, _circle3085, _circle3086, _circle3087, _circle3088, _circle3089, _circle3090, _circle3091, _circle3092, _circle3093, _circle3094, _circle3095, _circle3096, _circle3097, _circle3098, _circle3099, _circle3100, _circle3101, _circle3102, _circle3103, _circle3104, _circle3105, _circle3106, _circle3107, _circle3108, _circle3109, _circle3110, _circle3111, _circle3112, _circle3113, _circle3114, _circle3115, _circle3116, _circle3117, _circle3118, _circle3119, _circle3120, _circle3121, _circle3122, _circle3123, _circle3124, _circle3125, _circle3126, _circle3127, _circle3128, _circle3129, _circle3130, _circle3131, _circle3132, _circle3133, _circle3134, _circle3135, _circle3136, _circle3137, _circle3138, _circle3139, _circle3140, _circle3141, _circle3142, _circle3143, _circle3144, _circle3145, _circle3146, _circle3147, _circle3148, _circle3149, _circle3150, _circle3151, _circle3152, _circle3153, _circle3154, _circle3155, _circle3156, _circle3157, _circle3158, _circle3159, _circle3160, _circle3161, _circle3162, _circle3163, _circle3164, _circle3165, _circle3166, _circle3167, _circle3168, _circle3169, _circle3170, _circle3171, _circle3172, _circle3173, _circle3174, _circle3175, _circle3176, _circle3177, _circle3178, _circle3179, _circle3180, _circle3181, _circle3182, _circle3183, _circle3184, _circle3185, _circle3186, _circle3187, _circle3188, _circle3189, _circle3190, _circle3191, _circle3192, _circle3193, _circle3194, _circle3195, _circle3196, _circle3197, _circle3198, _circle3199, _circle3200, _circle3201, _circle3202, _circle3203, _circle3204, _circle3205, _circle3206, _circle3207, _circle3208, _circle3209, _circle3210, _circle3211, _circle3212, _circle3213, _circle3214, _circle3215, _circle3216, _circle3217, _circle3218, _circle3219, _circle3220, _circle3221, _circle3222, _circle3223, _circle3224, _circle3225, _circle3226, _circle3227, _circle3228, _circle3229, _circle3230, _circle3231, _circle3232, _circle3233, _circle3234, _circle3235, _circle3236, _circle3237, _circle3238, _circle3239, _circle3240, _circle3241, _circle3242, _circle3243, _circle3244, _circle3245, _circle3246, _circle3247, _circle3248, _circle3249, _circle3250, _circle3251, _circle3252, _circle3253, _circle3254, _circle3255, _circle3256, _circle3257, _circle3258, _circle3259, _circle3260, _circle3261, _circle3262, _circle3263, _circle3264, _circle3265, _circle3266, _circle3267, _circle3268, _circle3269, _circle3270, _circle3271, _circle3272, _circle3273, _circle3274, _circle3275, _circle3276, _circle3277, _circle3278, _circle3279, _circle3280, _circle3281, _circle3282, _circle3283, _circle3284, _circle3285, _circle3286, _circle3287, _circle3288, _circle3289, _circle3290, _circle3291, _circle3292, _circle3293, _circle3294, _circle3295, _circle3296, _circle3297, _circle3298, _circle3299, _circle3300, _circle3301, _circle3302, _circle3303, _circle3304, _circle3305, _circle3306, _circle3307, _circle3308, _circle3309, _circle3310, _circle3311, _circle3312, _circle3313, _circle3314, _circle3315, _circle3316, _circle3317, _circle3318, _circle3319, _circle3320, _circle3321, _circle3322, _circle3323, _circle3324, _circle3325, _circle3326, _circle3327, _circle3328, _circle3329, _circle3330, _circle3331, _circle3332, _circle3333, _circle3334, _circle3335, _circle3336, _circle3337, _circle3338, _circle3339, _circle3340, _circle3341, _circle3342, _circle3343, _circle3344, _circle3345, _circle3346, _circle3347, _circle3348, _circle3349, _circle3350, _circle3351, _circle3352, _circle3353, _circle3354, _circle3355, _circle3356, _circle3357, _circle3358, _circle3359, _circle3360, _circle3361, _circle3362, _circle3363, _circle3364, _circle3365, _circle3366, _circle3367, _circle3368, _circle3369, _circle3370, _circle3371, _circle3372, _circle3373, _circle3374, _circle3375, _circle3376, _circle3377, _circle3378, _circle3379, _circle3380, _circle3381, _circle3382, _circle3383, _circle3384, _circle3385, _circle3386, _circle3387, _circle3388, _circle3389, _circle3390, _circle3391, _circle3392, _circle3393, _circle3394, _circle3395, _circle3396, _circle3397, _circle3398, _circle3399, _circle3400, _circle3401, _circle3402, _circle3403, _circle3404, _circle3405, _circle3406, _circle3407, _circle3408, _circle3409, _circle3410, _circle3411, _circle3412, _circle3413, _circle3414, _circle3415, _circle3416, _circle3417, _circle3418, _circle3419, _circle3420, _circle3421, _circle3422, _circle3423, _circle3424, _circle3425, _circle3426, _circle3427, _circle3428, _circle3429, _circle3430, _circle3431, _circle3432, _circle3433, _circle3434, _circle3435, _circle3436, _circle3437, _circle3438, _circle3439, _circle3440, _circle3441, _circle3442, _circle3443, _circle3444, _circle3445, _circle3446, _circle3447, _circle3448, _circle3449, _circle3450, _circle3451, _circle3452, _circle3453, _circle3454, _circle3455, _circle3456, _circle3457, _circle3458, _circle3459, _circle3460, _circle3461, _circle3462, _circle3463, _circle3464, _circle3465, _circle3466, _circle3467, _circle3468, _circle3469, _circle3470, _circle3471, _circle3472, _circle3473, _circle3474, _circle3475, _circle3476, _circle3477, _circle3478, _circle3479, _circle3480, _circle3481, _circle3482, _circle3483, _circle3484, _circle3485, _circle3486, _circle3487, _circle3488, _circle3489, _circle3490, _circle3491, _circle3492, _circle3493, _circle3494, _circle3495, _circle3496, _circle3497, _circle3498, _circle3499, _circle3500, _circle3501, _circle3502, _circle3503, _circle3504, _circle3505, _circle3506, _circle3507, _circle3508, _circle3509, _circle3510, _circle3511, _circle3512, _circle3513, _circle3514, _circle3515, _circle3516, _circle3517, _circle3518, _circle3519, _circle3520, _circle3521, _circle3522, _circle3523, _circle3524, _circle3525, _circle3526, _circle3527, _circle3528, _circle3529, _circle3530, _circle3531, _circle3532, _circle3533, _circle3534, _circle3535, _circle3536, _circle3537, _circle3538, _circle3539, _circle3540, _circle3541, _circle3542, _circle3543, _circle3544, _circle3545, _circle3546, _circle3547, _circle3548, _circle3549, _circle3550, _circle3551, _circle3552, _circle3553, _circle3554, _circle3555, _circle3556, _circle3557, _circle3558, _circle3559, _circle3560, _circle3561, _circle3562, _circle3563, _circle3564, _circle3565, _circle3566, _circle3567, _circle3568, _circle3569, _circle3570, _circle3571, _circle3572, _circle3573, _circle3574, _circle3575, _circle3576, _circle3577, _circle3578, _circle3579, _circle3580, _circle3581, _circle3582, _circle3583, _circle3584, _circle3585, _circle3586, _circle3587, _circle3588, _circle3589, _circle3590, _circle3591, _circle3592, _circle3593, _circle3594, _circle3595, _circle3596, _circle3597, _circle3598, _circle3599, _circle3600, _circle3601, _circle3602, _circle3603, _circle3604, _circle3605, _circle3606, _circle3607, _circle3608, _circle3609, _circle3610, _circle3611, _circle3612, _circle3613, _circle3614, _circle3615, _circle3616, _circle3617, _circle3618, _circle3619, _circle3620, _circle3621, _circle3622, _circle3623, _circle3624, _circle3625, _circle3626, _circle3627, _circle3628, _circle3629, _circle3630, _circle3631, _circle3632, _circle3633, _circle3634, _circle3635, _circle3636, _circle3637, _circle3638, _circle3639, _circle3640, _circle3641, _circle3642, _circle3643, _circle3644, _circle3645, _circle3646, _circle3647, _circle3648, _circle3649, _circle3650, _circle3651, _circle3652, _circle3653, _circle3654, _circle3655, _circle3656, _circle3657, _circle3658, _circle3659, _circle3660, _circle3661, _circle3662, _circle3663, _circle3664, _circle3665, _circle3666, _circle3667, _circle3668, _circle3669, _circle3670, _circle3671, _circle3672, _circle3673, _circle3674, _circle3675, _circle3676, _circle3677, _circle3678, _circle3679, _circle3680, _circle3681, _circle3682, _circle3683, _circle3684, _circle3685, _circle3686, _circle3687, _circle3688, _circle3689, _circle3690, _circle3691, _circle3692, _circle3693, _circle3694, _circle3695, _circle3696, _circle3697, _circle3698, _circle3699, _circle3700, _circle3701, _circle3702, _circle3703, _circle3704, _circle3705, _circle3706, _circle3707, _circle3708, _circle3709, _circle3710, _circle3711, _circle3712, _circle3713, _circle3714, _circle3715, _circle3716, _circle3717, _circle3718, _circle3719, _circle3720, _circle3721, _circle3722, _circle3723, _circle3724, _circle3725, _circle3726, _circle3727, _circle3728, _circle3729, _circle3730, _circle3731, _circle3732, _circle3733, _circle3734, _circle3735, _circle3736, _circle3737, _circle3738, _circle3739, _circle3740, _circle3741, _circle3742, _circle3743, _circle3744, _circle3745, _circle3746, _circle3747, _circle3748, _circle3749, _circle3750, _circle3751, _circle3752, _circle3753, _circle3754, _circle3755, _circle3756, _circle3757, _circle3758, _circle3759, _circle3760, _circle3761, _circle3762, _circle3763, _circle3764, _circle3765, _circle3766, _circle3767, _circle3768, _circle3769, _circle3770, _circle3771, _circle3772, _circle3773, _circle3774, _circle3775, _circle3776, _circle3777, _circle3778, _circle3779, _circle3780, _circle3781, _circle3782, _circle3783, _circle3784, _circle3785, _circle3786, _circle3787, _circle3788, _circle3789, _circle3790, _circle3791, _circle3792, _circle3793, _circle3794, _circle3795, _circle3796, _circle3797, _circle3798, _circle3799, _circle3800, _circle3801, _circle3802, _circle3803, _circle3804, _circle3805, _circle3806, _circle3807, _circle3808, _circle3809, _circle3810, _circle3811, _circle3812, _circle3813, _circle3814, _circle3815, _circle3816, _circle3817, _circle3818, _circle3819, _circle3820, _circle3821, _circle3822, _circle3823, _circle3824, _circle3825, _circle3826, _circle3827, _circle3828, _circle3829, _circle3830, _circle3831, _circle3832, _circle3833, _circle3834, _circle3835, _circle3836, _circle3837, _circle3838, _circle3839, _circle3840, _circle3841, _circle3842, _circle3843, _circle3844, _circle3845, _circle3846, _circle3847, _circle3848, _circle3849, _circle3850, _circle3851, _circle3852, _circle3853, _circle3854, _circle3855, _circle3856, _circle3857, _circle3858, _circle3859, _circle3860, _circle3861, _circle3862, _circle3863, _circle3864, _circle3865, _circle3866, _circle3867, _circle3868, _circle3869, _circle3870, _circle3871, _circle3872, _circle3873, _circle3874, _circle3875, _circle3876, _circle3877, _circle3878, _circle3879, _circle3880, _circle3881, _circle3882, _circle3883, _circle3884, _circle3885, _circle3886, _circle3887, _circle3888, _circle3889, _circle3890, _circle3891, _circle3892, _circle3893, _circle3894, _circle3895, _circle3896, _circle3897, _circle3898, _circle3899, _circle3900, _circle3901, _circle3902, _circle3903, _circle3904, _circle3905, _circle3906, _circle3907, _circle3908, _circle3909, _circle3910, _circle3911, _circle3912, _circle3913, _circle3914, _circle3915, _circle3916, _circle3917, _circle3918, _circle3919, _circle3920, _circle3921, _circle3922, _circle3923, _circle3924, _circle3925, _circle3926, _circle3927, _circle3928, _circle3929, _circle3930, _circle3931, _circle3932, _circle3933, _circle3934, _circle3935, _circle3936, _circle3937, _circle3938, _circle3939, _circle3940, _circle3941, _circle3942, _circle3943, _circle3944, _circle3945, _circle3946, _circle3947, _circle3948, _circle3949, _circle3950, _circle3951, _circle3952, _circle3953, _circle3954, _circle3955, _circle3956, _circle3957, _circle3958, _circle3959, _circle3960, _circle3961, _circle3962, _circle3963, _circle3964, _circle3965, _circle3966, _circle3967, _circle3968, _circle3969, _circle3970, _circle3971, _circle3972, _circle3973, _circle3974, _circle3975, _circle3976, _circle3977, _circle3978, _circle3979, _circle3980, _circle3981, _circle3982, _circle3983, _circle3984, _circle3985, _circle3986, _circle3987, _circle3988, _circle3989, _circle3990, _circle3991, _circle3992, _circle3993, _circle3994, _circle3995, _circle3996, _circle3997, _circle3998, _circle3999, _circle4000, _circle4001, _circle4002, _circle4003, _circle4004, _circle4005, _circle4006, _circle4007, _circle4008, _circle4009, _circle4010, _circle4011, _circle4012, _circle4013, _circle4014, _circle4015, _circle4016, _circle4017, _circle4018, _circle4019, _circle4020, _circle4021, _circle4022, _circle4023, _circle4024, _circle4025, _circle4026, _circle4027, _circle4028, _circle4029, _circle4030, _circle4031, _circle4032, _circle4033, _circle4034, _circle4035, _circle4036, _circle4037, _circle4038, _circle4039, _circle4040, _circle4041, _circle4042, _circle4043, _circle4044, _circle4045, _circle4046, _circle4047, _circle4048, _circle4049, _circle4050, _circle4051, _circle4052, _circle4053, _circle4054, _circle4055, _circle4056, _circle4057, _circle4058, _circle4059, _circle4060, _circle4061, _circle4062, _circle4063, _circle4064, _circle4065, _circle4066, _circle4067, _circle4068, _circle4069, _circle4070, _circle4071, _circle4072, _circle4073, _circle4074, _circle4075, _circle4076, _circle4077, _circle4078, _circle4079, _circle4080, _circle4081, _circle4082, _circle4083, _circle4084, _circle4085, _circle4086, _circle4087, _circle4088, _circle4089, _circle4090, _circle4091, _circle4092, _circle4093, _circle4094, _circle4095, _circle4096, _circle4097, _circle4098, _circle4099, _circle4100, _circle4101, _circle4102, _circle4103, _circle4104, _circle4105, _circle4106, _circle4107, _circle4108, _circle4109, _circle4110, _circle4111, _circle4112, _circle4113, _circle4114, _circle4115, _circle4116, _circle4117, _circle4118, _circle4119, _circle4120, _circle4121, _circle4122, _circle4123, _circle4124, _circle4125, _circle4126, _circle4127, _circle4128, _circle4129, _circle4130, _circle4131, _circle4132, _circle4133, _circle4134, _circle4135, _circle4136, _circle4137, _circle4138, _circle4139, _circle4140, _circle4141, _circle4142, _circle4143, _circle4144, _circle4145, _circle4146, _circle4147, _circle4148, _circle4149, _circle4150, _circle4151, _circle4152, _circle4153, _circle4154, _circle4155, _circle4156, _circle4157, _circle4158, _circle4159, _circle4160, _circle4161, _circle4162, _circle4163, _circle4164, _circle4165, _circle4166, _circle4167, _circle4168, _circle4169, _circle4170, _circle4171, _circle4172, _circle4173, _circle4174, _circle4175, _circle4176, _circle4177, _circle4178, _circle4179, _circle4180, _circle4181, _circle4182, _circle4183, _circle4184, _circle4185, _circle4186, _circle4187, _circle4188, _circle4189, _circle4190, _circle4191, _circle4192, _circle4193, _circle4194, _circle4195, _circle4196, _circle4197, _circle4198, _circle4199, _circle4200, _circle4201, _circle4202, _circle4203, _circle4204, _circle4205, _circle4206, _circle4207, _circle4208, _circle4209, _circle4210, _circle4211, _circle4212, _circle4213, _circle4214, _circle4215, _circle4216, _circle4217, _circle4218, _circle4219, _circle4220, _circle4221, _circle4222, _circle4223, _circle4224, _circle4225, _circle4226, _circle4227, _circle4228, _circle4229, _circle4230, _circle4231, _circle4232, _circle4233, _circle4234, _circle4235, _circle4236, _circle4237, _circle4238, _circle4239, _circle4240, _circle4241, _circle4242, _circle4243, _circle4244, _circle4245, _circle4246, _circle4247, _circle4248, _circle4249, _circle4250, _circle4251, _circle4252, _circle4253, _circle4254, _circle4255, _circle4256, _circle4257, _circle4258, _circle4259, _circle4260, _circle4261, _circle4262, _circle4263, _circle4264, _circle4265, _circle4266, _circle4267, _circle4268, _circle4269, _circle4270, _circle4271, _circle4272, _circle4273, _circle4274, _circle4275, _circle4276, _circle4277, _circle4278, _circle4279, _circle4280, _circle4281, _circle4282, _circle4283, _circle4284, _circle4285, _circle4286, _circle4287, _circle4288, _circle4289, _circle4290, _circle4291, _circle4292, _circle4293, _circle4294, _circle4295, _circle4296, _circle4297, _circle4298, _circle4299, _circle4300, _circle4301, _circle4302, _circle4303, _circle4304, _circle4305, _circle4306, _circle4307, _circle4308, _circle4309, _circle4310, _circle4311, _circle4312, _circle4313, _circle4314, _circle4315, _circle4316, _circle4317, _circle4318, _circle4319, _circle4320, _circle4321, _circle4322, _circle4323, _circle4324, _circle4325, _circle4326, _circle4327, _circle4328, _circle4329, _circle4330, _circle4331, _circle4332, _circle4333, _circle4334, _circle4335, _circle4336, _circle4337, _circle4338, _circle4339, _circle4340, _circle4341, _circle4342, _circle4343, _circle4344, _circle4345, _circle4346, _circle4347, _circle4348, _circle4349, _circle4350, _circle4351, _circle4352, _circle4353, _circle4354, _circle4355, _circle4356, _circle4357, _circle4358, _circle4359, _circle4360, _circle4361, _circle4362, _circle4363, _circle4364, _circle4365, _circle4366, _circle4367, _circle4368, _circle4369, _circle4370, _circle4371, _circle4372, _circle4373, _circle4374, _circle4375, _circle4376, _circle4377, _circle4378, _circle4379, _circle4380, _circle4381, _circle4382, _circle4383, _circle4384, _circle4385, _circle4386, _circle4387, _circle4388, _circle4389, _circle4390, _circle4391, _circle4392, _circle4393, _circle4394, _circle4395, _circle4396, _circle4397, _circle4398, _circle4399, _circle4400, _circle4401, _circle4402, _circle4403, _circle4404, _circle4405, _circle4406, _circle4407, _circle4408, _circle4409, _circle4410, _circle4411, _circle4412, _circle4413, _circle4414, _circle4415, _circle4416, _circle4417, _circle4418, _circle4419, _circle4420, _circle4421, _circle4422, _circle4423, _circle4424, _circle4425, _circle4426, _circle4427, _circle4428, _circle4429, _circle4430, _circle4431, _circle4432, _circle4433, _circle4434, _circle4435, _circle4436, _circle4437, _circle4438, _circle4439, _circle4440, _circle4441, _circle4442, _circle4443, _circle4444, _circle4445, _circle4446, _circle4447, _circle4448, _circle4449, _circle4450, _circle4451, _circle4452, _circle4453, _circle4454, _circle4455, _circle4456, _circle4457, _circle4458, _circle4459, _circle4460, _circle4461, _circle4462, _circle4463, _circle4464, _circle4465, _circle4466, _circle4467, _circle4468, _circle4469, _circle4470, _circle4471, _circle4472, _circle4473, _circle4474, _circle4475, _circle4476, _circle4477, _circle4478, _circle4479, _circle4480, _circle4481, _circle4482, _circle4483, _circle4484, _circle4485, _circle4486, _circle4487, _circle4488, _circle4489, _circle4490, _circle4491, _circle4492, _circle4493, _circle4494, _circle4495, _circle4496, _circle4497, _circle4498, _circle4499, _circle4500, _circle4501, _circle4502, _circle4503, _circle4504, _circle4505, _circle4506, _circle4507, _circle4508, _circle4509, _circle4510, _circle4511, _circle4512, _circle4513, _circle4514, _circle4515, _circle4516, _circle4517, _circle4518, _circle4519, _circle4520, _circle4521, _circle4522, _circle4523, _circle4524, _circle4525, _circle4526, _circle4527, _circle4528, _circle4529, _circle4530, _circle4531, _circle4532, _circle4533, _circle4534, _circle4535, _circle4536, _circle4537, _circle4538, _circle4539, _circle4540, _circle4541, _circle4542, _circle4543, _circle4544, _circle4545, _circle4546, _circle4547, _circle4548, _circle4549, _circle4550, _circle4551, _circle4552, _circle4553, _circle4554, _circle4555, _circle4556, _circle4557, _circle4558, _circle4559, _circle4560, _circle4561, _circle4562, _circle4563, _circle4564, _circle4565, _circle4566, _circle4567, _circle4568, _circle4569, _circle4570, _circle4571, _circle4572, _circle4573, _circle4574, _circle4575, _circle4576, _circle4577, _circle4578, _circle4579, _circle4580, _circle4581, _circle4582, _circle4583, _circle4584, _circle4585, _circle4586, _circle4587, _circle4588, _circle4589, _circle4590, _circle4591, _circle4592, _circle4593, _circle4594, _circle4595, _circle4596, _circle4597, _circle4598, _circle4599, _circle4600, _circle4601, _circle4602, _circle4603, _circle4604, _circle4605, _circle4606, _circle4607, _circle4608, _circle4609, _circle4610, _circle4611, _circle4612, _circle4613, _circle4614, _circle4615, _circle4616, _circle4617, _circle4618, _circle4619, _circle4620, _circle4621, _circle4622, _circle4623, _circle4624, _circle4625, _circle4626, _circle4627, _circle4628, _circle4629, _circle4630, _circle4631, _circle4632, _circle4633, _circle4634, _circle4635, _circle4636, _circle4637, _circle4638, _circle4639, _circle4640, _circle4641, _circle4642, _circle4643, _circle4644, _circle4645, _circle4646, _circle4647, _circle4648, _circle4649, _circle4650, _circle4651, _circle4652, _circle4653, _circle4654, _circle4655, _circle4656, _circle4657, _circle4658, _circle4659, _circle4660, _circle4661, _circle4662, _circle4663, _circle4664, _circle4665, _circle4666, _circle4667, _circle4668, _circle4669, _circle4670, _circle4671, _circle4672, _circle4673, _circle4674, _circle4675, _circle4676, _circle4677, _circle4678, _circle4679, _circle4680, _circle4681, _circle4682, _circle4683, _circle4684, _circle4685, _circle4686, _circle4687, _circle4688, _circle4689, _circle4690, _circle4691, _circle4692, _circle4693, _circle4694, _circle4695, _circle4696, _circle4697, _circle4698, _circle4699, _circle4700, _circle4701, _circle4702, _circle4703, _circle4704, _circle4705, _circle4706, _circle4707, _circle4708, _circle4709, _circle4710, _circle4711, _circle4712, _circle4713, _circle4714, _circle4715, _circle4716, _circle4717, _circle4718, _circle4719, _circle4720, _circle4721, _circle4722, _circle4723, _circle4724, _circle4725, _circle4726, _circle4727, _circle4728, _circle4729, _circle4730, _circle4731, _circle4732, _circle4733, _circle4734, _circle4735;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundwave = function SvgSoundwave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "soundwave_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1050 150"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".soundwave_svg__st0{fill:#ffd100}.soundwave_svg__st1{fill:#f5cf0b}.soundwave_svg__st2{fill:#ebcd16}.soundwave_svg__st3{fill:#e0cc20}.soundwave_svg__st4{fill:#d6ca2b}.soundwave_svg__st5{fill:#ccc836}.soundwave_svg__st6{fill:#c2c641}.soundwave_svg__st7{fill:#b8c44b}.soundwave_svg__st8{fill:#adc356}.soundwave_svg__st9{fill:#a3c161}.soundwave_svg__st10{fill:#99bf6c}.soundwave_svg__st11{fill:#8fbd76}.soundwave_svg__st12{fill:#85bb81}.soundwave_svg__st13{fill:#7bb98c}.soundwave_svg__st14{fill:#70b897}.soundwave_svg__st15{fill:#66b6a1}.soundwave_svg__st16{fill:#5cb4ac}.soundwave_svg__st17{fill:#52b2b7}.soundwave_svg__st18{fill:#48b0c2}.soundwave_svg__st19{fill:#3dafcc}.soundwave_svg__st20{fill:#33add7}.soundwave_svg__st21{fill:#29abe2}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1174.5,
    cy: -133.5,
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1043.3,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1038.5,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1033.6,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1028.8,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.2,
    cy: 80.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.4,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009.7,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000.3,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.6,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.9,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 986.2,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 981.5,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 976.6,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.8,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 967,
    cy: 63.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 962.1,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 957.3,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 952.5,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 947.6,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 942.6,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 937.6,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 932.6,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 927.6,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.7,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.7,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 912.9,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 908.1,
    cy: 61.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 903.4,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.6,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 893.9,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.3,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 884.7,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.2,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.6,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.1,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.4,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 861.6,
    cy: 79.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 856.8,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 852,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.3,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.5,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.7,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.9,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.1,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.3,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.5,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.7,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.8,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.8,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.8,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.8,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.8,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.9,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.9,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.9,
    cy: 95.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.9,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.9,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 759,
    cy: 96.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.1,
    cy: 95.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.2,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.3,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.4,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.5,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.6,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 719.7,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.8,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.9,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.1,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.4,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.7,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.3,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.7,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.3,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.6,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.9,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.1,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.4,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.7,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 639,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 63.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.1,
    cy: 62.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.1,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 619.2,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 614.2,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 609.3,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 604.3,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.4,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.4,
    cy: 58.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.5,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.5,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.6,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.6,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 569.6,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.6,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.7,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.7,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.7,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.8,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.8,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.9,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 525.2,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 520.3,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.4,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.5,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.6,
    cy: 69.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.7,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.8,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.9,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.1,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.2,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 476.4,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.5,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 466.7,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.8,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 457,
    cy: 80.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.1,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.3,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.4,
    cy: 83.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.5,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.6,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.7,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.8,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.9,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 413,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.1,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.2,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.3,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.4,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.4,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.4,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.5,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.5,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5,
    cy: 94.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.5,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.6,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.6,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.6,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.7,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.7,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.8,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.8,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.9,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.1,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.2,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.4,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.6,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.7,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.9,
    cy: 83.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.1,
    cy: 82,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.2,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.4,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.6,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.8,
    cy: 76.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.2,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.4,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.6,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.8,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.2,
    cy: 67.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.3,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.6,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.7,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.9,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.1,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.3,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.4,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 56.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.6,
    cy: 55.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.6,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.6,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.7,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.7,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.8,
    cy: 52.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.8,
    cy: 52,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.9,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.9,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.9,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.9,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.9,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.9,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.9,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.2,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.2,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.3,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.4,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.6,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3,
    cy: 62.9,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.1,
    cy: 66.6,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2,
    cy: 72.3,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st0"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 1046.5,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 1041.7,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 1036.8,
    cy: 85.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 1032,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 1027.1,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 1022.3,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 1017.4,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 1012.6,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 1007.8,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 1003.1,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 998.3,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 993.6,
    cy: 73.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 988.8,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 984.1,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.3,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.5,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.6,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 964.8,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 955.1,
    cy: 62.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.3,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.4,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 940.4,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 935.4,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 930.4,
    cy: 60.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 925.4,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.4,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 915.5,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.6,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.8,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.9,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 896.1,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 891.3,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.5,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 881.9,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 877.2,
    cy: 71.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.5,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 867.9,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.2,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.4,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 853.6,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 848.7,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 843.9,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 839.1,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 834.3,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.5,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 824.7,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.9,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.1,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 810.3,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 805.4,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.4,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.4,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 790.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.5,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.5,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 775.5,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.5,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 765.6,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.6,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.6,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.6,
    cy: 95.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.7,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.8,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.9,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.9,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 726,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.1,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.2,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.2,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 706.3,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.4,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 696.5,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 691.6,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.9,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.2,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 677.5,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.8,
    cy: 79.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 668.1,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 663.4,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.7,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 654,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.3,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.6,
    cy: 69.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.9,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.2,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.5,
    cy: 64.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.7,
    cy: 62.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.7,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.8,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.8,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    cx: 605.9,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    cx: 601,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    cx: 596,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    cx: 591.1,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.1,
    cy: 57.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    cx: 581.2,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.2,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.2,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.3,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.3,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.3,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.4,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.4,
    cy: 59.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.4,
    cy: 59.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.4,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.5,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.6,
    cy: 61.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.7,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.8,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    cx: 507,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.1,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.2,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.3,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.4,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.6,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.7,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.8,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.1,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.3,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.4,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.6,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.7,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.9,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.1,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.2,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    cx: 419.3,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.4,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.6,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.7,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.8,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.9,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.1,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.1,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.1,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.1,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.1,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.2,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.2,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.2,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.2,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.2,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.3,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.3,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.4,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.4,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.5,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.5,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.6,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.7,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.8,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.9,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.1,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.2,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.3,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.5,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.6,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.7,
    cy: 80.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.9,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.1,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.3,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.4,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.6,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.8,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.1,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.3,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.4,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.6,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.7,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.9,
    cy: 63.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 62.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.1,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.2,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.3,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.4,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.6,
    cy: 57.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.6,
    cy: 56.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.6,
    cy: 56.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.7,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.7,
    cy: 55.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.7,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.7,
    cy: 54.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.8,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.8,
    cy: 55,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.9,
    cy: 55.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.9,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.9,
    cy: 56.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 57.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.1,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.8,
    cy: 62.8,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7,
    cy: 67.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 71,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.8,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.1,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st1"
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.2,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.3,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.4,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.5,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.6,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.7,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.8,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.2,
    cy: 78.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000.4,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.7,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.9,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    cx: 986.1,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    cx: 981.3,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    cx: 976.5,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.6,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    cx: 966.8,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.9,
    cy: 66.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    cx: 957.1,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    cx: 952.2,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    cx: 947.4,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    cx: 942.5,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    cx: 937.5,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    cx: 932.5,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    cx: 927.5,
    cy: 62,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.5,
    cy: 61.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.6,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    cx: 912.6,
    cy: 61.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.7,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    cx: 902.8,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    cx: 897.9,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    cx: 893,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.1,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.3,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.5,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.8,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 71.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    cx: 864.2,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    cx: 859.5,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    cx: 854.7,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    cx: 849.9,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.1,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.3,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.5,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    cx: 830.7,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    cx: 825.9,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    cx: 821.1,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    cx: 816.2,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    cx: 811.3,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.4,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.4,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.5,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    cx: 791.6,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.7,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    cx: 781.7,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.8,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.9,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.9,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.9,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.9,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.9,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    cx: 746.9,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.9,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle493 || (_circle493 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.9,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle494 || (_circle494 = /*#__PURE__*/React.createElement("circle", {
    cx: 732,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle495 || (_circle495 = /*#__PURE__*/React.createElement("circle", {
    cx: 727,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle496 || (_circle496 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.1,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle497 || (_circle497 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.2,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle498 || (_circle498 = /*#__PURE__*/React.createElement("circle", {
    cx: 712.2,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle499 || (_circle499 = /*#__PURE__*/React.createElement("circle", {
    cx: 707.3,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle500 || (_circle500 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.4,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle501 || (_circle501 = /*#__PURE__*/React.createElement("circle", {
    cx: 697.5,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle502 || (_circle502 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.5,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle503 || (_circle503 = /*#__PURE__*/React.createElement("circle", {
    cx: 687.6,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle504 || (_circle504 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.8,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle505 || (_circle505 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.1,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle506 || (_circle506 = /*#__PURE__*/React.createElement("circle", {
    cx: 673.4,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle507 || (_circle507 = /*#__PURE__*/React.createElement("circle", {
    cx: 668.7,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle508 || (_circle508 = /*#__PURE__*/React.createElement("circle", {
    cx: 664,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle509 || (_circle509 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.3,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle510 || (_circle510 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.6,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle511 || (_circle511 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.9,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle512 || (_circle512 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.2,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle513 || (_circle513 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.5,
    cy: 70.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle514 || (_circle514 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.8,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle515 || (_circle515 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.1,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle516 || (_circle516 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.4,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle517 || (_circle517 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.7,
    cy: 64.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle518 || (_circle518 = /*#__PURE__*/React.createElement("circle", {
    cx: 617,
    cy: 62.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle519 || (_circle519 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.2,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle520 || (_circle520 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.2,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle521 || (_circle521 = /*#__PURE__*/React.createElement("circle", {
    cx: 602.3,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle522 || (_circle522 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.3,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle523 || (_circle523 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.4,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle524 || (_circle524 = /*#__PURE__*/React.createElement("circle", {
    cx: 587.4,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle525 || (_circle525 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.5,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle526 || (_circle526 = /*#__PURE__*/React.createElement("circle", {
    cx: 577.6,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle527 || (_circle527 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.6,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle528 || (_circle528 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.7,
    cy: 55.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle529 || (_circle529 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.7,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle530 || (_circle530 = /*#__PURE__*/React.createElement("circle", {
    cx: 557.7,
    cy: 56.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle531 || (_circle531 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.8,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle532 || (_circle532 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.8,
    cy: 57.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle533 || (_circle533 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.8,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle534 || (_circle534 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.8,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle535 || (_circle535 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.9,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle536 || (_circle536 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.9,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle537 || (_circle537 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.9,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle538 || (_circle538 = /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle539 || (_circle539 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.1,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle540 || (_circle540 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.2,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle541 || (_circle541 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.3,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle542 || (_circle542 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.4,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle543 || (_circle543 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.5,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle544 || (_circle544 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.6,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle545 || (_circle545 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.7,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle546 || (_circle546 = /*#__PURE__*/React.createElement("circle", {
    cx: 478.8,
    cy: 67.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle547 || (_circle547 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.9,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle548 || (_circle548 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.1,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle549 || (_circle549 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.2,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle550 || (_circle550 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.4,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle551 || (_circle551 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.5,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle552 || (_circle552 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle553 || (_circle553 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.8,
    cy: 75.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle554 || (_circle554 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle555 || (_circle555 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.1,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle556 || (_circle556 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.2,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle557 || (_circle557 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.4,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle558 || (_circle558 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle559 || (_circle559 = /*#__PURE__*/React.createElement("circle", {
    cx: 415.6,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle560 || (_circle560 = /*#__PURE__*/React.createElement("circle", {
    cx: 410.7,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle561 || (_circle561 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.8,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle562 || (_circle562 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.9,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle563 || (_circle563 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle564 || (_circle564 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.1,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle565 || (_circle565 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.2,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle566 || (_circle566 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.3,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle567 || (_circle567 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.4,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle568 || (_circle568 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.5,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle569 || (_circle569 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle570 || (_circle570 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.5,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle571 || (_circle571 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.6,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle572 || (_circle572 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.6,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle573 || (_circle573 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.6,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle574 || (_circle574 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.6,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle575 || (_circle575 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.7,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle576 || (_circle576 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.7,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle577 || (_circle577 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.7,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle578 || (_circle578 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.8,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle579 || (_circle579 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.8,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle580 || (_circle580 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.9,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle581 || (_circle581 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.9,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle582 || (_circle582 = /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle583 || (_circle583 = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle584 || (_circle584 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle585 || (_circle585 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.1,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle586 || (_circle586 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.1,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle587 || (_circle587 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.2,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle588 || (_circle588 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.2,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle589 || (_circle589 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.3,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle590 || (_circle590 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.4,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle591 || (_circle591 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle592 || (_circle592 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.7,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle593 || (_circle593 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.8,
    cy: 81.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle594 || (_circle594 = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle595 || (_circle595 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.1,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle596 || (_circle596 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.2,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle597 || (_circle597 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.4,
    cy: 77,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle598 || (_circle598 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle599 || (_circle599 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.7,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle600 || (_circle600 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.8,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle601 || (_circle601 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.9,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle602 || (_circle602 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.1,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle603 || (_circle603 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.2,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle604 || (_circle604 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.3,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle605 || (_circle605 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.4,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle606 || (_circle606 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle607 || (_circle607 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.6,
    cy: 66.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle608 || (_circle608 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.7,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle609 || (_circle609 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.8,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle610 || (_circle610 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.9,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle611 || (_circle611 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 62.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle612 || (_circle612 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.1,
    cy: 61.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle613 || (_circle613 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.2,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle614 || (_circle614 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.2,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle615 || (_circle615 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.3,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle616 || (_circle616 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.3,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle617 || (_circle617 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.3,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle618 || (_circle618 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.3,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle619 || (_circle619 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.4,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle620 || (_circle620 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.4,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle621 || (_circle621 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.4,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle622 || (_circle622 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle623 || (_circle623 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle624 || (_circle624 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle625 || (_circle625 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.6,
    cy: 57.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle626 || (_circle626 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.6,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle627 || (_circle627 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.6,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle628 || (_circle628 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle629 || (_circle629 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.7,
    cy: 59.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle630 || (_circle630 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle631 || (_circle631 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.7,
    cy: 60,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle632 || (_circle632 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle633 || (_circle633 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.8,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle634 || (_circle634 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle635 || (_circle635 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.2,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle636 || (_circle636 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle637 || (_circle637 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7,
    cy: 66.7,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle638 || (_circle638 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle639 || (_circle639 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle640 || (_circle640 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle641 || (_circle641 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle642 || (_circle642 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle643 || (_circle643 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.2,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st2"
  })), _circle644 || (_circle644 = /*#__PURE__*/React.createElement("circle", {
    cx: 1046.3,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle645 || (_circle645 = /*#__PURE__*/React.createElement("circle", {
    cx: 1041.4,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle646 || (_circle646 = /*#__PURE__*/React.createElement("circle", {
    cx: 1036.5,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle647 || (_circle647 = /*#__PURE__*/React.createElement("circle", {
    cx: 1031.6,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle648 || (_circle648 = /*#__PURE__*/React.createElement("circle", {
    cx: 1026.7,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle649 || (_circle649 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.7,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle650 || (_circle650 = /*#__PURE__*/React.createElement("circle", {
    cx: 1016.8,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle651 || (_circle651 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.9,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle652 || (_circle652 = /*#__PURE__*/React.createElement("circle", {
    cx: 1007.1,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle653 || (_circle653 = /*#__PURE__*/React.createElement("circle", {
    cx: 1002.3,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle654 || (_circle654 = /*#__PURE__*/React.createElement("circle", {
    cx: 997.5,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle655 || (_circle655 = /*#__PURE__*/React.createElement("circle", {
    cx: 992.6,
    cy: 76.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle656 || (_circle656 = /*#__PURE__*/React.createElement("circle", {
    cx: 987.8,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle657 || (_circle657 = /*#__PURE__*/React.createElement("circle", {
    cx: 983,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle658 || (_circle658 = /*#__PURE__*/React.createElement("circle", {
    cx: 978.2,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle659 || (_circle659 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.3,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle660 || (_circle660 = /*#__PURE__*/React.createElement("circle", {
    cx: 968.5,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle661 || (_circle661 = /*#__PURE__*/React.createElement("circle", {
    cx: 963.6,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle662 || (_circle662 = /*#__PURE__*/React.createElement("circle", {
    cx: 958.8,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle663 || (_circle663 = /*#__PURE__*/React.createElement("circle", {
    cx: 953.9,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle664 || (_circle664 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle665 || (_circle665 = /*#__PURE__*/React.createElement("circle", {
    cx: 944.2,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle666 || (_circle666 = /*#__PURE__*/React.createElement("circle", {
    cx: 939.2,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle667 || (_circle667 = /*#__PURE__*/React.createElement("circle", {
    cx: 934.2,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle668 || (_circle668 = /*#__PURE__*/React.createElement("circle", {
    cx: 929.3,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle669 || (_circle669 = /*#__PURE__*/React.createElement("circle", {
    cx: 924.3,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle670 || (_circle670 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.3,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle671 || (_circle671 = /*#__PURE__*/React.createElement("circle", {
    cx: 914.3,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle672 || (_circle672 = /*#__PURE__*/React.createElement("circle", {
    cx: 909.4,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle673 || (_circle673 = /*#__PURE__*/React.createElement("circle", {
    cx: 904.4,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle674 || (_circle674 = /*#__PURE__*/React.createElement("circle", {
    cx: 899.5,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle675 || (_circle675 = /*#__PURE__*/React.createElement("circle", {
    cx: 894.5,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle676 || (_circle676 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.6,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle677 || (_circle677 = /*#__PURE__*/React.createElement("circle", {
    cx: 884.7,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle678 || (_circle678 = /*#__PURE__*/React.createElement("circle", {
    cx: 879.8,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle679 || (_circle679 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.9,
    cy: 68,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle680 || (_circle680 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.1,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle681 || (_circle681 = /*#__PURE__*/React.createElement("circle", {
    cx: 865.3,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle682 || (_circle682 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.4,
    cy: 71.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle683 || (_circle683 = /*#__PURE__*/React.createElement("circle", {
    cx: 855.6,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle684 || (_circle684 = /*#__PURE__*/React.createElement("circle", {
    cx: 850.8,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle685 || (_circle685 = /*#__PURE__*/React.createElement("circle", {
    cx: 846,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle686 || (_circle686 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.1,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle687 || (_circle687 = /*#__PURE__*/React.createElement("circle", {
    cx: 836.3,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle688 || (_circle688 = /*#__PURE__*/React.createElement("circle", {
    cx: 831.5,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle689 || (_circle689 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.7,
    cy: 80.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle690 || (_circle690 = /*#__PURE__*/React.createElement("circle", {
    cx: 821.8,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle691 || (_circle691 = /*#__PURE__*/React.createElement("circle", {
    cx: 817,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle692 || (_circle692 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.2,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle693 || (_circle693 = /*#__PURE__*/React.createElement("circle", {
    cx: 807.3,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle694 || (_circle694 = /*#__PURE__*/React.createElement("circle", {
    cx: 802.3,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle695 || (_circle695 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.4,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle696 || (_circle696 = /*#__PURE__*/React.createElement("circle", {
    cx: 792.5,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle697 || (_circle697 = /*#__PURE__*/React.createElement("circle", {
    cx: 787.6,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle698 || (_circle698 = /*#__PURE__*/React.createElement("circle", {
    cx: 782.7,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle699 || (_circle699 = /*#__PURE__*/React.createElement("circle", {
    cx: 777.8,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle700 || (_circle700 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.9,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle701 || (_circle701 = /*#__PURE__*/React.createElement("circle", {
    cx: 767.9,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle702 || (_circle702 = /*#__PURE__*/React.createElement("circle", {
    cx: 762.9,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle703 || (_circle703 = /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle704 || (_circle704 = /*#__PURE__*/React.createElement("circle", {
    cx: 753,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle705 || (_circle705 = /*#__PURE__*/React.createElement("circle", {
    cx: 748,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle706 || (_circle706 = /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle707 || (_circle707 = /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle708 || (_circle708 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.1,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle709 || (_circle709 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.1,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle710 || (_circle710 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.1,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle711 || (_circle711 = /*#__PURE__*/React.createElement("circle", {
    cx: 718.2,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle712 || (_circle712 = /*#__PURE__*/React.createElement("circle", {
    cx: 713.2,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle713 || (_circle713 = /*#__PURE__*/React.createElement("circle", {
    cx: 708.3,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle714 || (_circle714 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.3,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle715 || (_circle715 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.4,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle716 || (_circle716 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.4,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle717 || (_circle717 = /*#__PURE__*/React.createElement("circle", {
    cx: 688.5,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle718 || (_circle718 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.5,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle719 || (_circle719 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.6,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle720 || (_circle720 = /*#__PURE__*/React.createElement("circle", {
    cx: 673.9,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle721 || (_circle721 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.2,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle722 || (_circle722 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.5,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle723 || (_circle723 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.8,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle724 || (_circle724 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.1,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle725 || (_circle725 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.4,
    cy: 77.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle726 || (_circle726 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.7,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle727 || (_circle727 = /*#__PURE__*/React.createElement("circle", {
    cx: 641,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle728 || (_circle728 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.3,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle729 || (_circle729 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.6,
    cy: 71,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle730 || (_circle730 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.9,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle731 || (_circle731 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.2,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle732 || (_circle732 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.5,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle733 || (_circle733 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.8,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle734 || (_circle734 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.2,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle735 || (_circle735 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.4,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle736 || (_circle736 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.5,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle737 || (_circle737 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.5,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle738 || (_circle738 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.6,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle739 || (_circle739 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.7,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle740 || (_circle740 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.7,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle741 || (_circle741 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.8,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle742 || (_circle742 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.8,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle743 || (_circle743 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.9,
    cy: 55.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle744 || (_circle744 = /*#__PURE__*/React.createElement("circle", {
    cx: 559,
    cy: 54.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle745 || (_circle745 = /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 54.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle746 || (_circle746 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 55.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle747 || (_circle747 = /*#__PURE__*/React.createElement("circle", {
    cx: 544,
    cy: 55.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle748 || (_circle748 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.1,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle749 || (_circle749 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.1,
    cy: 56.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle750 || (_circle750 = /*#__PURE__*/React.createElement("circle", {
    cx: 529.1,
    cy: 56.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle751 || (_circle751 = /*#__PURE__*/React.createElement("circle", {
    cx: 524.1,
    cy: 57.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle752 || (_circle752 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.2,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle753 || (_circle753 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.2,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle754 || (_circle754 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.2,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle755 || (_circle755 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.3,
    cy: 59.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle756 || (_circle756 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.4,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle757 || (_circle757 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.6,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle758 || (_circle758 = /*#__PURE__*/React.createElement("circle", {
    cx: 489.7,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle759 || (_circle759 = /*#__PURE__*/React.createElement("circle", {
    cx: 484.8,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle760 || (_circle760 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.9,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle761 || (_circle761 = /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 65,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle762 || (_circle762 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.1,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle763 || (_circle763 = /*#__PURE__*/React.createElement("circle", {
    cx: 465.2,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle764 || (_circle764 = /*#__PURE__*/React.createElement("circle", {
    cx: 460.3,
    cy: 68,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle765 || (_circle765 = /*#__PURE__*/React.createElement("circle", {
    cx: 455.5,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle766 || (_circle766 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.6,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle767 || (_circle767 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.8,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle768 || (_circle768 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.9,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle769 || (_circle769 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.1,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle770 || (_circle770 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.2,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle771 || (_circle771 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.3,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle772 || (_circle772 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.5,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle773 || (_circle773 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.6,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle774 || (_circle774 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.8,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle775 || (_circle775 = /*#__PURE__*/React.createElement("circle", {
    cx: 406.9,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle776 || (_circle776 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle777 || (_circle777 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.1,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle778 || (_circle778 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.2,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle779 || (_circle779 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.3,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle780 || (_circle780 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.4,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle781 || (_circle781 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.5,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle782 || (_circle782 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.6,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle783 || (_circle783 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.7,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle784 || (_circle784 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.8,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle785 || (_circle785 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.8,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle786 || (_circle786 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.8,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle787 || (_circle787 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.8,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle788 || (_circle788 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.9,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle789 || (_circle789 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.9,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle790 || (_circle790 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.9,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle791 || (_circle791 = /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle792 || (_circle792 = /*#__PURE__*/React.createElement("circle", {
    cx: 323,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle793 || (_circle793 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle794 || (_circle794 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.1,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle795 || (_circle795 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.1,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle796 || (_circle796 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.1,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle797 || (_circle797 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.2,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle798 || (_circle798 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.2,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle799 || (_circle799 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.2,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle800 || (_circle800 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.3,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle801 || (_circle801 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.3,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle802 || (_circle802 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.3,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle803 || (_circle803 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.4,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle804 || (_circle804 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.4,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle805 || (_circle805 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle806 || (_circle806 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.6,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle807 || (_circle807 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.7,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle808 || (_circle808 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.8,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle809 || (_circle809 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.9,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle810 || (_circle810 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle811 || (_circle811 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.1,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle812 || (_circle812 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.3,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle813 || (_circle813 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.4,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle814 || (_circle814 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.5,
    cy: 76.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle815 || (_circle815 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.6,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle816 || (_circle816 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.7,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle817 || (_circle817 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.8,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle818 || (_circle818 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.9,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle819 || (_circle819 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle820 || (_circle820 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.1,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle821 || (_circle821 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.2,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle822 || (_circle822 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.3,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle823 || (_circle823 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.4,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle824 || (_circle824 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle825 || (_circle825 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.6,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle826 || (_circle826 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.7,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle827 || (_circle827 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.8,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle828 || (_circle828 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.9,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle829 || (_circle829 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.9,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle830 || (_circle830 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.9,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle831 || (_circle831 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle832 || (_circle832 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle833 || (_circle833 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 61.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle834 || (_circle834 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.1,
    cy: 61.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle835 || (_circle835 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.1,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle836 || (_circle836 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.1,
    cy: 60.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle837 || (_circle837 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.2,
    cy: 60.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle838 || (_circle838 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2,
    cy: 59.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle839 || (_circle839 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2,
    cy: 60.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle840 || (_circle840 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.2,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle841 || (_circle841 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.2,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle842 || (_circle842 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.3,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle843 || (_circle843 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.3,
    cy: 61.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle844 || (_circle844 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.3,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle845 || (_circle845 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.3,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle846 || (_circle846 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle847 || (_circle847 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4,
    cy: 62.5,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle848 || (_circle848 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle849 || (_circle849 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle850 || (_circle850 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle851 || (_circle851 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1,
    cy: 67.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle852 || (_circle852 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle853 || (_circle853 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle854 || (_circle854 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle855 || (_circle855 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle856 || (_circle856 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.2,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle857 || (_circle857 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.4,
    cy: 75.8,
    r: 0.8,
    className: "soundwave_svg__st3"
  })), _circle858 || (_circle858 = /*#__PURE__*/React.createElement("circle", {
    cx: 1043,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle859 || (_circle859 = /*#__PURE__*/React.createElement("circle", {
    cx: 1038.1,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle860 || (_circle860 = /*#__PURE__*/React.createElement("circle", {
    cx: 1033.2,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle861 || (_circle861 = /*#__PURE__*/React.createElement("circle", {
    cx: 1028.2,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle862 || (_circle862 = /*#__PURE__*/React.createElement("circle", {
    cx: 1023.3,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle863 || (_circle863 = /*#__PURE__*/React.createElement("circle", {
    cx: 1018.3,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle864 || (_circle864 = /*#__PURE__*/React.createElement("circle", {
    cx: 1013.4,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle865 || (_circle865 = /*#__PURE__*/React.createElement("circle", {
    cx: 1008.5,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle866 || (_circle866 = /*#__PURE__*/React.createElement("circle", {
    cx: 1003.7,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle867 || (_circle867 = /*#__PURE__*/React.createElement("circle", {
    cx: 998.8,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle868 || (_circle868 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle869 || (_circle869 = /*#__PURE__*/React.createElement("circle", {
    cx: 989.1,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle870 || (_circle870 = /*#__PURE__*/React.createElement("circle", {
    cx: 984.3,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle871 || (_circle871 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.4,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle872 || (_circle872 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.6,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle873 || (_circle873 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.7,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle874 || (_circle874 = /*#__PURE__*/React.createElement("circle", {
    cx: 964.8,
    cy: 71.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle875 || (_circle875 = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle876 || (_circle876 = /*#__PURE__*/React.createElement("circle", {
    cx: 955.1,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle877 || (_circle877 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.2,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle878 || (_circle878 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.4,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle879 || (_circle879 = /*#__PURE__*/React.createElement("circle", {
    cx: 940.5,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle880 || (_circle880 = /*#__PURE__*/React.createElement("circle", {
    cx: 935.5,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle881 || (_circle881 = /*#__PURE__*/React.createElement("circle", {
    cx: 930.5,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle882 || (_circle882 = /*#__PURE__*/React.createElement("circle", {
    cx: 925.6,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle883 || (_circle883 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.6,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle884 || (_circle884 = /*#__PURE__*/React.createElement("circle", {
    cx: 915.6,
    cy: 64.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle885 || (_circle885 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.7,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle886 || (_circle886 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.7,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle887 || (_circle887 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.7,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle888 || (_circle888 = /*#__PURE__*/React.createElement("circle", {
    cx: 895.8,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle889 || (_circle889 = /*#__PURE__*/React.createElement("circle", {
    cx: 890.8,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle890 || (_circle890 = /*#__PURE__*/React.createElement("circle", {
    cx: 885.8,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle891 || (_circle891 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.8,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle892 || (_circle892 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.9,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle893 || (_circle893 = /*#__PURE__*/React.createElement("circle", {
    cx: 871,
    cy: 67.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle894 || (_circle894 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.1,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle895 || (_circle895 = /*#__PURE__*/React.createElement("circle", {
    cx: 861.2,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle896 || (_circle896 = /*#__PURE__*/React.createElement("circle", {
    cx: 856.4,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle897 || (_circle897 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.5,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle898 || (_circle898 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.6,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle899 || (_circle899 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.8,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle900 || (_circle900 = /*#__PURE__*/React.createElement("circle", {
    cx: 836.9,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle901 || (_circle901 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.1,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle902 || (_circle902 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.3,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle903 || (_circle903 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.4,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle904 || (_circle904 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.6,
    cy: 79.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle905 || (_circle905 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.7,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle906 || (_circle906 = /*#__PURE__*/React.createElement("circle", {
    cx: 807.9,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle907 || (_circle907 = /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle908 || (_circle908 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.1,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle909 || (_circle909 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.2,
    cy: 84.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle910 || (_circle910 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.3,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle911 || (_circle911 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.4,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle912 || (_circle912 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.5,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle913 || (_circle913 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.6,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle914 || (_circle914 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.6,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle915 || (_circle915 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.7,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle916 || (_circle916 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.8,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle917 || (_circle917 = /*#__PURE__*/React.createElement("circle", {
    cx: 753.8,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle918 || (_circle918 = /*#__PURE__*/React.createElement("circle", {
    cx: 748.8,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle919 || (_circle919 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.8,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle920 || (_circle920 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.9,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle921 || (_circle921 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.9,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle922 || (_circle922 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.9,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle923 || (_circle923 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.9,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle924 || (_circle924 = /*#__PURE__*/React.createElement("circle", {
    cx: 719,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle925 || (_circle925 = /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle926 || (_circle926 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle927 || (_circle927 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.1,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle928 || (_circle928 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.1,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle929 || (_circle929 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.2,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle930 || (_circle930 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.2,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle931 || (_circle931 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.2,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle932 || (_circle932 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.3,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle933 || (_circle933 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.3,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle934 || (_circle934 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.6,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle935 || (_circle935 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.8,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle936 || (_circle936 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.1,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle937 || (_circle937 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.4,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle938 || (_circle938 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.7,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle939 || (_circle939 = /*#__PURE__*/React.createElement("circle", {
    cx: 646,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle940 || (_circle940 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.2,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle941 || (_circle941 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.5,
    cy: 76.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle942 || (_circle942 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.8,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle943 || (_circle943 = /*#__PURE__*/React.createElement("circle", {
    cx: 627.1,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle944 || (_circle944 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.5,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle945 || (_circle945 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.8,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle946 || (_circle946 = /*#__PURE__*/React.createElement("circle", {
    cx: 613.1,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle947 || (_circle947 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.4,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle948 || (_circle948 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.8,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle949 || (_circle949 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.1,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle950 || (_circle950 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.4,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle951 || (_circle951 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.6,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle952 || (_circle952 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.6,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle953 || (_circle953 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.7,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle954 || (_circle954 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.7,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle955 || (_circle955 = /*#__PURE__*/React.createElement("circle", {
    cx: 569.8,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle956 || (_circle956 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.9,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle957 || (_circle957 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.9,
    cy: 55.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle958 || (_circle958 = /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 54.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle959 || (_circle959 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.1,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle960 || (_circle960 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.1,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle961 || (_circle961 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.1,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle962 || (_circle962 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.1,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle963 || (_circle963 = /*#__PURE__*/React.createElement("circle", {
    cx: 530.2,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle964 || (_circle964 = /*#__PURE__*/React.createElement("circle", {
    cx: 525.2,
    cy: 55,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle965 || (_circle965 = /*#__PURE__*/React.createElement("circle", {
    cx: 520.2,
    cy: 55.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle966 || (_circle966 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.2,
    cy: 55.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle967 || (_circle967 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.3,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle968 || (_circle968 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.3,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle969 || (_circle969 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.3,
    cy: 56.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle970 || (_circle970 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.4,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle971 || (_circle971 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.5,
    cy: 58.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle972 || (_circle972 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.6,
    cy: 59.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle973 || (_circle973 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.7,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle974 || (_circle974 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.8,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle975 || (_circle975 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.9,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle976 || (_circle976 = /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle977 || (_circle977 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.1,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle978 || (_circle978 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.2,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle979 || (_circle979 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.3,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle980 || (_circle980 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.5,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle981 || (_circle981 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.6,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle982 || (_circle982 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.8,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle983 || (_circle983 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.9,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle984 || (_circle984 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.1,
    cy: 71.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle985 || (_circle985 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.2,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle986 || (_circle986 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.4,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle987 || (_circle987 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.5,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle988 || (_circle988 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.6,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle989 || (_circle989 = /*#__PURE__*/React.createElement("circle", {
    cx: 402.8,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle990 || (_circle990 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.9,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle991 || (_circle991 = /*#__PURE__*/React.createElement("circle", {
    cx: 393,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle992 || (_circle992 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.1,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle993 || (_circle993 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.2,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle994 || (_circle994 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.3,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle995 || (_circle995 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.5,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle996 || (_circle996 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.6,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle997 || (_circle997 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.7,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle998 || (_circle998 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.8,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle999 || (_circle999 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.8,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1000 || (_circle1000 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.9,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1001 || (_circle1001 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.9,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1002 || (_circle1002 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.9,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1003 || (_circle1003 = /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1004 || (_circle1004 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1005 || (_circle1005 = /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1006 || (_circle1006 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.1,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1007 || (_circle1007 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.1,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1008 || (_circle1008 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.2,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1009 || (_circle1009 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.2,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1010 || (_circle1010 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.2,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1011 || (_circle1011 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.2,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1012 || (_circle1012 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.2,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1013 || (_circle1013 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.3,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1014 || (_circle1014 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.3,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1015 || (_circle1015 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.3,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1016 || (_circle1016 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.3,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1017 || (_circle1017 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.4,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1018 || (_circle1018 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.4,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1019 || (_circle1019 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.4,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1020 || (_circle1020 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1021 || (_circle1021 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.6,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1022 || (_circle1022 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.7,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1023 || (_circle1023 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.8,
    cy: 83.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1024 || (_circle1024 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.9,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1025 || (_circle1025 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.9,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1026 || (_circle1026 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1027 || (_circle1027 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.1,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1028 || (_circle1028 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.2,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1029 || (_circle1029 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.3,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1030 || (_circle1030 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.4,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1031 || (_circle1031 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1032 || (_circle1032 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.6,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1033 || (_circle1033 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.7,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1034 || (_circle1034 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.8,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1035 || (_circle1035 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.9,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1036 || (_circle1036 = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1037 || (_circle1037 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.1,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1038 || (_circle1038 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.1,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1039 || (_circle1039 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.2,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1040 || (_circle1040 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.3,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1041 || (_circle1041 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.4,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1042 || (_circle1042 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1043 || (_circle1043 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1044 || (_circle1044 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1045 || (_circle1045 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.6,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1046 || (_circle1046 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.6,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1047 || (_circle1047 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.6,
    cy: 64.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1048 || (_circle1048 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.7,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1049 || (_circle1049 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.7,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1050 || (_circle1050 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.7,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1051 || (_circle1051 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.8,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1052 || (_circle1052 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.8,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1053 || (_circle1053 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.8,
    cy: 62.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1054 || (_circle1054 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.8,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1055 || (_circle1055 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.9,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1056 || (_circle1056 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.9,
    cy: 63.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1057 || (_circle1057 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.9,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1058 || (_circle1058 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.9,
    cy: 63.9,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1059 || (_circle1059 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1060 || (_circle1060 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1061 || (_circle1061 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1062 || (_circle1062 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1063 || (_circle1063 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1064 || (_circle1064 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1065 || (_circle1065 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1066 || (_circle1066 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1067 || (_circle1067 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1068 || (_circle1068 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1069 || (_circle1069 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.3,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1070 || (_circle1070 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st4"
  })), _circle1071 || (_circle1071 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.1,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1072 || (_circle1072 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.1,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1073 || (_circle1073 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.2,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1074 || (_circle1074 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.2,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1075 || (_circle1075 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.3,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1076 || (_circle1076 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.3,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1077 || (_circle1077 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.4,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1078 || (_circle1078 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009.4,
    cy: 83.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1079 || (_circle1079 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004.6,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1080 || (_circle1080 = /*#__PURE__*/React.createElement("circle", {
    cx: 999.7,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1081 || (_circle1081 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.9,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1082 || (_circle1082 = /*#__PURE__*/React.createElement("circle", {
    cx: 990,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1083 || (_circle1083 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.1,
    cy: 77.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1084 || (_circle1084 = /*#__PURE__*/React.createElement("circle", {
    cx: 980.3,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1085 || (_circle1085 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.4,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1086 || (_circle1086 = /*#__PURE__*/React.createElement("circle", {
    cx: 970.5,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1087 || (_circle1087 = /*#__PURE__*/React.createElement("circle", {
    cx: 965.7,
    cy: 73.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1088 || (_circle1088 = /*#__PURE__*/React.createElement("circle", {
    cx: 960.8,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1089 || (_circle1089 = /*#__PURE__*/React.createElement("circle", {
    cx: 955.9,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1090 || (_circle1090 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.1,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1091 || (_circle1091 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.2,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1092 || (_circle1092 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.3,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1093 || (_circle1093 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.4,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1094 || (_circle1094 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.4,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1095 || (_circle1095 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.4,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1096 || (_circle1096 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.5,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1097 || (_circle1097 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.5,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1098 || (_circle1098 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.5,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1099 || (_circle1099 = /*#__PURE__*/React.createElement("circle", {
    cx: 906.6,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1100 || (_circle1100 = /*#__PURE__*/React.createElement("circle", {
    cx: 901.6,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1101 || (_circle1101 = /*#__PURE__*/React.createElement("circle", {
    cx: 896.6,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1102 || (_circle1102 = /*#__PURE__*/React.createElement("circle", {
    cx: 891.6,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1103 || (_circle1103 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.6,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1104 || (_circle1104 = /*#__PURE__*/React.createElement("circle", {
    cx: 881.6,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1105 || (_circle1105 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.7,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1106 || (_circle1106 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.7,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1107 || (_circle1107 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.8,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1108 || (_circle1108 = /*#__PURE__*/React.createElement("circle", {
    cx: 861.8,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1109 || (_circle1109 = /*#__PURE__*/React.createElement("circle", {
    cx: 856.9,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1110 || (_circle1110 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.9,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1111 || (_circle1111 = /*#__PURE__*/React.createElement("circle", {
    cx: 847,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1112 || (_circle1112 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.2,
    cy: 70.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1113 || (_circle1113 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.3,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1114 || (_circle1114 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.5,
    cy: 73.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1115 || (_circle1115 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.6,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1116 || (_circle1116 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.7,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1117 || (_circle1117 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.9,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1118 || (_circle1118 = /*#__PURE__*/React.createElement("circle", {
    cx: 813,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1119 || (_circle1119 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.1,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1120 || (_circle1120 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.3,
    cy: 79.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1121 || (_circle1121 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.4,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1122 || (_circle1122 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.5,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1123 || (_circle1123 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.6,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1124 || (_circle1124 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.7,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1125 || (_circle1125 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.8,
    cy: 84.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1126 || (_circle1126 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.9,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1127 || (_circle1127 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1128 || (_circle1128 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.2,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1129 || (_circle1129 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.3,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1130 || (_circle1130 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.3,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1131 || (_circle1131 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.3,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1132 || (_circle1132 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.4,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1133 || (_circle1133 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.4,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1134 || (_circle1134 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.5,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1135 || (_circle1135 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.5,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1136 || (_circle1136 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.5,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1137 || (_circle1137 = /*#__PURE__*/React.createElement("circle", {
    cx: 719.6,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1138 || (_circle1138 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.6,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1139 || (_circle1139 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.6,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1140 || (_circle1140 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.7,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1141 || (_circle1141 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.7,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1142 || (_circle1142 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.7,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1143 || (_circle1143 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.7,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1144 || (_circle1144 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.8,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1145 || (_circle1145 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.8,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1146 || (_circle1146 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.8,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1147 || (_circle1147 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.8,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1148 || (_circle1148 = /*#__PURE__*/React.createElement("circle", {
    cx: 665,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1149 || (_circle1149 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.2,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1150 || (_circle1150 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.4,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1151 || (_circle1151 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.6,
    cy: 84.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1152 || (_circle1152 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.9,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1153 || (_circle1153 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.1,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1154 || (_circle1154 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.4,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1155 || (_circle1155 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.8,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1156 || (_circle1156 = /*#__PURE__*/React.createElement("circle", {
    cx: 627.2,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1157 || (_circle1157 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1158 || (_circle1158 = /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1159 || (_circle1159 = /*#__PURE__*/React.createElement("circle", {
    cx: 613.4,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1160 || (_circle1160 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.7,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1161 || (_circle1161 = /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1162 || (_circle1162 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.3,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1163 || (_circle1163 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.6,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1164 || (_circle1164 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.9,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1165 || (_circle1165 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.2,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1166 || (_circle1166 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.5,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1167 || (_circle1167 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.5,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1168 || (_circle1168 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.6,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1169 || (_circle1169 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.7,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1170 || (_circle1170 = /*#__PURE__*/React.createElement("circle", {
    cx: 560.7,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1171 || (_circle1171 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.8,
    cy: 55.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1172 || (_circle1172 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.9,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1173 || (_circle1173 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.9,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1174 || (_circle1174 = /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1175 || (_circle1175 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.1,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1176 || (_circle1176 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.1,
    cy: 52.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1177 || (_circle1177 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.1,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1178 || (_circle1178 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.1,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1179 || (_circle1179 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.2,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1180 || (_circle1180 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.2,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1181 || (_circle1181 = /*#__PURE__*/React.createElement("circle", {
    cx: 506.2,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1182 || (_circle1182 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.2,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1183 || (_circle1183 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.2,
    cy: 54.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1184 || (_circle1184 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.3,
    cy: 55.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1185 || (_circle1185 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.3,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1186 || (_circle1186 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.4,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1187 || (_circle1187 = /*#__PURE__*/React.createElement("circle", {
    cx: 476.5,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1188 || (_circle1188 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.6,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1189 || (_circle1189 = /*#__PURE__*/React.createElement("circle", {
    cx: 466.7,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1190 || (_circle1190 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.8,
    cy: 60.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1191 || (_circle1191 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.9,
    cy: 61.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1192 || (_circle1192 = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1193 || (_circle1193 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.1,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1194 || (_circle1194 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.2,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1195 || (_circle1195 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.4,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1196 || (_circle1196 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.5,
    cy: 66.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1197 || (_circle1197 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.7,
    cy: 67.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1198 || (_circle1198 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.8,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1199 || (_circle1199 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1200 || (_circle1200 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.1,
    cy: 71.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1201 || (_circle1201 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.3,
    cy: 72.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1202 || (_circle1202 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.4,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1203 || (_circle1203 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1204 || (_circle1204 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.7,
    cy: 75.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1205 || (_circle1205 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.8,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1206 || (_circle1206 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.9,
    cy: 77.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1207 || (_circle1207 = /*#__PURE__*/React.createElement("circle", {
    cx: 379,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1208 || (_circle1208 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.2,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1209 || (_circle1209 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.3,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1210 || (_circle1210 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1211 || (_circle1211 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.5,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1212 || (_circle1212 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.6,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1213 || (_circle1213 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.7,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1214 || (_circle1214 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.8,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1215 || (_circle1215 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.8,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1216 || (_circle1216 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.9,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1217 || (_circle1217 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.9,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1218 || (_circle1218 = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1219 || (_circle1219 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1220 || (_circle1220 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1221 || (_circle1221 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.1,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1222 || (_circle1222 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.1,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1223 || (_circle1223 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.1,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1224 || (_circle1224 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.2,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1225 || (_circle1225 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.2,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1226 || (_circle1226 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.2,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1227 || (_circle1227 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.2,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1228 || (_circle1228 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.2,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1229 || (_circle1229 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.2,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1230 || (_circle1230 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.3,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1231 || (_circle1231 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.3,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1232 || (_circle1232 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.3,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1233 || (_circle1233 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.3,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1234 || (_circle1234 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.3,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1235 || (_circle1235 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.4,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1236 || (_circle1236 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1237 || (_circle1237 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.6,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1238 || (_circle1238 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.6,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1239 || (_circle1239 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.7,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1240 || (_circle1240 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.8,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1241 || (_circle1241 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.8,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1242 || (_circle1242 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.9,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1243 || (_circle1243 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1244 || (_circle1244 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.1,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1245 || (_circle1245 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.1,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1246 || (_circle1246 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.2,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1247 || (_circle1247 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.3,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1248 || (_circle1248 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.4,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1249 || (_circle1249 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1250 || (_circle1250 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1251 || (_circle1251 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.6,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1252 || (_circle1252 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.7,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1253 || (_circle1253 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.8,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1254 || (_circle1254 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.9,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1255 || (_circle1255 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1256 || (_circle1256 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1257 || (_circle1257 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.1,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1258 || (_circle1258 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.1,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1259 || (_circle1259 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.1,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1260 || (_circle1260 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1261 || (_circle1261 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.2,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1262 || (_circle1262 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.2,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1263 || (_circle1263 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.3,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1264 || (_circle1264 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1265 || (_circle1265 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.3,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1266 || (_circle1266 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.4,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1267 || (_circle1267 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.4,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1268 || (_circle1268 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1269 || (_circle1269 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.4,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1270 || (_circle1270 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.4,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1271 || (_circle1271 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1272 || (_circle1272 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.4,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1273 || (_circle1273 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 66.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1274 || (_circle1274 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1275 || (_circle1275 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.6,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1276 || (_circle1276 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.7,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1277 || (_circle1277 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8,
    cy: 69.1,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1278 || (_circle1278 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1279 || (_circle1279 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1280 || (_circle1280 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1281 || (_circle1281 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1282 || (_circle1282 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1283 || (_circle1283 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.6,
    cy: 75.6,
    r: 0.8,
    className: "soundwave_svg__st5"
  })), _circle1284 || (_circle1284 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.9,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1285 || (_circle1285 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.9,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1286 || (_circle1286 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.9,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1287 || (_circle1287 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1288 || (_circle1288 = /*#__PURE__*/React.createElement("circle", {
    cx: 1025,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1289 || (_circle1289 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1290 || (_circle1290 = /*#__PURE__*/React.createElement("circle", {
    cx: 1015.1,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1291 || (_circle1291 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010.1,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1292 || (_circle1292 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.1,
    cy: 83.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1293 || (_circle1293 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000.2,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1294 || (_circle1294 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.3,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1295 || (_circle1295 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.4,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1296 || (_circle1296 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.5,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1297 || (_circle1297 = /*#__PURE__*/React.createElement("circle", {
    cx: 980.6,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1298 || (_circle1298 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.8,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1299 || (_circle1299 = /*#__PURE__*/React.createElement("circle", {
    cx: 970.9,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1300 || (_circle1300 = /*#__PURE__*/React.createElement("circle", {
    cx: 966,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1301 || (_circle1301 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.1,
    cy: 75,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1302 || (_circle1302 = /*#__PURE__*/React.createElement("circle", {
    cx: 956.2,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1303 || (_circle1303 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.4,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1304 || (_circle1304 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.4,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1305 || (_circle1305 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.5,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1306 || (_circle1306 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.6,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1307 || (_circle1307 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.6,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1308 || (_circle1308 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.7,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1309 || (_circle1309 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.8,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1310 || (_circle1310 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.8,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1311 || (_circle1311 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.9,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1312 || (_circle1312 = /*#__PURE__*/React.createElement("circle", {
    cx: 907,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1313 || (_circle1313 = /*#__PURE__*/React.createElement("circle", {
    cx: 902,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1314 || (_circle1314 = /*#__PURE__*/React.createElement("circle", {
    cx: 897,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1315 || (_circle1315 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.1,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1316 || (_circle1316 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.1,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1317 || (_circle1317 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.1,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1318 || (_circle1318 = /*#__PURE__*/React.createElement("circle", {
    cx: 877.1,
    cy: 65,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1319 || (_circle1319 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.1,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1320 || (_circle1320 = /*#__PURE__*/React.createElement("circle", {
    cx: 867.2,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1321 || (_circle1321 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.2,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1322 || (_circle1322 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.2,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1323 || (_circle1323 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.3,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1324 || (_circle1324 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.3,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1325 || (_circle1325 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.4,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1326 || (_circle1326 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.5,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1327 || (_circle1327 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.6,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1328 || (_circle1328 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.7,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1329 || (_circle1329 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.9,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1330 || (_circle1330 = /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1331 || (_circle1331 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.1,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1332 || (_circle1332 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.2,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1333 || (_circle1333 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.4,
    cy: 76.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1334 || (_circle1334 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.5,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1335 || (_circle1335 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.6,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1336 || (_circle1336 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.7,
    cy: 79.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1337 || (_circle1337 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.8,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1338 || (_circle1338 = /*#__PURE__*/React.createElement("circle", {
    cx: 779,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1339 || (_circle1339 = /*#__PURE__*/React.createElement("circle", {
    cx: 774.1,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1340 || (_circle1340 = /*#__PURE__*/React.createElement("circle", {
    cx: 769.2,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1341 || (_circle1341 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.3,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1342 || (_circle1342 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.5,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1343 || (_circle1343 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.6,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1344 || (_circle1344 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.6,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1345 || (_circle1345 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.7,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1346 || (_circle1346 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.8,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1347 || (_circle1347 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.8,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1348 || (_circle1348 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.9,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1349 || (_circle1349 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.9,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1350 || (_circle1350 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1351 || (_circle1351 = /*#__PURE__*/React.createElement("circle", {
    cx: 715,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1352 || (_circle1352 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.1,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1353 || (_circle1353 = /*#__PURE__*/React.createElement("circle", {
    cx: 705.1,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1354 || (_circle1354 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.1,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1355 || (_circle1355 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.1,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1356 || (_circle1356 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.2,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1357 || (_circle1357 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.2,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1358 || (_circle1358 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.2,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1359 || (_circle1359 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.2,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1360 || (_circle1360 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.2,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1361 || (_circle1361 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.3,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1362 || (_circle1362 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.3,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1363 || (_circle1363 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.5,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1364 || (_circle1364 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.7,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1365 || (_circle1365 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.9,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1366 || (_circle1366 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.2,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1367 || (_circle1367 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.4,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1368 || (_circle1368 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.6,
    cy: 82,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1369 || (_circle1369 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.9,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1370 || (_circle1370 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.3,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1371 || (_circle1371 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.7,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1372 || (_circle1372 = /*#__PURE__*/React.createElement("circle", {
    cx: 613.1,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1373 || (_circle1373 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.5,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1374 || (_circle1374 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.9,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1375 || (_circle1375 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.3,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1376 || (_circle1376 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.6,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1377 || (_circle1377 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.9,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1378 || (_circle1378 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.3,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1379 || (_circle1379 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.6,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1380 || (_circle1380 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.9,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1381 || (_circle1381 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.2,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1382 || (_circle1382 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.3,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1383 || (_circle1383 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1384 || (_circle1384 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.4,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1385 || (_circle1385 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.5,
    cy: 55.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1386 || (_circle1386 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.6,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1387 || (_circle1387 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.6,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1388 || (_circle1388 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.7,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1389 || (_circle1389 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.8,
    cy: 52.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1390 || (_circle1390 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.8,
    cy: 51.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1391 || (_circle1391 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.9,
    cy: 51.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1392 || (_circle1392 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.9,
    cy: 52,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1393 || (_circle1393 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1394 || (_circle1394 = /*#__PURE__*/React.createElement("circle", {
    cx: 506.9,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1395 || (_circle1395 = /*#__PURE__*/React.createElement("circle", {
    cx: 502,
    cy: 52.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1396 || (_circle1396 = /*#__PURE__*/React.createElement("circle", {
    cx: 497,
    cy: 53,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1397 || (_circle1397 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 53.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1398 || (_circle1398 = /*#__PURE__*/React.createElement("circle", {
    cx: 487,
    cy: 53.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1399 || (_circle1399 = /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1400 || (_circle1400 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.1,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1401 || (_circle1401 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.2,
    cy: 55.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1402 || (_circle1402 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.3,
    cy: 56.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1403 || (_circle1403 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.4,
    cy: 57.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1404 || (_circle1404 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.5,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1405 || (_circle1405 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.6,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1406 || (_circle1406 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.7,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1407 || (_circle1407 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.8,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1408 || (_circle1408 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.8,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1409 || (_circle1409 = /*#__PURE__*/React.createElement("circle", {
    cx: 433,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1410 || (_circle1410 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.1,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1411 || (_circle1411 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.3,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1412 || (_circle1412 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.4,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1413 || (_circle1413 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.5,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1414 || (_circle1414 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.7,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1415 || (_circle1415 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.8,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1416 || (_circle1416 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1417 || (_circle1417 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.1,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1418 || (_circle1418 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.3,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1419 || (_circle1419 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.4,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1420 || (_circle1420 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.5,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1421 || (_circle1421 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.7,
    cy: 76.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1422 || (_circle1422 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.8,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1423 || (_circle1423 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.9,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1424 || (_circle1424 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1425 || (_circle1425 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.2,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1426 || (_circle1426 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.3,
    cy: 81.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1427 || (_circle1427 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.4,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1428 || (_circle1428 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.5,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1429 || (_circle1429 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.6,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1430 || (_circle1430 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.6,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1431 || (_circle1431 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.7,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1432 || (_circle1432 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.7,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1433 || (_circle1433 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.8,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1434 || (_circle1434 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.8,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1435 || (_circle1435 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.9,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1436 || (_circle1436 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.9,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1437 || (_circle1437 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1438 || (_circle1438 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1439 || (_circle1439 = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1440 || (_circle1440 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1441 || (_circle1441 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1442 || (_circle1442 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1443 || (_circle1443 = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1444 || (_circle1444 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.1,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1445 || (_circle1445 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.1,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1446 || (_circle1446 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.1,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1447 || (_circle1447 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.1,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1448 || (_circle1448 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.1,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1449 || (_circle1449 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.2,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1450 || (_circle1450 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.2,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1451 || (_circle1451 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.3,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1452 || (_circle1452 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.3,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1453 || (_circle1453 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.4,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1454 || (_circle1454 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.4,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1455 || (_circle1455 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 83.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1456 || (_circle1456 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1457 || (_circle1457 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.6,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1458 || (_circle1458 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.7,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1459 || (_circle1459 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.7,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1460 || (_circle1460 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.8,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1461 || (_circle1461 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.8,
    cy: 79.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1462 || (_circle1462 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.9,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1463 || (_circle1463 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1464 || (_circle1464 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.1,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1465 || (_circle1465 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.1,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1466 || (_circle1466 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.2,
    cy: 75.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1467 || (_circle1467 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.3,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1468 || (_circle1468 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.4,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1469 || (_circle1469 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.4,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1470 || (_circle1470 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1471 || (_circle1471 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1472 || (_circle1472 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.6,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1473 || (_circle1473 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.6,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1474 || (_circle1474 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.7,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1475 || (_circle1475 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.7,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1476 || (_circle1476 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.7,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1477 || (_circle1477 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.8,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1478 || (_circle1478 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1479 || (_circle1479 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.8,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1480 || (_circle1480 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1481 || (_circle1481 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1482 || (_circle1482 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1483 || (_circle1483 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1484 || (_circle1484 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1485 || (_circle1485 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1486 || (_circle1486 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.9,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1487 || (_circle1487 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1488 || (_circle1488 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1489 || (_circle1489 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1490 || (_circle1490 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1491 || (_circle1491 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3,
    cy: 71,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1492 || (_circle1492 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1493 || (_circle1493 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1494 || (_circle1494 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1495 || (_circle1495 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1496 || (_circle1496 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 75.6,
    r: 0.8,
    className: "soundwave_svg__st6"
  })), _circle1497 || (_circle1497 = /*#__PURE__*/React.createElement("circle", {
    cx: 1045.1,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1498 || (_circle1498 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040.1,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1499 || (_circle1499 = /*#__PURE__*/React.createElement("circle", {
    cx: 1035.1,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1500 || (_circle1500 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030.1,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1501 || (_circle1501 = /*#__PURE__*/React.createElement("circle", {
    cx: 1025.2,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1502 || (_circle1502 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.2,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1503 || (_circle1503 = /*#__PURE__*/React.createElement("circle", {
    cx: 1015.2,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1504 || (_circle1504 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010.2,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1505 || (_circle1505 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.2,
    cy: 84.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1506 || (_circle1506 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000.3,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1507 || (_circle1507 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.3,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1508 || (_circle1508 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.4,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1509 || (_circle1509 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.5,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1510 || (_circle1510 = /*#__PURE__*/React.createElement("circle", {
    cx: 980.6,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1511 || (_circle1511 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.8,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1512 || (_circle1512 = /*#__PURE__*/React.createElement("circle", {
    cx: 970.9,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1513 || (_circle1513 = /*#__PURE__*/React.createElement("circle", {
    cx: 966,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1514 || (_circle1514 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.1,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1515 || (_circle1515 = /*#__PURE__*/React.createElement("circle", {
    cx: 956.2,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1516 || (_circle1516 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.3,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1517 || (_circle1517 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.4,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1518 || (_circle1518 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.5,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1519 || (_circle1519 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.5,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1520 || (_circle1520 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.6,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1521 || (_circle1521 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.7,
    cy: 71,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1522 || (_circle1522 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.8,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1523 || (_circle1523 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.8,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1524 || (_circle1524 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.9,
    cy: 68.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1525 || (_circle1525 = /*#__PURE__*/React.createElement("circle", {
    cx: 907,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1526 || (_circle1526 = /*#__PURE__*/React.createElement("circle", {
    cx: 902.1,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1527 || (_circle1527 = /*#__PURE__*/React.createElement("circle", {
    cx: 897.1,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1528 || (_circle1528 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.1,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1529 || (_circle1529 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.2,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1530 || (_circle1530 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.2,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1531 || (_circle1531 = /*#__PURE__*/React.createElement("circle", {
    cx: 877.2,
    cy: 65,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1532 || (_circle1532 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.2,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1533 || (_circle1533 = /*#__PURE__*/React.createElement("circle", {
    cx: 867.3,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1534 || (_circle1534 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.3,
    cy: 65,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1535 || (_circle1535 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.3,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1536 || (_circle1536 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.3,
    cy: 65.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1537 || (_circle1537 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.3,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1538 || (_circle1538 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.4,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1539 || (_circle1539 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.5,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1540 || (_circle1540 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.6,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1541 || (_circle1541 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.7,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1542 || (_circle1542 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.8,
    cy: 69.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1543 || (_circle1543 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.9,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1544 || (_circle1544 = /*#__PURE__*/React.createElement("circle", {
    cx: 813,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1545 || (_circle1545 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.1,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1546 || (_circle1546 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.2,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1547 || (_circle1547 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.3,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1548 || (_circle1548 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.4,
    cy: 75.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1549 || (_circle1549 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.6,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1550 || (_circle1550 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.7,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1551 || (_circle1551 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.8,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1552 || (_circle1552 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1553 || (_circle1553 = /*#__PURE__*/React.createElement("circle", {
    cx: 769.1,
    cy: 81.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1554 || (_circle1554 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.3,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1555 || (_circle1555 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.4,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1556 || (_circle1556 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1557 || (_circle1557 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.7,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1558 || (_circle1558 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.7,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1559 || (_circle1559 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.8,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1560 || (_circle1560 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.9,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1561 || (_circle1561 = /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1562 || (_circle1562 = /*#__PURE__*/React.createElement("circle", {
    cx: 725,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1563 || (_circle1563 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.1,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1564 || (_circle1564 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.2,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1565 || (_circle1565 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.2,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1566 || (_circle1566 = /*#__PURE__*/React.createElement("circle", {
    cx: 705.3,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1567 || (_circle1567 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.4,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1568 || (_circle1568 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1569 || (_circle1569 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1570 || (_circle1570 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.4,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1571 || (_circle1571 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.4,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1572 || (_circle1572 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.4,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1573 || (_circle1573 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.4,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1574 || (_circle1574 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.5,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1575 || (_circle1575 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.5,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1576 || (_circle1576 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.5,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1577 || (_circle1577 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.7,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1578 || (_circle1578 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.9,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1579 || (_circle1579 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.1,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1580 || (_circle1580 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.3,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1581 || (_circle1581 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.5,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1582 || (_circle1582 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.7,
    cy: 83.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1583 || (_circle1583 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.9,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1584 || (_circle1584 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.3,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1585 || (_circle1585 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.7,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1586 || (_circle1586 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.1,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1587 || (_circle1587 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.5,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1588 || (_circle1588 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.9,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1589 || (_circle1589 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.4,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1590 || (_circle1590 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.7,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1591 || (_circle1591 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.1,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1592 || (_circle1592 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.4,
    cy: 65.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1593 || (_circle1593 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.7,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1594 || (_circle1594 = /*#__PURE__*/React.createElement("circle", {
    cx: 571,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1595 || (_circle1595 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.3,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1596 || (_circle1596 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.7,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1597 || (_circle1597 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.9,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1598 || (_circle1598 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1599 || (_circle1599 = /*#__PURE__*/React.createElement("circle", {
    cx: 547,
    cy: 55.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1600 || (_circle1600 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.1,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1601 || (_circle1601 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.2,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1602 || (_circle1602 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.2,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1603 || (_circle1603 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.3,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1604 || (_circle1604 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.4,
    cy: 51.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1605 || (_circle1605 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.4,
    cy: 50.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1606 || (_circle1606 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.5,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1607 || (_circle1607 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.5,
    cy: 50.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1608 || (_circle1608 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.5,
    cy: 51.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1609 || (_circle1609 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.5,
    cy: 51.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1610 || (_circle1610 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.6,
    cy: 51.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1611 || (_circle1611 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.6,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1612 || (_circle1612 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.6,
    cy: 52,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1613 || (_circle1613 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.6,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1614 || (_circle1614 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.6,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1615 || (_circle1615 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.7,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1616 || (_circle1616 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.8,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1617 || (_circle1617 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.9,
    cy: 54.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1618 || (_circle1618 = /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 55.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1619 || (_circle1619 = /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 56.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1620 || (_circle1620 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.1,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1621 || (_circle1621 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.2,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1622 || (_circle1622 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.3,
    cy: 59.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1623 || (_circle1623 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.4,
    cy: 60.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1624 || (_circle1624 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.5,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1625 || (_circle1625 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.7,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1626 || (_circle1626 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.8,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1627 || (_circle1627 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1628 || (_circle1628 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.1,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1629 || (_circle1629 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.2,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1630 || (_circle1630 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.4,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1631 || (_circle1631 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.5,
    cy: 69.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1632 || (_circle1632 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.7,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1633 || (_circle1633 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.8,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1634 || (_circle1634 = /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1635 || (_circle1635 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.1,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1636 || (_circle1636 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.2,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1637 || (_circle1637 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.4,
    cy: 75.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1638 || (_circle1638 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.5,
    cy: 76.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1639 || (_circle1639 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.6,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1640 || (_circle1640 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.8,
    cy: 79.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1641 || (_circle1641 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.9,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1642 || (_circle1642 = /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1643 || (_circle1643 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.1,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1644 || (_circle1644 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.2,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1645 || (_circle1645 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.2,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1646 || (_circle1646 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.3,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1647 || (_circle1647 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.4,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1648 || (_circle1648 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.4,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1649 || (_circle1649 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.5,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1650 || (_circle1650 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.6,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1651 || (_circle1651 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.6,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1652 || (_circle1652 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.6,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1653 || (_circle1653 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.6,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1654 || (_circle1654 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.7,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1655 || (_circle1655 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.7,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1656 || (_circle1656 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.7,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1657 || (_circle1657 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.7,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1658 || (_circle1658 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.7,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1659 || (_circle1659 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.7,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1660 || (_circle1660 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.7,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1661 || (_circle1661 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.7,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1662 || (_circle1662 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.8,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1663 || (_circle1663 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.8,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1664 || (_circle1664 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.8,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1665 || (_circle1665 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.9,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1666 || (_circle1666 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.9,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1667 || (_circle1667 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.9,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1668 || (_circle1668 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1669 || (_circle1669 = /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1670 || (_circle1670 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.1,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1671 || (_circle1671 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.1,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1672 || (_circle1672 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.1,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1673 || (_circle1673 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.2,
    cy: 83.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1674 || (_circle1674 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.2,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1675 || (_circle1675 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.3,
    cy: 82,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1676 || (_circle1676 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.4,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1677 || (_circle1677 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.4,
    cy: 80.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1678 || (_circle1678 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1679 || (_circle1679 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.6,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1680 || (_circle1680 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.6,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1681 || (_circle1681 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.7,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1682 || (_circle1682 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.8,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1683 || (_circle1683 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.8,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1684 || (_circle1684 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.9,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1685 || (_circle1685 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.9,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1686 || (_circle1686 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1687 || (_circle1687 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1688 || (_circle1688 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.1,
    cy: 73.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1689 || (_circle1689 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.1,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1690 || (_circle1690 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.1,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1691 || (_circle1691 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1692 || (_circle1692 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.2,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1693 || (_circle1693 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.3,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1694 || (_circle1694 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.3,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1695 || (_circle1695 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1696 || (_circle1696 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.3,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1697 || (_circle1697 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.3,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1698 || (_circle1698 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.3,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1699 || (_circle1699 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.3,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1700 || (_circle1700 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.3,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1701 || (_circle1701 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1702 || (_circle1702 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1703 || (_circle1703 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 71.2,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1704 || (_circle1704 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1705 || (_circle1705 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1706 || (_circle1706 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7,
    cy: 73.4,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1707 || (_circle1707 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1708 || (_circle1708 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.8,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1709 || (_circle1709 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.9,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st7"
  })), _circle1710 || (_circle1710 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.8,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1711 || (_circle1711 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.8,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1712 || (_circle1712 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.8,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1713 || (_circle1713 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.8,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1714 || (_circle1714 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.8,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1715 || (_circle1715 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.9,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1716 || (_circle1716 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.9,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1717 || (_circle1717 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009.9,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1718 || (_circle1718 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004.9,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1719 || (_circle1719 = /*#__PURE__*/React.createElement("circle", {
    cx: 999.9,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1720 || (_circle1720 = /*#__PURE__*/React.createElement("circle", {
    cx: 995,
    cy: 85.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1721 || (_circle1721 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.1,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1722 || (_circle1722 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.2,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1723 || (_circle1723 = /*#__PURE__*/React.createElement("circle", {
    cx: 980.2,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1724 || (_circle1724 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.3,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1725 || (_circle1725 = /*#__PURE__*/React.createElement("circle", {
    cx: 970.4,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1726 || (_circle1726 = /*#__PURE__*/React.createElement("circle", {
    cx: 965.5,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1727 || (_circle1727 = /*#__PURE__*/React.createElement("circle", {
    cx: 960.6,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1728 || (_circle1728 = /*#__PURE__*/React.createElement("circle", {
    cx: 955.7,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1729 || (_circle1729 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.8,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1730 || (_circle1730 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.9,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1731 || (_circle1731 = /*#__PURE__*/React.createElement("circle", {
    cx: 941,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1732 || (_circle1732 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.1,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1733 || (_circle1733 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.2,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1734 || (_circle1734 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.3,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1735 || (_circle1735 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.3,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1736 || (_circle1736 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.4,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1737 || (_circle1737 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.5,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1738 || (_circle1738 = /*#__PURE__*/React.createElement("circle", {
    cx: 906.6,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1739 || (_circle1739 = /*#__PURE__*/React.createElement("circle", {
    cx: 901.7,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1740 || (_circle1740 = /*#__PURE__*/React.createElement("circle", {
    cx: 896.8,
    cy: 67.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1741 || (_circle1741 = /*#__PURE__*/React.createElement("circle", {
    cx: 891.8,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1742 || (_circle1742 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.9,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1743 || (_circle1743 = /*#__PURE__*/React.createElement("circle", {
    cx: 881.9,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1744 || (_circle1744 = /*#__PURE__*/React.createElement("circle", {
    cx: 877,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1745 || (_circle1745 = /*#__PURE__*/React.createElement("circle", {
    cx: 872,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1746 || (_circle1746 = /*#__PURE__*/React.createElement("circle", {
    cx: 867.1,
    cy: 64.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1747 || (_circle1747 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.1,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1748 || (_circle1748 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.1,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1749 || (_circle1749 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.1,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1750 || (_circle1750 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.1,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1751 || (_circle1751 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.1,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1752 || (_circle1752 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.1,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1753 || (_circle1753 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.2,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1754 || (_circle1754 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.3,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1755 || (_circle1755 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.4,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1756 || (_circle1756 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.5,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1757 || (_circle1757 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.6,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1758 || (_circle1758 = /*#__PURE__*/React.createElement("circle", {
    cx: 807.7,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1759 || (_circle1759 = /*#__PURE__*/React.createElement("circle", {
    cx: 802.8,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1760 || (_circle1760 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.9,
    cy: 71.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1761 || (_circle1761 = /*#__PURE__*/React.createElement("circle", {
    cx: 793,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1762 || (_circle1762 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.1,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1763 || (_circle1763 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.3,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1764 || (_circle1764 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.4,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1765 || (_circle1765 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.6,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1766 || (_circle1766 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.7,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1767 || (_circle1767 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.9,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1768 || (_circle1768 = /*#__PURE__*/React.createElement("circle", {
    cx: 759,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1769 || (_circle1769 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.2,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1770 || (_circle1770 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.3,
    cy: 83,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1771 || (_circle1771 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.5,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1772 || (_circle1772 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.6,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1773 || (_circle1773 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.7,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1774 || (_circle1774 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.8,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1775 || (_circle1775 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.9,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1776 || (_circle1776 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1777 || (_circle1777 = /*#__PURE__*/React.createElement("circle", {
    cx: 715,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1778 || (_circle1778 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.1,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1779 || (_circle1779 = /*#__PURE__*/React.createElement("circle", {
    cx: 705.2,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1780 || (_circle1780 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.3,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1781 || (_circle1781 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1782 || (_circle1782 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1783 || (_circle1783 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1784 || (_circle1784 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1785 || (_circle1785 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1786 || (_circle1786 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1787 || (_circle1787 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.5,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1788 || (_circle1788 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.5,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1789 || (_circle1789 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.5,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1790 || (_circle1790 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.5,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1791 || (_circle1791 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.6,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1792 || (_circle1792 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.8,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1793 || (_circle1793 = /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1794 || (_circle1794 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.2,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1795 || (_circle1795 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.4,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1796 || (_circle1796 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.6,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1797 || (_circle1797 = /*#__PURE__*/React.createElement("circle", {
    cx: 616.8,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1798 || (_circle1798 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.1,
    cy: 82,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1799 || (_circle1799 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.5,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1800 || (_circle1800 = /*#__PURE__*/React.createElement("circle", {
    cx: 602.9,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1801 || (_circle1801 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.3,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1802 || (_circle1802 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.7,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1803 || (_circle1803 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.2,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1804 || (_circle1804 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.6,
    cy: 70.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1805 || (_circle1805 = /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1806 || (_circle1806 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.3,
    cy: 66.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1807 || (_circle1807 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.6,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1808 || (_circle1808 = /*#__PURE__*/React.createElement("circle", {
    cx: 566,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1809 || (_circle1809 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.3,
    cy: 61.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1810 || (_circle1810 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.6,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1811 || (_circle1811 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.9,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1812 || (_circle1812 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.3,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1813 || (_circle1813 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.3,
    cy: 55.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1814 || (_circle1814 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.4,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1815 || (_circle1815 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1816 || (_circle1816 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.5,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1817 || (_circle1817 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.6,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1818 || (_circle1818 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.7,
    cy: 51.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1819 || (_circle1819 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.8,
    cy: 50.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1820 || (_circle1820 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.8,
    cy: 50,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1821 || (_circle1821 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.9,
    cy: 49.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1822 || (_circle1822 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.9,
    cy: 49.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1823 || (_circle1823 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.9,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1824 || (_circle1824 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.9,
    cy: 50.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1825 || (_circle1825 = /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 50.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1826 || (_circle1826 = /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1827 || (_circle1827 = /*#__PURE__*/React.createElement("circle", {
    cx: 473,
    cy: 50.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1828 || (_circle1828 = /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 51,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1829 || (_circle1829 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 51.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1830 || (_circle1830 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.1,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1831 || (_circle1831 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.2,
    cy: 52.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1832 || (_circle1832 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.2,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1833 || (_circle1833 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.3,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1834 || (_circle1834 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.4,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1835 || (_circle1835 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.5,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1836 || (_circle1836 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.6,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1837 || (_circle1837 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.7,
    cy: 57.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1838 || (_circle1838 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1839 || (_circle1839 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.9,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1840 || (_circle1840 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1841 || (_circle1841 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.2,
    cy: 61.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1842 || (_circle1842 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.3,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1843 || (_circle1843 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.5,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1844 || (_circle1844 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.6,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1845 || (_circle1845 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.7,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1846 || (_circle1846 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.9,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1847 || (_circle1847 = /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1848 || (_circle1848 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.2,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1849 || (_circle1849 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.3,
    cy: 71,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1850 || (_circle1850 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.5,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1851 || (_circle1851 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.6,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1852 || (_circle1852 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.7,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1853 || (_circle1853 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.9,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1854 || (_circle1854 = /*#__PURE__*/React.createElement("circle", {
    cx: 341,
    cy: 76.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1855 || (_circle1855 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.2,
    cy: 77.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1856 || (_circle1856 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.3,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1857 || (_circle1857 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.4,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1858 || (_circle1858 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1859 || (_circle1859 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.6,
    cy: 81.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1860 || (_circle1860 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.7,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1861 || (_circle1861 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.7,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1862 || (_circle1862 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.8,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1863 || (_circle1863 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.9,
    cy: 84.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1864 || (_circle1864 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1865 || (_circle1865 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.1,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1866 || (_circle1866 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.1,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1867 || (_circle1867 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.1,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1868 || (_circle1868 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.1,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1869 || (_circle1869 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.2,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1870 || (_circle1870 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.2,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1871 || (_circle1871 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.2,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1872 || (_circle1872 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.2,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1873 || (_circle1873 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.2,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1874 || (_circle1874 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.2,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1875 || (_circle1875 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.3,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1876 || (_circle1876 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.3,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1877 || (_circle1877 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.3,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1878 || (_circle1878 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1879 || (_circle1879 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.4,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1880 || (_circle1880 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.4,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1881 || (_circle1881 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.4,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1882 || (_circle1882 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.4,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1883 || (_circle1883 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1884 || (_circle1884 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1885 || (_circle1885 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1886 || (_circle1886 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1887 || (_circle1887 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.6,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1888 || (_circle1888 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.6,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1889 || (_circle1889 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.7,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1890 || (_circle1890 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.7,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1891 || (_circle1891 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.8,
    cy: 83,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1892 || (_circle1892 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.8,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1893 || (_circle1893 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.9,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1894 || (_circle1894 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1895 || (_circle1895 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1896 || (_circle1896 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.1,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1897 || (_circle1897 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.1,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1898 || (_circle1898 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.2,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1899 || (_circle1899 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.2,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1900 || (_circle1900 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.3,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1901 || (_circle1901 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.3,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1902 || (_circle1902 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.4,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1903 || (_circle1903 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1904 || (_circle1904 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1905 || (_circle1905 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1906 || (_circle1906 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.6,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1907 || (_circle1907 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.6,
    cy: 73.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1908 || (_circle1908 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.6,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1909 || (_circle1909 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.6,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1910 || (_circle1910 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1911 || (_circle1911 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1912 || (_circle1912 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7,
    cy: 72.3,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1913 || (_circle1913 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1914 || (_circle1914 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1915 || (_circle1915 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.7,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1916 || (_circle1916 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.8,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1917 || (_circle1917 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1918 || (_circle1918 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1919 || (_circle1919 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1920 || (_circle1920 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1921 || (_circle1921 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.9,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1922 || (_circle1922 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st8"
  })), _circle1923 || (_circle1923 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1924 || (_circle1924 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.1,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1925 || (_circle1925 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.1,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1926 || (_circle1926 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.1,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1927 || (_circle1927 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.1,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1928 || (_circle1928 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.1,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1929 || (_circle1929 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.1,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1930 || (_circle1930 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009.1,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1931 || (_circle1931 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004.1,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1932 || (_circle1932 = /*#__PURE__*/React.createElement("circle", {
    cx: 999.2,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1933 || (_circle1933 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.2,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1934 || (_circle1934 = /*#__PURE__*/React.createElement("circle", {
    cx: 989.3,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1935 || (_circle1935 = /*#__PURE__*/React.createElement("circle", {
    cx: 984.4,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1936 || (_circle1936 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.4,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1937 || (_circle1937 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.5,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1938 || (_circle1938 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.6,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1939 || (_circle1939 = /*#__PURE__*/React.createElement("circle", {
    cx: 964.7,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1940 || (_circle1940 = /*#__PURE__*/React.createElement("circle", {
    cx: 959.8,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1941 || (_circle1941 = /*#__PURE__*/React.createElement("circle", {
    cx: 954.8,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1942 || (_circle1942 = /*#__PURE__*/React.createElement("circle", {
    cx: 949.9,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1943 || (_circle1943 = /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1944 || (_circle1944 = /*#__PURE__*/React.createElement("circle", {
    cx: 940.1,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1945 || (_circle1945 = /*#__PURE__*/React.createElement("circle", {
    cx: 935.2,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1946 || (_circle1946 = /*#__PURE__*/React.createElement("circle", {
    cx: 930.3,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1947 || (_circle1947 = /*#__PURE__*/React.createElement("circle", {
    cx: 925.4,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1948 || (_circle1948 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.5,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1949 || (_circle1949 = /*#__PURE__*/React.createElement("circle", {
    cx: 915.6,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1950 || (_circle1950 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.7,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1951 || (_circle1951 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.8,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1952 || (_circle1952 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.9,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1953 || (_circle1953 = /*#__PURE__*/React.createElement("circle", {
    cx: 896,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1954 || (_circle1954 = /*#__PURE__*/React.createElement("circle", {
    cx: 891.1,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1955 || (_circle1955 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.2,
    cy: 67.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1956 || (_circle1956 = /*#__PURE__*/React.createElement("circle", {
    cx: 881.2,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1957 || (_circle1957 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.3,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1958 || (_circle1958 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.4,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1959 || (_circle1959 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.5,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1960 || (_circle1960 = /*#__PURE__*/React.createElement("circle", {
    cx: 861.5,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1961 || (_circle1961 = /*#__PURE__*/React.createElement("circle", {
    cx: 856.5,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1962 || (_circle1962 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.5,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1963 || (_circle1963 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.6,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1964 || (_circle1964 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.6,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1965 || (_circle1965 = /*#__PURE__*/React.createElement("circle", {
    cx: 836.6,
    cy: 62.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1966 || (_circle1966 = /*#__PURE__*/React.createElement("circle", {
    cx: 831.6,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1967 || (_circle1967 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.7,
    cy: 63.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1968 || (_circle1968 = /*#__PURE__*/React.createElement("circle", {
    cx: 821.8,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1969 || (_circle1969 = /*#__PURE__*/React.createElement("circle", {
    cx: 816.9,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1970 || (_circle1970 = /*#__PURE__*/React.createElement("circle", {
    cx: 812,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1971 || (_circle1971 = /*#__PURE__*/React.createElement("circle", {
    cx: 807.1,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1972 || (_circle1972 = /*#__PURE__*/React.createElement("circle", {
    cx: 802.1,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1973 || (_circle1973 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.2,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1974 || (_circle1974 = /*#__PURE__*/React.createElement("circle", {
    cx: 792.3,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1975 || (_circle1975 = /*#__PURE__*/React.createElement("circle", {
    cx: 787.4,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1976 || (_circle1976 = /*#__PURE__*/React.createElement("circle", {
    cx: 782.5,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1977 || (_circle1977 = /*#__PURE__*/React.createElement("circle", {
    cx: 777.7,
    cy: 73.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1978 || (_circle1978 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.9,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1979 || (_circle1979 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.1,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1980 || (_circle1980 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.2,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1981 || (_circle1981 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.4,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1982 || (_circle1982 = /*#__PURE__*/React.createElement("circle", {
    cx: 753.6,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1983 || (_circle1983 = /*#__PURE__*/React.createElement("circle", {
    cx: 748.7,
    cy: 80.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1984 || (_circle1984 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.9,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1985 || (_circle1985 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.1,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1986 || (_circle1986 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.2,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1987 || (_circle1987 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.3,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1988 || (_circle1988 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.4,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1989 || (_circle1989 = /*#__PURE__*/React.createElement("circle", {
    cx: 719.5,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1990 || (_circle1990 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.6,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1991 || (_circle1991 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.7,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1992 || (_circle1992 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.8,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1993 || (_circle1993 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1994 || (_circle1994 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.1,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1995 || (_circle1995 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.2,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1996 || (_circle1996 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.2,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1997 || (_circle1997 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.2,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1998 || (_circle1998 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.2,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle1999 || (_circle1999 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.2,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2000 || (_circle2000 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.2,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2001 || (_circle2001 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.2,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2002 || (_circle2002 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.2,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2003 || (_circle2003 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.3,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2004 || (_circle2004 = /*#__PURE__*/React.createElement("circle", {
    cx: 645.3,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2005 || (_circle2005 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2006 || (_circle2006 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.6,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2007 || (_circle2007 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.7,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2008 || (_circle2008 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.9,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2009 || (_circle2009 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.1,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2010 || (_circle2010 = /*#__PURE__*/React.createElement("circle", {
    cx: 616.3,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2011 || (_circle2011 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.5,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2012 || (_circle2012 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.6,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2013 || (_circle2013 = /*#__PURE__*/React.createElement("circle", {
    cx: 602.1,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2014 || (_circle2014 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.5,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2015 || (_circle2015 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.9,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2016 || (_circle2016 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.3,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2017 || (_circle2017 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.8,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2018 || (_circle2018 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.2,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2019 || (_circle2019 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.6,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2020 || (_circle2020 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 68,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2021 || (_circle2021 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.3,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2022 || (_circle2022 = /*#__PURE__*/React.createElement("circle", {
    cx: 560.7,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2023 || (_circle2023 = /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2024 || (_circle2024 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.3,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2025 || (_circle2025 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.7,
    cy: 59.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2026 || (_circle2026 = /*#__PURE__*/React.createElement("circle", {
    cx: 542,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2027 || (_circle2027 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.3,
    cy: 55.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2028 || (_circle2028 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2029 || (_circle2029 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.6,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2030 || (_circle2030 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.6,
    cy: 53,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2031 || (_circle2031 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.7,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2032 || (_circle2032 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.8,
    cy: 51.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2033 || (_circle2033 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.9,
    cy: 50.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2034 || (_circle2034 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.9,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2035 || (_circle2035 = /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 49.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2036 || (_circle2036 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.1,
    cy: 48.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2037 || (_circle2037 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.1,
    cy: 48.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2038 || (_circle2038 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.1,
    cy: 48.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2039 || (_circle2039 = /*#__PURE__*/React.createElement("circle", {
    cx: 478.1,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2040 || (_circle2040 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.1,
    cy: 49.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2041 || (_circle2041 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.2,
    cy: 49.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2042 || (_circle2042 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.2,
    cy: 49.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2043 || (_circle2043 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.2,
    cy: 49.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2044 || (_circle2044 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.2,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2045 || (_circle2045 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.2,
    cy: 50.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2046 || (_circle2046 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.3,
    cy: 51.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2047 || (_circle2047 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.4,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2048 || (_circle2048 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.5,
    cy: 52.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2049 || (_circle2049 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.6,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2050 || (_circle2050 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.7,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2051 || (_circle2051 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.7,
    cy: 55.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2052 || (_circle2052 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.8,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2053 || (_circle2053 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.9,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2054 || (_circle2054 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2055 || (_circle2055 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.2,
    cy: 59.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2056 || (_circle2056 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.3,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2057 || (_circle2057 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.5,
    cy: 61.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2058 || (_circle2058 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.6,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2059 || (_circle2059 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.7,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2060 || (_circle2060 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.9,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2061 || (_circle2061 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2062 || (_circle2062 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.2,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2063 || (_circle2063 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.3,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2064 || (_circle2064 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.5,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2065 || (_circle2065 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.6,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2066 || (_circle2066 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.8,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2067 || (_circle2067 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.9,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2068 || (_circle2068 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.1,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2069 || (_circle2069 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.2,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2070 || (_circle2070 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.4,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2071 || (_circle2071 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 77.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2072 || (_circle2072 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.6,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2073 || (_circle2073 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.7,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2074 || (_circle2074 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.8,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2075 || (_circle2075 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.9,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2076 || (_circle2076 = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2077 || (_circle2077 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.1,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2078 || (_circle2078 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.2,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2079 || (_circle2079 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.3,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2080 || (_circle2080 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.4,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2081 || (_circle2081 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.4,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2082 || (_circle2082 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.4,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2083 || (_circle2083 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.4,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2084 || (_circle2084 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2085 || (_circle2085 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2086 || (_circle2086 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2087 || (_circle2087 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.6,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2088 || (_circle2088 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.6,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2089 || (_circle2089 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.6,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2090 || (_circle2090 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.6,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2091 || (_circle2091 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.7,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2092 || (_circle2092 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.7,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2093 || (_circle2093 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.7,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2094 || (_circle2094 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.7,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2095 || (_circle2095 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.7,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2096 || (_circle2096 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.8,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2097 || (_circle2097 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.8,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2098 || (_circle2098 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.8,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2099 || (_circle2099 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.8,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2100 || (_circle2100 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.8,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2101 || (_circle2101 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.9,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2102 || (_circle2102 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.9,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2103 || (_circle2103 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.9,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2104 || (_circle2104 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2105 || (_circle2105 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2106 || (_circle2106 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.1,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2107 || (_circle2107 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.1,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2108 || (_circle2108 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.2,
    cy: 83.5,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2109 || (_circle2109 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.2,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2110 || (_circle2110 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.3,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2111 || (_circle2111 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.3,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2112 || (_circle2112 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.4,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2113 || (_circle2113 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.4,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2114 || (_circle2114 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2115 || (_circle2115 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2116 || (_circle2116 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.6,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2117 || (_circle2117 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2118 || (_circle2118 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2119 || (_circle2119 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.7,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2120 || (_circle2120 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2121 || (_circle2121 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.8,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2122 || (_circle2122 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.8,
    cy: 75.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2123 || (_circle2123 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2124 || (_circle2124 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2125 || (_circle2125 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2126 || (_circle2126 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2127 || (_circle2127 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2128 || (_circle2128 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2129 || (_circle2129 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2130 || (_circle2130 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2131 || (_circle2131 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2132 || (_circle2132 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2133 || (_circle2133 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2134 || (_circle2134 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2135 || (_circle2135 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st9"
  })), _circle2136 || (_circle2136 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042.8,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2137 || (_circle2137 = /*#__PURE__*/React.createElement("circle", {
    cx: 1037.8,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2138 || (_circle2138 = /*#__PURE__*/React.createElement("circle", {
    cx: 1032.9,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2139 || (_circle2139 = /*#__PURE__*/React.createElement("circle", {
    cx: 1027.9,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2140 || (_circle2140 = /*#__PURE__*/React.createElement("circle", {
    cx: 1022.9,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2141 || (_circle2141 = /*#__PURE__*/React.createElement("circle", {
    cx: 1017.9,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2142 || (_circle2142 = /*#__PURE__*/React.createElement("circle", {
    cx: 1012.9,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2143 || (_circle2143 = /*#__PURE__*/React.createElement("circle", {
    cx: 1007.9,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2144 || (_circle2144 = /*#__PURE__*/React.createElement("circle", {
    cx: 1002.9,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2145 || (_circle2145 = /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2146 || (_circle2146 = /*#__PURE__*/React.createElement("circle", {
    cx: 993,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2147 || (_circle2147 = /*#__PURE__*/React.createElement("circle", {
    cx: 988.1,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2148 || (_circle2148 = /*#__PURE__*/React.createElement("circle", {
    cx: 983.1,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2149 || (_circle2149 = /*#__PURE__*/React.createElement("circle", {
    cx: 978.2,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2150 || (_circle2150 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.3,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2151 || (_circle2151 = /*#__PURE__*/React.createElement("circle", {
    cx: 968.3,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2152 || (_circle2152 = /*#__PURE__*/React.createElement("circle", {
    cx: 963.4,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2153 || (_circle2153 = /*#__PURE__*/React.createElement("circle", {
    cx: 958.5,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2154 || (_circle2154 = /*#__PURE__*/React.createElement("circle", {
    cx: 953.5,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2155 || (_circle2155 = /*#__PURE__*/React.createElement("circle", {
    cx: 948.6,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2156 || (_circle2156 = /*#__PURE__*/React.createElement("circle", {
    cx: 943.7,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2157 || (_circle2157 = /*#__PURE__*/React.createElement("circle", {
    cx: 938.8,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2158 || (_circle2158 = /*#__PURE__*/React.createElement("circle", {
    cx: 933.9,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2159 || (_circle2159 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2160 || (_circle2160 = /*#__PURE__*/React.createElement("circle", {
    cx: 924.1,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2161 || (_circle2161 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.3,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2162 || (_circle2162 = /*#__PURE__*/React.createElement("circle", {
    cx: 914.4,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2163 || (_circle2163 = /*#__PURE__*/React.createElement("circle", {
    cx: 909.5,
    cy: 73.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2164 || (_circle2164 = /*#__PURE__*/React.createElement("circle", {
    cx: 904.6,
    cy: 72.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2165 || (_circle2165 = /*#__PURE__*/React.createElement("circle", {
    cx: 899.7,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2166 || (_circle2166 = /*#__PURE__*/React.createElement("circle", {
    cx: 894.8,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2167 || (_circle2167 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.9,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2168 || (_circle2168 = /*#__PURE__*/React.createElement("circle", {
    cx: 885.1,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2169 || (_circle2169 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.2,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2170 || (_circle2170 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.3,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2171 || (_circle2171 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.4,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2172 || (_circle2172 = /*#__PURE__*/React.createElement("circle", {
    cx: 865.5,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2173 || (_circle2173 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.6,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2174 || (_circle2174 = /*#__PURE__*/React.createElement("circle", {
    cx: 855.6,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2175 || (_circle2175 = /*#__PURE__*/React.createElement("circle", {
    cx: 850.6,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2176 || (_circle2176 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.7,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2177 || (_circle2177 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.7,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2178 || (_circle2178 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.7,
    cy: 61.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2179 || (_circle2179 = /*#__PURE__*/React.createElement("circle", {
    cx: 830.8,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2180 || (_circle2180 = /*#__PURE__*/React.createElement("circle", {
    cx: 825.8,
    cy: 61.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2181 || (_circle2181 = /*#__PURE__*/React.createElement("circle", {
    cx: 820.9,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2182 || (_circle2182 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.9,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2183 || (_circle2183 = /*#__PURE__*/React.createElement("circle", {
    cx: 811,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2184 || (_circle2184 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.1,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2185 || (_circle2185 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.1,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2186 || (_circle2186 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.2,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2187 || (_circle2187 = /*#__PURE__*/React.createElement("circle", {
    cx: 791.3,
    cy: 66.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2188 || (_circle2188 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.4,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2189 || (_circle2189 = /*#__PURE__*/React.createElement("circle", {
    cx: 781.6,
    cy: 69.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2190 || (_circle2190 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.8,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2191 || (_circle2191 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.9,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2192 || (_circle2192 = /*#__PURE__*/React.createElement("circle", {
    cx: 767.1,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2193 || (_circle2193 = /*#__PURE__*/React.createElement("circle", {
    cx: 762.2,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2194 || (_circle2194 = /*#__PURE__*/React.createElement("circle", {
    cx: 757.4,
    cy: 75.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2195 || (_circle2195 = /*#__PURE__*/React.createElement("circle", {
    cx: 752.6,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2196 || (_circle2196 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.8,
    cy: 77.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2197 || (_circle2197 = /*#__PURE__*/React.createElement("circle", {
    cx: 742.9,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2198 || (_circle2198 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.1,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2199 || (_circle2199 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.3,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2200 || (_circle2200 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.5,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2201 || (_circle2201 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2202 || (_circle2202 = /*#__PURE__*/React.createElement("circle", {
    cx: 718.9,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2203 || (_circle2203 = /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2204 || (_circle2204 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.1,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2205 || (_circle2205 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.2,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2206 || (_circle2206 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.3,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2207 || (_circle2207 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.4,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2208 || (_circle2208 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.5,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2209 || (_circle2209 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.6,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2210 || (_circle2210 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.7,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2211 || (_circle2211 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.8,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2212 || (_circle2212 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.8,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2213 || (_circle2213 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.8,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2214 || (_circle2214 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.8,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2215 || (_circle2215 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.9,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2216 || (_circle2216 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.9,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2217 || (_circle2217 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.9,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2218 || (_circle2218 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.9,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2219 || (_circle2219 = /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2220 || (_circle2220 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.1,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2221 || (_circle2221 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.3,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2222 || (_circle2222 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.5,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2223 || (_circle2223 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.6,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2224 || (_circle2224 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.8,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2225 || (_circle2225 = /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2226 || (_circle2226 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.2,
    cy: 85.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2227 || (_circle2227 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.5,
    cy: 83.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2228 || (_circle2228 = /*#__PURE__*/React.createElement("circle", {
    cx: 591.9,
    cy: 81.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2229 || (_circle2229 = /*#__PURE__*/React.createElement("circle", {
    cx: 587.3,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2230 || (_circle2230 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.8,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2231 || (_circle2231 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.2,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2232 || (_circle2232 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.6,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2233 || (_circle2233 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2234 || (_circle2234 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.5,
    cy: 69.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2235 || (_circle2235 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.8,
    cy: 67.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2236 || (_circle2236 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.2,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2237 || (_circle2237 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.5,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2238 || (_circle2238 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.9,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2239 || (_circle2239 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.2,
    cy: 60.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2240 || (_circle2240 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.6,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2241 || (_circle2241 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.9,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2242 || (_circle2242 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.3,
    cy: 55.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2243 || (_circle2243 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.5,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2244 || (_circle2244 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.5,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2245 || (_circle2245 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.6,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2246 || (_circle2246 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.7,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2247 || (_circle2247 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.7,
    cy: 51.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2248 || (_circle2248 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.8,
    cy: 50.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2249 || (_circle2249 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.8,
    cy: 49.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2250 || (_circle2250 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.9,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2251 || (_circle2251 = /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 48.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2252 || (_circle2252 = /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 47.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2253 || (_circle2253 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.1,
    cy: 47.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2254 || (_circle2254 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.1,
    cy: 47.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2255 || (_circle2255 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.1,
    cy: 48,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2256 || (_circle2256 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.2,
    cy: 48.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2257 || (_circle2257 = /*#__PURE__*/React.createElement("circle", {
    cx: 453.2,
    cy: 48.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2258 || (_circle2258 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.2,
    cy: 49.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2259 || (_circle2259 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.2,
    cy: 49.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2260 || (_circle2260 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.3,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2261 || (_circle2261 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.3,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2262 || (_circle2262 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.3,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2263 || (_circle2263 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.3,
    cy: 51.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2264 || (_circle2264 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.5,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2265 || (_circle2265 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.6,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2266 || (_circle2266 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.7,
    cy: 54.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2267 || (_circle2267 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.8,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2268 || (_circle2268 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.9,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2269 || (_circle2269 = /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 57.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2270 || (_circle2270 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.1,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2271 || (_circle2271 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.3,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2272 || (_circle2272 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.4,
    cy: 60.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2273 || (_circle2273 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.5,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2274 || (_circle2274 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.6,
    cy: 62.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2275 || (_circle2275 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.8,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2276 || (_circle2276 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 64.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2277 || (_circle2277 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.1,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2278 || (_circle2278 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.3,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2279 || (_circle2279 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.4,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2280 || (_circle2280 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.6,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2281 || (_circle2281 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.8,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2282 || (_circle2282 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.9,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2283 || (_circle2283 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.1,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2284 || (_circle2284 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.2,
    cy: 74.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2285 || (_circle2285 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.3,
    cy: 75.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2286 || (_circle2286 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.5,
    cy: 76.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2287 || (_circle2287 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.6,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2288 || (_circle2288 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.7,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2289 || (_circle2289 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.8,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2290 || (_circle2290 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.9,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2291 || (_circle2291 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2292 || (_circle2292 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.1,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2293 || (_circle2293 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.3,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2294 || (_circle2294 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.4,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2295 || (_circle2295 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.4,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2296 || (_circle2296 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2297 || (_circle2297 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2298 || (_circle2298 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.6,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2299 || (_circle2299 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.6,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2300 || (_circle2300 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.6,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2301 || (_circle2301 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.7,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2302 || (_circle2302 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.7,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2303 || (_circle2303 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.8,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2304 || (_circle2304 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.8,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2305 || (_circle2305 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.9,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2306 || (_circle2306 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.9,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2307 || (_circle2307 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.9,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2308 || (_circle2308 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.9,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2309 || (_circle2309 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.9,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2310 || (_circle2310 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.9,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2311 || (_circle2311 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2312 || (_circle2312 = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2313 || (_circle2313 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2314 || (_circle2314 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2315 || (_circle2315 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2316 || (_circle2316 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2317 || (_circle2317 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2318 || (_circle2318 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.1,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2319 || (_circle2319 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.1,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2320 || (_circle2320 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.2,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2321 || (_circle2321 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.2,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2322 || (_circle2322 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.3,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2323 || (_circle2323 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.3,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2324 || (_circle2324 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.4,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2325 || (_circle2325 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.4,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2326 || (_circle2326 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2327 || (_circle2327 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2328 || (_circle2328 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.6,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2329 || (_circle2329 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.6,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2330 || (_circle2330 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.7,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2331 || (_circle2331 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2332 || (_circle2332 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.8,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2333 || (_circle2333 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2334 || (_circle2334 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2335 || (_circle2335 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2336 || (_circle2336 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2337 || (_circle2337 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2338 || (_circle2338 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 76.9,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2339 || (_circle2339 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.1,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2340 || (_circle2340 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2341 || (_circle2341 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2342 || (_circle2342 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2343 || (_circle2343 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2344 || (_circle2344 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2345 || (_circle2345 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2346 || (_circle2346 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2347 || (_circle2347 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2348 || (_circle2348 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.2,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st10"
  })), _circle2349 || (_circle2349 = /*#__PURE__*/React.createElement("circle", {
    cx: 1041.2,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2350 || (_circle2350 = /*#__PURE__*/React.createElement("circle", {
    cx: 1036.2,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2351 || (_circle2351 = /*#__PURE__*/React.createElement("circle", {
    cx: 1031.2,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2352 || (_circle2352 = /*#__PURE__*/React.createElement("circle", {
    cx: 1026.2,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2353 || (_circle2353 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.2,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2354 || (_circle2354 = /*#__PURE__*/React.createElement("circle", {
    cx: 1016.2,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2355 || (_circle2355 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.3,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2356 || (_circle2356 = /*#__PURE__*/React.createElement("circle", {
    cx: 1006.3,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2357 || (_circle2357 = /*#__PURE__*/React.createElement("circle", {
    cx: 1001.3,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2358 || (_circle2358 = /*#__PURE__*/React.createElement("circle", {
    cx: 996.3,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2359 || (_circle2359 = /*#__PURE__*/React.createElement("circle", {
    cx: 991.3,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2360 || (_circle2360 = /*#__PURE__*/React.createElement("circle", {
    cx: 986.4,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2361 || (_circle2361 = /*#__PURE__*/React.createElement("circle", {
    cx: 981.5,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2362 || (_circle2362 = /*#__PURE__*/React.createElement("circle", {
    cx: 976.5,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2363 || (_circle2363 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.6,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2364 || (_circle2364 = /*#__PURE__*/React.createElement("circle", {
    cx: 966.6,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2365 || (_circle2365 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.7,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2366 || (_circle2366 = /*#__PURE__*/React.createElement("circle", {
    cx: 956.8,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2367 || (_circle2367 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.8,
    cy: 83.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2368 || (_circle2368 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.9,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2369 || (_circle2369 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2370 || (_circle2370 = /*#__PURE__*/React.createElement("circle", {
    cx: 937.1,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2371 || (_circle2371 = /*#__PURE__*/React.createElement("circle", {
    cx: 932.2,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2372 || (_circle2372 = /*#__PURE__*/React.createElement("circle", {
    cx: 927.3,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2373 || (_circle2373 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.5,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2374 || (_circle2374 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.6,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2375 || (_circle2375 = /*#__PURE__*/React.createElement("circle", {
    cx: 912.7,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2376 || (_circle2376 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.8,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2377 || (_circle2377 = /*#__PURE__*/React.createElement("circle", {
    cx: 903,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2378 || (_circle2378 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.1,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2379 || (_circle2379 = /*#__PURE__*/React.createElement("circle", {
    cx: 893.2,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2380 || (_circle2380 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.4,
    cy: 70.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2381 || (_circle2381 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.5,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2382 || (_circle2382 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.7,
    cy: 68,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2383 || (_circle2383 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.8,
    cy: 66.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2384 || (_circle2384 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 65.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2385 || (_circle2385 = /*#__PURE__*/React.createElement("circle", {
    cx: 864.1,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2386 || (_circle2386 = /*#__PURE__*/React.createElement("circle", {
    cx: 859.3,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2387 || (_circle2387 = /*#__PURE__*/React.createElement("circle", {
    cx: 854.3,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2388 || (_circle2388 = /*#__PURE__*/React.createElement("circle", {
    cx: 849.4,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2389 || (_circle2389 = /*#__PURE__*/React.createElement("circle", {
    cx: 844.4,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2390 || (_circle2390 = /*#__PURE__*/React.createElement("circle", {
    cx: 839.5,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2391 || (_circle2391 = /*#__PURE__*/React.createElement("circle", {
    cx: 834.5,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2392 || (_circle2392 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.6,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2393 || (_circle2393 = /*#__PURE__*/React.createElement("circle", {
    cx: 824.6,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2394 || (_circle2394 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.7,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2395 || (_circle2395 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.7,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2396 || (_circle2396 = /*#__PURE__*/React.createElement("circle", {
    cx: 809.8,
    cy: 61.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2397 || (_circle2397 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.8,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2398 || (_circle2398 = /*#__PURE__*/React.createElement("circle", {
    cx: 799.9,
    cy: 62.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2399 || (_circle2399 = /*#__PURE__*/React.createElement("circle", {
    cx: 794.9,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2400 || (_circle2400 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2401 || (_circle2401 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.1,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2402 || (_circle2402 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.3,
    cy: 66.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2403 || (_circle2403 = /*#__PURE__*/React.createElement("circle", {
    cx: 775.4,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2404 || (_circle2404 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.6,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2405 || (_circle2405 = /*#__PURE__*/React.createElement("circle", {
    cx: 765.8,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2406 || (_circle2406 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.9,
    cy: 71.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2407 || (_circle2407 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.1,
    cy: 72.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2408 || (_circle2408 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.3,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2409 || (_circle2409 = /*#__PURE__*/React.createElement("circle", {
    cx: 746.5,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2410 || (_circle2410 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.7,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2411 || (_circle2411 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.9,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2412 || (_circle2412 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.1,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2413 || (_circle2413 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.3,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2414 || (_circle2414 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.5,
    cy: 82,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2415 || (_circle2415 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.7,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2416 || (_circle2416 = /*#__PURE__*/React.createElement("circle", {
    cx: 712.9,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2417 || (_circle2417 = /*#__PURE__*/React.createElement("circle", {
    cx: 708.1,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2418 || (_circle2418 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.2,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2419 || (_circle2419 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.4,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2420 || (_circle2420 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.5,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2421 || (_circle2421 = /*#__PURE__*/React.createElement("circle", {
    cx: 688.6,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2422 || (_circle2422 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.7,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2423 || (_circle2423 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.9,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2424 || (_circle2424 = /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2425 || (_circle2425 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.1,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2426 || (_circle2426 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.1,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2427 || (_circle2427 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.1,
    cy: 94.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2428 || (_circle2428 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.1,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2429 || (_circle2429 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.1,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2430 || (_circle2430 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.1,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2431 || (_circle2431 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.2,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2432 || (_circle2432 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.2,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2433 || (_circle2433 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.2,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2434 || (_circle2434 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.4,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2435 || (_circle2435 = /*#__PURE__*/React.createElement("circle", {
    cx: 619.6,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2436 || (_circle2436 = /*#__PURE__*/React.createElement("circle", {
    cx: 614.7,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2437 || (_circle2437 = /*#__PURE__*/React.createElement("circle", {
    cx: 609.9,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2438 || (_circle2438 = /*#__PURE__*/React.createElement("circle", {
    cx: 605,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2439 || (_circle2439 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.2,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2440 || (_circle2440 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.4,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2441 || (_circle2441 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.6,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2442 || (_circle2442 = /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2443 || (_circle2443 = /*#__PURE__*/React.createElement("circle", {
    cx: 581.4,
    cy: 81.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2444 || (_circle2444 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.9,
    cy: 79.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2445 || (_circle2445 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.3,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2446 || (_circle2446 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.7,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2447 || (_circle2447 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.2,
    cy: 73.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2448 || (_circle2448 = /*#__PURE__*/React.createElement("circle", {
    cx: 558.6,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2449 || (_circle2449 = /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 69.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2450 || (_circle2450 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.4,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2451 || (_circle2451 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.8,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2452 || (_circle2452 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.1,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2453 || (_circle2453 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.5,
    cy: 61.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2454 || (_circle2454 = /*#__PURE__*/React.createElement("circle", {
    cx: 530.8,
    cy: 60,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2455 || (_circle2455 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.2,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2456 || (_circle2456 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.5,
    cy: 56.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2457 || (_circle2457 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.9,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2458 || (_circle2458 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.1,
    cy: 53,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2459 || (_circle2459 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.2,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2460 || (_circle2460 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.3,
    cy: 51.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2461 || (_circle2461 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.3,
    cy: 50.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2462 || (_circle2462 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.4,
    cy: 50.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2463 || (_circle2463 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.5,
    cy: 49.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2464 || (_circle2464 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.5,
    cy: 48.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2465 || (_circle2465 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.6,
    cy: 48,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2466 || (_circle2466 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.6,
    cy: 47.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2467 || (_circle2467 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.7,
    cy: 46.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2468 || (_circle2468 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.8,
    cy: 46.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2469 || (_circle2469 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.8,
    cy: 46.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2470 || (_circle2470 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.8,
    cy: 46.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2471 || (_circle2471 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.8,
    cy: 47.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2472 || (_circle2472 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.9,
    cy: 47.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2473 || (_circle2473 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.9,
    cy: 47.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2474 || (_circle2474 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.9,
    cy: 48.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2475 || (_circle2475 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.9,
    cy: 48.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2476 || (_circle2476 = /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2477 || (_circle2477 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 49.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2478 || (_circle2478 = /*#__PURE__*/React.createElement("circle", {
    cx: 413,
    cy: 49.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2479 || (_circle2479 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.1,
    cy: 50.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2480 || (_circle2480 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.3,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2481 || (_circle2481 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.4,
    cy: 52.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2482 || (_circle2482 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.5,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2483 || (_circle2483 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.6,
    cy: 54.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2484 || (_circle2484 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.7,
    cy: 55.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2485 || (_circle2485 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.8,
    cy: 56.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2486 || (_circle2486 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.9,
    cy: 57.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2487 || (_circle2487 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2488 || (_circle2488 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.1,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2489 || (_circle2489 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.3,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2490 || (_circle2490 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.5,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2491 || (_circle2491 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.6,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2492 || (_circle2492 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.8,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2493 || (_circle2493 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2494 || (_circle2494 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.1,
    cy: 67,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2495 || (_circle2495 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.3,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2496 || (_circle2496 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.5,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2497 || (_circle2497 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.6,
    cy: 70.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2498 || (_circle2498 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.8,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2499 || (_circle2499 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.9,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2500 || (_circle2500 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.1,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2501 || (_circle2501 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.2,
    cy: 75.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2502 || (_circle2502 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.3,
    cy: 76.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2503 || (_circle2503 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.5,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2504 || (_circle2504 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.6,
    cy: 78.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2505 || (_circle2505 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.7,
    cy: 79.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2506 || (_circle2506 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.9,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2507 || (_circle2507 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2508 || (_circle2508 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.1,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2509 || (_circle2509 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.2,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2510 || (_circle2510 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.3,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2511 || (_circle2511 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.4,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2512 || (_circle2512 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.4,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2513 || (_circle2513 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2514 || (_circle2514 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2515 || (_circle2515 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.6,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2516 || (_circle2516 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.7,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2517 || (_circle2517 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.7,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2518 || (_circle2518 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.8,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2519 || (_circle2519 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.8,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2520 || (_circle2520 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.9,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2521 || (_circle2521 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.9,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2522 || (_circle2522 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.9,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2523 || (_circle2523 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.9,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2524 || (_circle2524 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2525 || (_circle2525 = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2526 || (_circle2526 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2527 || (_circle2527 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2528 || (_circle2528 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2529 || (_circle2529 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2530 || (_circle2530 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2531 || (_circle2531 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2532 || (_circle2532 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.1,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2533 || (_circle2533 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.1,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2534 || (_circle2534 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.2,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2535 || (_circle2535 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.2,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2536 || (_circle2536 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.2,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2537 || (_circle2537 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.3,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2538 || (_circle2538 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.3,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2539 || (_circle2539 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.4,
    cy: 87.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2540 || (_circle2540 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.4,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2541 || (_circle2541 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2542 || (_circle2542 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2543 || (_circle2543 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2544 || (_circle2544 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2545 || (_circle2545 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.7,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2546 || (_circle2546 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2547 || (_circle2547 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.8,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2548 || (_circle2548 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.9,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2549 || (_circle2549 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.9,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2550 || (_circle2550 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2551 || (_circle2551 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2552 || (_circle2552 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.1,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2553 || (_circle2553 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2554 || (_circle2554 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.2,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2555 || (_circle2555 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2556 || (_circle2556 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2557 || (_circle2557 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2558 || (_circle2558 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2559 || (_circle2559 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3,
    cy: 75.8,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2560 || (_circle2560 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2561 || (_circle2561 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.3,
    cy: 75.2,
    r: 0.8,
    className: "soundwave_svg__st11"
  })), _circle2562 || (_circle2562 = /*#__PURE__*/React.createElement("circle", {
    cx: 1043.8,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2563 || (_circle2563 = /*#__PURE__*/React.createElement("circle", {
    cx: 1038.9,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2564 || (_circle2564 = /*#__PURE__*/React.createElement("circle", {
    cx: 1033.9,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2565 || (_circle2565 = /*#__PURE__*/React.createElement("circle", {
    cx: 1028.9,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2566 || (_circle2566 = /*#__PURE__*/React.createElement("circle", {
    cx: 1023.9,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2567 || (_circle2567 = /*#__PURE__*/React.createElement("circle", {
    cx: 1018.9,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2568 || (_circle2568 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2569 || (_circle2569 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2570 || (_circle2570 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2571 || (_circle2571 = /*#__PURE__*/React.createElement("circle", {
    cx: 999,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2572 || (_circle2572 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.1,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2573 || (_circle2573 = /*#__PURE__*/React.createElement("circle", {
    cx: 989.1,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2574 || (_circle2574 = /*#__PURE__*/React.createElement("circle", {
    cx: 984.2,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2575 || (_circle2575 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.2,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2576 || (_circle2576 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.3,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2577 || (_circle2577 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.3,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2578 || (_circle2578 = /*#__PURE__*/React.createElement("circle", {
    cx: 964.4,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2579 || (_circle2579 = /*#__PURE__*/React.createElement("circle", {
    cx: 959.4,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2580 || (_circle2580 = /*#__PURE__*/React.createElement("circle", {
    cx: 954.5,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2581 || (_circle2581 = /*#__PURE__*/React.createElement("circle", {
    cx: 949.5,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2582 || (_circle2582 = /*#__PURE__*/React.createElement("circle", {
    cx: 944.6,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2583 || (_circle2583 = /*#__PURE__*/React.createElement("circle", {
    cx: 939.6,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2584 || (_circle2584 = /*#__PURE__*/React.createElement("circle", {
    cx: 934.8,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2585 || (_circle2585 = /*#__PURE__*/React.createElement("circle", {
    cx: 929.9,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2586 || (_circle2586 = /*#__PURE__*/React.createElement("circle", {
    cx: 925.1,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2587 || (_circle2587 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.2,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2588 || (_circle2588 = /*#__PURE__*/React.createElement("circle", {
    cx: 915.3,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2589 || (_circle2589 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.5,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2590 || (_circle2590 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.6,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2591 || (_circle2591 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.8,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2592 || (_circle2592 = /*#__PURE__*/React.createElement("circle", {
    cx: 895.9,
    cy: 73.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2593 || (_circle2593 = /*#__PURE__*/React.createElement("circle", {
    cx: 891,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2594 || (_circle2594 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.2,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2595 || (_circle2595 = /*#__PURE__*/React.createElement("circle", {
    cx: 881.4,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2596 || (_circle2596 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.6,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2597 || (_circle2597 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.8,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2598 || (_circle2598 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.9,
    cy: 66.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2599 || (_circle2599 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.1,
    cy: 64.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2600 || (_circle2600 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.3,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2601 || (_circle2601 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.4,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2602 || (_circle2602 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.5,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2603 || (_circle2603 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.6,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2604 || (_circle2604 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.6,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2605 || (_circle2605 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.7,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2606 || (_circle2606 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.8,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2607 || (_circle2607 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.9,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2608 || (_circle2608 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.9,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2609 || (_circle2609 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.9,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2610 || (_circle2610 = /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2611 || (_circle2611 = /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 59.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2612 || (_circle2612 = /*#__PURE__*/React.createElement("circle", {
    cx: 798,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2613 || (_circle2613 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.1,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2614 || (_circle2614 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.1,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2615 || (_circle2615 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.1,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2616 || (_circle2616 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.3,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2617 || (_circle2617 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.5,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2618 || (_circle2618 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.6,
    cy: 65,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2619 || (_circle2619 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.8,
    cy: 66.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2620 || (_circle2620 = /*#__PURE__*/React.createElement("circle", {
    cx: 759,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2621 || (_circle2621 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.2,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2622 || (_circle2622 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.4,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2623 || (_circle2623 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.5,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2624 || (_circle2624 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.8,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2625 || (_circle2625 = /*#__PURE__*/React.createElement("circle", {
    cx: 735,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2626 || (_circle2626 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.3,
    cy: 75.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2627 || (_circle2627 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2628 || (_circle2628 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.8,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2629 || (_circle2629 = /*#__PURE__*/React.createElement("circle", {
    cx: 716,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2630 || (_circle2630 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.3,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2631 || (_circle2631 = /*#__PURE__*/React.createElement("circle", {
    cx: 706.5,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2632 || (_circle2632 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.7,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2633 || (_circle2633 = /*#__PURE__*/React.createElement("circle", {
    cx: 696.9,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2634 || (_circle2634 = /*#__PURE__*/React.createElement("circle", {
    cx: 692,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2635 || (_circle2635 = /*#__PURE__*/React.createElement("circle", {
    cx: 687.2,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2636 || (_circle2636 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.4,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2637 || (_circle2637 = /*#__PURE__*/React.createElement("circle", {
    cx: 677.5,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2638 || (_circle2638 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.7,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2639 || (_circle2639 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.8,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2640 || (_circle2640 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.9,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2641 || (_circle2641 = /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2642 || (_circle2642 = /*#__PURE__*/React.createElement("circle", {
    cx: 653,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2643 || (_circle2643 = /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2644 || (_circle2644 = /*#__PURE__*/React.createElement("circle", {
    cx: 643,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2645 || (_circle2645 = /*#__PURE__*/React.createElement("circle", {
    cx: 638,
    cy: 95.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2646 || (_circle2646 = /*#__PURE__*/React.createElement("circle", {
    cx: 633.1,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2647 || (_circle2647 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.1,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2648 || (_circle2648 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.1,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2649 || (_circle2649 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.2,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2650 || (_circle2650 = /*#__PURE__*/React.createElement("circle", {
    cx: 613.4,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2651 || (_circle2651 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.5,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2652 || (_circle2652 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.6,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2653 || (_circle2653 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.7,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2654 || (_circle2654 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.8,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2655 || (_circle2655 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.2,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2656 || (_circle2656 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.5,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2657 || (_circle2657 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.9,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2658 || (_circle2658 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.3,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2659 || (_circle2659 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.7,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2660 || (_circle2660 = /*#__PURE__*/React.createElement("circle", {
    cx: 566,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2661 || (_circle2661 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 76.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2662 || (_circle2662 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.9,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2663 || (_circle2663 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.4,
    cy: 72.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2664 || (_circle2664 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.8,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2665 || (_circle2665 = /*#__PURE__*/React.createElement("circle", {
    cx: 543.3,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2666 || (_circle2666 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.8,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2667 || (_circle2667 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.2,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2668 || (_circle2668 = /*#__PURE__*/React.createElement("circle", {
    cx: 529.6,
    cy: 62.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2669 || (_circle2669 = /*#__PURE__*/React.createElement("circle", {
    cx: 524.9,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2670 || (_circle2670 = /*#__PURE__*/React.createElement("circle", {
    cx: 520.2,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2671 || (_circle2671 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.6,
    cy: 57.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2672 || (_circle2672 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.9,
    cy: 55.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2673 || (_circle2673 = /*#__PURE__*/React.createElement("circle", {
    cx: 506.2,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2674 || (_circle2674 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.5,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2675 || (_circle2675 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.6,
    cy: 51.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2676 || (_circle2676 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.7,
    cy: 50.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2677 || (_circle2677 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.7,
    cy: 50,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2678 || (_circle2678 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.8,
    cy: 49.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2679 || (_circle2679 = /*#__PURE__*/React.createElement("circle", {
    cx: 476.9,
    cy: 48.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2680 || (_circle2680 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.9,
    cy: 47.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2681 || (_circle2681 = /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2682 || (_circle2682 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.1,
    cy: 46.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2683 || (_circle2683 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.1,
    cy: 45.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2684 || (_circle2684 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.2,
    cy: 45.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2685 || (_circle2685 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.2,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2686 || (_circle2686 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.2,
    cy: 45.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2687 || (_circle2687 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.3,
    cy: 46.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2688 || (_circle2688 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.3,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2689 || (_circle2689 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.3,
    cy: 46.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2690 || (_circle2690 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.3,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2691 || (_circle2691 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.3,
    cy: 47.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2692 || (_circle2692 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.4,
    cy: 47.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2693 || (_circle2693 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.4,
    cy: 48,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2694 || (_circle2694 = /*#__PURE__*/React.createElement("circle", {
    cx: 402.4,
    cy: 48.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2695 || (_circle2695 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.6,
    cy: 49.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2696 || (_circle2696 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.7,
    cy: 50.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2697 || (_circle2697 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.8,
    cy: 51.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2698 || (_circle2698 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.9,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2699 || (_circle2699 = /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2700 || (_circle2700 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.1,
    cy: 54.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2701 || (_circle2701 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.2,
    cy: 55.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2702 || (_circle2702 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.3,
    cy: 56.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2703 || (_circle2703 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.4,
    cy: 57.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2704 || (_circle2704 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.6,
    cy: 58.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2705 || (_circle2705 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.7,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2706 || (_circle2706 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.9,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2707 || (_circle2707 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.1,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2708 || (_circle2708 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.2,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2709 || (_circle2709 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.4,
    cy: 64.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2710 || (_circle2710 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.6,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2711 || (_circle2711 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.7,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2712 || (_circle2712 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.9,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2713 || (_circle2713 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.1,
    cy: 69.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2714 || (_circle2714 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.3,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2715 || (_circle2715 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.4,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2716 || (_circle2716 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.6,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2717 || (_circle2717 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.7,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2718 || (_circle2718 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.9,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2719 || (_circle2719 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2720 || (_circle2720 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.2,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2721 || (_circle2721 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.3,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2722 || (_circle2722 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2723 || (_circle2723 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.6,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2724 || (_circle2724 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.8,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2725 || (_circle2725 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.8,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2726 || (_circle2726 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.9,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2727 || (_circle2727 = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2728 || (_circle2728 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.1,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2729 || (_circle2729 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.2,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2730 || (_circle2730 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.3,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2731 || (_circle2731 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.4,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2732 || (_circle2732 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2733 || (_circle2733 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2734 || (_circle2734 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.6,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2735 || (_circle2735 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.7,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2736 || (_circle2736 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.7,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2737 || (_circle2737 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.7,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2738 || (_circle2738 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.7,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2739 || (_circle2739 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.8,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2740 || (_circle2740 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.8,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2741 || (_circle2741 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.8,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2742 || (_circle2742 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2743 || (_circle2743 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.8,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2744 || (_circle2744 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.8,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2745 || (_circle2745 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.9,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2746 || (_circle2746 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.9,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2747 || (_circle2747 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.9,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2748 || (_circle2748 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2749 || (_circle2749 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2750 || (_circle2750 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2751 || (_circle2751 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.1,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2752 || (_circle2752 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.1,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2753 || (_circle2753 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.2,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2754 || (_circle2754 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.2,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2755 || (_circle2755 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.2,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2756 || (_circle2756 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.3,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2757 || (_circle2757 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2758 || (_circle2758 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.4,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2759 || (_circle2759 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2760 || (_circle2760 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2761 || (_circle2761 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.6,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2762 || (_circle2762 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.7,
    cy: 84.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2763 || (_circle2763 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.7,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2764 || (_circle2764 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2765 || (_circle2765 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2766 || (_circle2766 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2767 || (_circle2767 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2768 || (_circle2768 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2769 || (_circle2769 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1,
    cy: 79.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2770 || (_circle2770 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2771 || (_circle2771 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2772 || (_circle2772 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2773 || (_circle2773 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2774 || (_circle2774 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 75.8,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2775 || (_circle2775 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 75.1,
    r: 0.8,
    className: "soundwave_svg__st12"
  })), _circle2776 || (_circle2776 = /*#__PURE__*/React.createElement("circle", {
    cx: 1041.3,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2777 || (_circle2777 = /*#__PURE__*/React.createElement("circle", {
    cx: 1036.3,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2778 || (_circle2778 = /*#__PURE__*/React.createElement("circle", {
    cx: 1031.3,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2779 || (_circle2779 = /*#__PURE__*/React.createElement("circle", {
    cx: 1026.4,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2780 || (_circle2780 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.4,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2781 || (_circle2781 = /*#__PURE__*/React.createElement("circle", {
    cx: 1016.4,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2782 || (_circle2782 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.5,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2783 || (_circle2783 = /*#__PURE__*/React.createElement("circle", {
    cx: 1006.5,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2784 || (_circle2784 = /*#__PURE__*/React.createElement("circle", {
    cx: 1001.5,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2785 || (_circle2785 = /*#__PURE__*/React.createElement("circle", {
    cx: 996.6,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2786 || (_circle2786 = /*#__PURE__*/React.createElement("circle", {
    cx: 991.6,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2787 || (_circle2787 = /*#__PURE__*/React.createElement("circle", {
    cx: 986.6,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2788 || (_circle2788 = /*#__PURE__*/React.createElement("circle", {
    cx: 981.7,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2789 || (_circle2789 = /*#__PURE__*/React.createElement("circle", {
    cx: 976.7,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2790 || (_circle2790 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.8,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2791 || (_circle2791 = /*#__PURE__*/React.createElement("circle", {
    cx: 966.8,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2792 || (_circle2792 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.9,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2793 || (_circle2793 = /*#__PURE__*/React.createElement("circle", {
    cx: 956.9,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2794 || (_circle2794 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.9,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2795 || (_circle2795 = /*#__PURE__*/React.createElement("circle", {
    cx: 947,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2796 || (_circle2796 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2797 || (_circle2797 = /*#__PURE__*/React.createElement("circle", {
    cx: 937.1,
    cy: 85.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2798 || (_circle2798 = /*#__PURE__*/React.createElement("circle", {
    cx: 932.3,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2799 || (_circle2799 = /*#__PURE__*/React.createElement("circle", {
    cx: 927.4,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2800 || (_circle2800 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.6,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2801 || (_circle2801 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.7,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2802 || (_circle2802 = /*#__PURE__*/React.createElement("circle", {
    cx: 912.9,
    cy: 79.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2803 || (_circle2803 = /*#__PURE__*/React.createElement("circle", {
    cx: 908,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2804 || (_circle2804 = /*#__PURE__*/React.createElement("circle", {
    cx: 903.2,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2805 || (_circle2805 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.3,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2806 || (_circle2806 = /*#__PURE__*/React.createElement("circle", {
    cx: 893.5,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2807 || (_circle2807 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.6,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2808 || (_circle2808 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.8,
    cy: 72.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2809 || (_circle2809 = /*#__PURE__*/React.createElement("circle", {
    cx: 879.1,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2810 || (_circle2810 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.3,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2811 || (_circle2811 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.6,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2812 || (_circle2812 = /*#__PURE__*/React.createElement("circle", {
    cx: 864.8,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2813 || (_circle2813 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.1,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2814 || (_circle2814 = /*#__PURE__*/React.createElement("circle", {
    cx: 855.3,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2815 || (_circle2815 = /*#__PURE__*/React.createElement("circle", {
    cx: 850.5,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2816 || (_circle2816 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.6,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2817 || (_circle2817 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.7,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2818 || (_circle2818 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.8,
    cy: 59.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2819 || (_circle2819 = /*#__PURE__*/React.createElement("circle", {
    cx: 830.9,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2820 || (_circle2820 = /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2821 || (_circle2821 = /*#__PURE__*/React.createElement("circle", {
    cx: 821,
    cy: 56.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2822 || (_circle2822 = /*#__PURE__*/React.createElement("circle", {
    cx: 816.1,
    cy: 56.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2823 || (_circle2823 = /*#__PURE__*/React.createElement("circle", {
    cx: 811.2,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2824 || (_circle2824 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.2,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2825 || (_circle2825 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.2,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2826 || (_circle2826 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.3,
    cy: 58.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2827 || (_circle2827 = /*#__PURE__*/React.createElement("circle", {
    cx: 791.3,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2828 || (_circle2828 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.3,
    cy: 59.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2829 || (_circle2829 = /*#__PURE__*/React.createElement("circle", {
    cx: 781.4,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2830 || (_circle2830 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.5,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2831 || (_circle2831 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.7,
    cy: 62,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2832 || (_circle2832 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.9,
    cy: 63.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2833 || (_circle2833 = /*#__PURE__*/React.createElement("circle", {
    cx: 762.1,
    cy: 64.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2834 || (_circle2834 = /*#__PURE__*/React.createElement("circle", {
    cx: 757.2,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2835 || (_circle2835 = /*#__PURE__*/React.createElement("circle", {
    cx: 752.4,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2836 || (_circle2836 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.6,
    cy: 68.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2837 || (_circle2837 = /*#__PURE__*/React.createElement("circle", {
    cx: 742.8,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2838 || (_circle2838 = /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 71.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2839 || (_circle2839 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.3,
    cy: 72.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2840 || (_circle2840 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.5,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2841 || (_circle2841 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.8,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2842 || (_circle2842 = /*#__PURE__*/React.createElement("circle", {
    cx: 719.1,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2843 || (_circle2843 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.3,
    cy: 79.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2844 || (_circle2844 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.6,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2845 || (_circle2845 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.9,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2846 || (_circle2846 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.1,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2847 || (_circle2847 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.3,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2848 || (_circle2848 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.5,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2849 || (_circle2849 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.6,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2850 || (_circle2850 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.8,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2851 || (_circle2851 = /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2852 || (_circle2852 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.2,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2853 || (_circle2853 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.3,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2854 || (_circle2854 = /*#__PURE__*/React.createElement("circle", {
    cx: 661.5,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2855 || (_circle2855 = /*#__PURE__*/React.createElement("circle", {
    cx: 656.6,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2856 || (_circle2856 = /*#__PURE__*/React.createElement("circle", {
    cx: 651.6,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2857 || (_circle2857 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.6,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2858 || (_circle2858 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.7,
    cy: 95.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2859 || (_circle2859 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.7,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2860 || (_circle2860 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.7,
    cy: 96.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2861 || (_circle2861 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.7,
    cy: 96.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2862 || (_circle2862 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.8,
    cy: 96.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2863 || (_circle2863 = /*#__PURE__*/React.createElement("circle", {
    cx: 616.8,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2864 || (_circle2864 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.9,
    cy: 95.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2865 || (_circle2865 = /*#__PURE__*/React.createElement("circle", {
    cx: 607,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2866 || (_circle2866 = /*#__PURE__*/React.createElement("circle", {
    cx: 602.1,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2867 || (_circle2867 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.2,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2868 || (_circle2868 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.4,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2869 || (_circle2869 = /*#__PURE__*/React.createElement("circle", {
    cx: 587.5,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2870 || (_circle2870 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.7,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2871 || (_circle2871 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.1,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2872 || (_circle2872 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.5,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2873 || (_circle2873 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.9,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2874 || (_circle2874 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.2,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2875 || (_circle2875 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.6,
    cy: 80.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2876 || (_circle2876 = /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2877 || (_circle2877 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.4,
    cy: 76.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2878 || (_circle2878 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.9,
    cy: 74.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2879 || (_circle2879 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.4,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2880 || (_circle2880 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.8,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2881 || (_circle2881 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.3,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2882 || (_circle2882 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.8,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2883 || (_circle2883 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.3,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2884 || (_circle2884 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.6,
    cy: 61.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2885 || (_circle2885 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.9,
    cy: 60,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2886 || (_circle2886 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.3,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2887 || (_circle2887 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.6,
    cy: 56.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2888 || (_circle2888 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.9,
    cy: 54.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2889 || (_circle2889 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.3,
    cy: 53,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2890 || (_circle2890 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.6,
    cy: 51.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2891 || (_circle2891 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.7,
    cy: 50.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2892 || (_circle2892 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.8,
    cy: 49.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2893 || (_circle2893 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.8,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2894 || (_circle2894 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.9,
    cy: 48.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2895 || (_circle2895 = /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 47.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2896 || (_circle2896 = /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 46.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2897 || (_circle2897 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.1,
    cy: 46,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2898 || (_circle2898 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.2,
    cy: 45.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2899 || (_circle2899 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.2,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2900 || (_circle2900 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.3,
    cy: 44,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2901 || (_circle2901 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.3,
    cy: 44.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2902 || (_circle2902 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.3,
    cy: 44.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2903 || (_circle2903 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.4,
    cy: 44.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2904 || (_circle2904 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.4,
    cy: 45.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2905 || (_circle2905 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.4,
    cy: 45.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2906 || (_circle2906 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.4,
    cy: 45.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2907 || (_circle2907 = /*#__PURE__*/React.createElement("circle", {
    cx: 406.4,
    cy: 46.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2908 || (_circle2908 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2909 || (_circle2909 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.5,
    cy: 46.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2910 || (_circle2910 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 47.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2911 || (_circle2911 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.7,
    cy: 48.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2912 || (_circle2912 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.8,
    cy: 49.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2913 || (_circle2913 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.9,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2914 || (_circle2914 = /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 51.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2915 || (_circle2915 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.1,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2916 || (_circle2916 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.2,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2917 || (_circle2917 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.3,
    cy: 54.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2918 || (_circle2918 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.4,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2919 || (_circle2919 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.5,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2920 || (_circle2920 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.7,
    cy: 57.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2921 || (_circle2921 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.8,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2922 || (_circle2922 = /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 59.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2923 || (_circle2923 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.2,
    cy: 61,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2924 || (_circle2924 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.4,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2925 || (_circle2925 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2926 || (_circle2926 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.7,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2927 || (_circle2927 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.9,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2928 || (_circle2928 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.1,
    cy: 67.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2929 || (_circle2929 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.3,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2930 || (_circle2930 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.4,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2931 || (_circle2931 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.6,
    cy: 71.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2932 || (_circle2932 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.8,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2933 || (_circle2933 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.9,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2934 || (_circle2934 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.1,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2935 || (_circle2935 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.3,
    cy: 76.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2936 || (_circle2936 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2937 || (_circle2937 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.6,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2938 || (_circle2938 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.8,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2939 || (_circle2939 = /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2940 || (_circle2940 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.1,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2941 || (_circle2941 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.2,
    cy: 83.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2942 || (_circle2942 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.3,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2943 || (_circle2943 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.5,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2944 || (_circle2944 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.6,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2945 || (_circle2945 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.7,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2946 || (_circle2946 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.8,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2947 || (_circle2947 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.9,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2948 || (_circle2948 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2949 || (_circle2949 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.2,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2950 || (_circle2950 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.3,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2951 || (_circle2951 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.3,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2952 || (_circle2952 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.3,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2953 || (_circle2953 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.3,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2954 || (_circle2954 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.4,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2955 || (_circle2955 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.4,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2956 || (_circle2956 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.4,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2957 || (_circle2957 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.4,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2958 || (_circle2958 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2959 || (_circle2959 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 95.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2960 || (_circle2960 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 95.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2961 || (_circle2961 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2962 || (_circle2962 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.6,
    cy: 95.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2963 || (_circle2963 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.6,
    cy: 95.1,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2964 || (_circle2964 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2965 || (_circle2965 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.6,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2966 || (_circle2966 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.7,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2967 || (_circle2967 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.7,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2968 || (_circle2968 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.7,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2969 || (_circle2969 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.8,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2970 || (_circle2970 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.9,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2971 || (_circle2971 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.9,
    cy: 90.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2972 || (_circle2972 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2973 || (_circle2973 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2974 || (_circle2974 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.1,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2975 || (_circle2975 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2976 || (_circle2976 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2977 || (_circle2977 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.3,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2978 || (_circle2978 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.4,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2979 || (_circle2979 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2980 || (_circle2980 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.6,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2981 || (_circle2981 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2982 || (_circle2982 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2983 || (_circle2983 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2984 || (_circle2984 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2985 || (_circle2985 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2986 || (_circle2986 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2987 || (_circle2987 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4,
    cy: 77,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2988 || (_circle2988 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2989 || (_circle2989 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 75,
    r: 0.8,
    className: "soundwave_svg__st13"
  })), _circle2990 || (_circle2990 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042.9,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2991 || (_circle2991 = /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2992 || (_circle2992 = /*#__PURE__*/React.createElement("circle", {
    cx: 1033,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2993 || (_circle2993 = /*#__PURE__*/React.createElement("circle", {
    cx: 1028.1,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2994 || (_circle2994 = /*#__PURE__*/React.createElement("circle", {
    cx: 1023.2,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2995 || (_circle2995 = /*#__PURE__*/React.createElement("circle", {
    cx: 1018.2,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2996 || (_circle2996 = /*#__PURE__*/React.createElement("circle", {
    cx: 1013.3,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2997 || (_circle2997 = /*#__PURE__*/React.createElement("circle", {
    cx: 1008.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2998 || (_circle2998 = /*#__PURE__*/React.createElement("circle", {
    cx: 1003.4,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle2999 || (_circle2999 = /*#__PURE__*/React.createElement("circle", {
    cx: 998.4,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3000 || (_circle3000 = /*#__PURE__*/React.createElement("circle", {
    cx: 993.4,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3001 || (_circle3001 = /*#__PURE__*/React.createElement("circle", {
    cx: 988.4,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3002 || (_circle3002 = /*#__PURE__*/React.createElement("circle", {
    cx: 983.5,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3003 || (_circle3003 = /*#__PURE__*/React.createElement("circle", {
    cx: 978.5,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3004 || (_circle3004 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.5,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3005 || (_circle3005 = /*#__PURE__*/React.createElement("circle", {
    cx: 968.5,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3006 || (_circle3006 = /*#__PURE__*/React.createElement("circle", {
    cx: 963.5,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3007 || (_circle3007 = /*#__PURE__*/React.createElement("circle", {
    cx: 958.6,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3008 || (_circle3008 = /*#__PURE__*/React.createElement("circle", {
    cx: 953.7,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3009 || (_circle3009 = /*#__PURE__*/React.createElement("circle", {
    cx: 948.8,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3010 || (_circle3010 = /*#__PURE__*/React.createElement("circle", {
    cx: 943.8,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3011 || (_circle3011 = /*#__PURE__*/React.createElement("circle", {
    cx: 938.9,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3012 || (_circle3012 = /*#__PURE__*/React.createElement("circle", {
    cx: 934,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3013 || (_circle3013 = /*#__PURE__*/React.createElement("circle", {
    cx: 929.1,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3014 || (_circle3014 = /*#__PURE__*/React.createElement("circle", {
    cx: 924.2,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3015 || (_circle3015 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.3,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3016 || (_circle3016 = /*#__PURE__*/React.createElement("circle", {
    cx: 914.5,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3017 || (_circle3017 = /*#__PURE__*/React.createElement("circle", {
    cx: 909.7,
    cy: 81.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3018 || (_circle3018 = /*#__PURE__*/React.createElement("circle", {
    cx: 904.9,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3019 || (_circle3019 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.1,
    cy: 78.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3020 || (_circle3020 = /*#__PURE__*/React.createElement("circle", {
    cx: 895.3,
    cy: 77.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3021 || (_circle3021 = /*#__PURE__*/React.createElement("circle", {
    cx: 890.4,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3022 || (_circle3022 = /*#__PURE__*/React.createElement("circle", {
    cx: 885.6,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3023 || (_circle3023 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.9,
    cy: 73.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3024 || (_circle3024 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.2,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3025 || (_circle3025 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.5,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3026 || (_circle3026 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.8,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3027 || (_circle3027 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.1,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3028 || (_circle3028 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.4,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3029 || (_circle3029 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.7,
    cy: 63.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3030 || (_circle3030 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.9,
    cy: 61.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3031 || (_circle3031 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3032 || (_circle3032 = /*#__PURE__*/React.createElement("circle", {
    cx: 838.1,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3033 || (_circle3033 = /*#__PURE__*/React.createElement("circle", {
    cx: 833.3,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3034 || (_circle3034 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.4,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3035 || (_circle3035 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.5,
    cy: 56.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3036 || (_circle3036 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.6,
    cy: 55.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3037 || (_circle3037 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.7,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3038 || (_circle3038 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.8,
    cy: 55,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3039 || (_circle3039 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.8,
    cy: 55.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3040 || (_circle3040 = /*#__PURE__*/React.createElement("circle", {
    cx: 798.8,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3041 || (_circle3041 = /*#__PURE__*/React.createElement("circle", {
    cx: 793.9,
    cy: 56.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3042 || (_circle3042 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.9,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3043 || (_circle3043 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.9,
    cy: 57.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3044 || (_circle3044 = /*#__PURE__*/React.createElement("circle", {
    cx: 779,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3045 || (_circle3045 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3046 || (_circle3046 = /*#__PURE__*/React.createElement("circle", {
    cx: 769.2,
    cy: 59.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3047 || (_circle3047 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.4,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3048 || (_circle3048 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.6,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3049 || (_circle3049 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.8,
    cy: 63.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3050 || (_circle3050 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3051 || (_circle3051 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.2,
    cy: 66.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3052 || (_circle3052 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.4,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3053 || (_circle3053 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.6,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3054 || (_circle3054 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.9,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3055 || (_circle3055 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.1,
    cy: 72.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3056 || (_circle3056 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.4,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3057 || (_circle3057 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.7,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3058 || (_circle3058 = /*#__PURE__*/React.createElement("circle", {
    cx: 712,
    cy: 77,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3059 || (_circle3059 = /*#__PURE__*/React.createElement("circle", {
    cx: 707.3,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3060 || (_circle3060 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.6,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3061 || (_circle3061 = /*#__PURE__*/React.createElement("circle", {
    cx: 697.9,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3062 || (_circle3062 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.2,
    cy: 83.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3063 || (_circle3063 = /*#__PURE__*/React.createElement("circle", {
    cx: 688.3,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3064 || (_circle3064 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.5,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3065 || (_circle3065 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.7,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3066 || (_circle3066 = /*#__PURE__*/React.createElement("circle", {
    cx: 673.9,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3067 || (_circle3067 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.1,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3068 || (_circle3068 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.3,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3069 || (_circle3069 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.5,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3070 || (_circle3070 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.7,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3071 || (_circle3071 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.8,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3072 || (_circle3072 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.8,
    cy: 95.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3073 || (_circle3073 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.9,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3074 || (_circle3074 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.9,
    cy: 96.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3075 || (_circle3075 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.9,
    cy: 96.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3076 || (_circle3076 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.9,
    cy: 97,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3077 || (_circle3077 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 97.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3078 || (_circle3078 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 97.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3079 || (_circle3079 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.1,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3080 || (_circle3080 = /*#__PURE__*/React.createElement("circle", {
    cx: 605.2,
    cy: 96.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3081 || (_circle3081 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.3,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3082 || (_circle3082 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.4,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3083 || (_circle3083 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.5,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3084 || (_circle3084 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.6,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3085 || (_circle3085 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.7,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3086 || (_circle3086 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.9,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3087 || (_circle3087 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.3,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3088 || (_circle3088 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.7,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3089 || (_circle3089 = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3090 || (_circle3090 = /*#__PURE__*/React.createElement("circle", {
    cx: 557.4,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3091 || (_circle3091 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.8,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3092 || (_circle3092 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.2,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3093 || (_circle3093 = /*#__PURE__*/React.createElement("circle", {
    cx: 543.6,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3094 || (_circle3094 = /*#__PURE__*/React.createElement("circle", {
    cx: 539,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3095 || (_circle3095 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.5,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3096 || (_circle3096 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3097 || (_circle3097 = /*#__PURE__*/React.createElement("circle", {
    cx: 525.5,
    cy: 69,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3098 || (_circle3098 = /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3099 || (_circle3099 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.5,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3100 || (_circle3100 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3101 || (_circle3101 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.3,
    cy: 60.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3102 || (_circle3102 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.6,
    cy: 59.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3103 || (_circle3103 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.9,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3104 || (_circle3104 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.3,
    cy: 55.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3105 || (_circle3105 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.6,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3106 || (_circle3106 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.9,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3107 || (_circle3107 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.3,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3108 || (_circle3108 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.4,
    cy: 49.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3109 || (_circle3109 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.4,
    cy: 48.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3110 || (_circle3110 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.5,
    cy: 48,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3111 || (_circle3111 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.6,
    cy: 47.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3112 || (_circle3112 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.6,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3113 || (_circle3113 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 45.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3114 || (_circle3114 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.8,
    cy: 44.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3115 || (_circle3115 = /*#__PURE__*/React.createElement("circle", {
    cx: 439.9,
    cy: 44.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3116 || (_circle3116 = /*#__PURE__*/React.createElement("circle", {
    cx: 434.9,
    cy: 43.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3117 || (_circle3117 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 43,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3118 || (_circle3118 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 43.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3119 || (_circle3119 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 43.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3120 || (_circle3120 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 43.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3121 || (_circle3121 = /*#__PURE__*/React.createElement("circle", {
    cx: 410.1,
    cy: 44.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3122 || (_circle3122 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.1,
    cy: 44.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3123 || (_circle3123 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.1,
    cy: 44.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3124 || (_circle3124 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.1,
    cy: 44.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3125 || (_circle3125 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.1,
    cy: 45.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3126 || (_circle3126 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.2,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3127 || (_circle3127 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.3,
    cy: 46.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3128 || (_circle3128 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.4,
    cy: 47.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3129 || (_circle3129 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.5,
    cy: 48.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3130 || (_circle3130 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.6,
    cy: 49.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3131 || (_circle3131 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.7,
    cy: 50.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3132 || (_circle3132 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.8,
    cy: 51.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3133 || (_circle3133 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.9,
    cy: 52,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3134 || (_circle3134 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 53,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3135 || (_circle3135 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.1,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3136 || (_circle3136 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.2,
    cy: 54.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3137 || (_circle3137 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.4,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3138 || (_circle3138 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.6,
    cy: 57.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3139 || (_circle3139 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.7,
    cy: 58.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3140 || (_circle3140 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.9,
    cy: 60.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3141 || (_circle3141 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.1,
    cy: 61.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3142 || (_circle3142 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.3,
    cy: 62.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3143 || (_circle3143 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 64,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3144 || (_circle3144 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.7,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3145 || (_circle3145 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.8,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3146 || (_circle3146 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3147 || (_circle3147 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.2,
    cy: 69.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3148 || (_circle3148 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.4,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3149 || (_circle3149 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.6,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3150 || (_circle3150 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.8,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3151 || (_circle3151 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3152 || (_circle3152 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.2,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3153 || (_circle3153 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.4,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3154 || (_circle3154 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.6,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3155 || (_circle3155 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.8,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3156 || (_circle3156 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.9,
    cy: 81.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3157 || (_circle3157 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.1,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3158 || (_circle3158 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.2,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3159 || (_circle3159 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.4,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3160 || (_circle3160 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3161 || (_circle3161 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.6,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3162 || (_circle3162 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.8,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3163 || (_circle3163 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.9,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3164 || (_circle3164 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3165 || (_circle3165 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3166 || (_circle3166 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.3,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3167 || (_circle3167 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.4,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3168 || (_circle3168 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.4,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3169 || (_circle3169 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.4,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3170 || (_circle3170 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3171 || (_circle3171 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3172 || (_circle3172 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.6,
    cy: 95.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3173 || (_circle3173 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.6,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3174 || (_circle3174 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.7,
    cy: 96.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3175 || (_circle3175 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.7,
    cy: 97,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3176 || (_circle3176 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.7,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3177 || (_circle3177 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.8,
    cy: 98.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3178 || (_circle3178 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.8,
    cy: 97.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3179 || (_circle3179 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.8,
    cy: 97.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3180 || (_circle3180 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.8,
    cy: 97.5,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3181 || (_circle3181 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.9,
    cy: 97.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3182 || (_circle3182 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.9,
    cy: 97,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3183 || (_circle3183 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.9,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3184 || (_circle3184 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.9,
    cy: 96.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3185 || (_circle3185 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3186 || (_circle3186 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3187 || (_circle3187 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.1,
    cy: 94.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3188 || (_circle3188 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3189 || (_circle3189 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.3,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3190 || (_circle3190 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.3,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3191 || (_circle3191 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.4,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3192 || (_circle3192 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3193 || (_circle3193 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3194 || (_circle3194 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.8,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3195 || (_circle3195 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3196 || (_circle3196 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.1,
    cy: 85.7,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3197 || (_circle3197 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3198 || (_circle3198 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3199 || (_circle3199 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3200 || (_circle3200 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3201 || (_circle3201 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3202 || (_circle3202 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3,
    cy: 77.8,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3203 || (_circle3203 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3204 || (_circle3204 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.7,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st14"
  })), _circle3205 || (_circle3205 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.1,
    cy: 87.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3206 || (_circle3206 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.2,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3207 || (_circle3207 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.3,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3208 || (_circle3208 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.3,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3209 || (_circle3209 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.4,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3210 || (_circle3210 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.5,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3211 || (_circle3211 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.6,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3212 || (_circle3212 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009.7,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3213 || (_circle3213 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004.7,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3214 || (_circle3214 = /*#__PURE__*/React.createElement("circle", {
    cx: 999.8,
    cy: 93.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3215 || (_circle3215 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.8,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3216 || (_circle3216 = /*#__PURE__*/React.createElement("circle", {
    cx: 989.8,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3217 || (_circle3217 = /*#__PURE__*/React.createElement("circle", {
    cx: 984.8,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3218 || (_circle3218 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.8,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3219 || (_circle3219 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.8,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3220 || (_circle3220 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.8,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3221 || (_circle3221 = /*#__PURE__*/React.createElement("circle", {
    cx: 964.8,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3222 || (_circle3222 = /*#__PURE__*/React.createElement("circle", {
    cx: 959.9,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3223 || (_circle3223 = /*#__PURE__*/React.createElement("circle", {
    cx: 955,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3224 || (_circle3224 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.1,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3225 || (_circle3225 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.1,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3226 || (_circle3226 = /*#__PURE__*/React.createElement("circle", {
    cx: 940.2,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3227 || (_circle3227 = /*#__PURE__*/React.createElement("circle", {
    cx: 935.3,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3228 || (_circle3228 = /*#__PURE__*/React.createElement("circle", {
    cx: 930.4,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3229 || (_circle3229 = /*#__PURE__*/React.createElement("circle", {
    cx: 925.4,
    cy: 87.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3230 || (_circle3230 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.5,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3231 || (_circle3231 = /*#__PURE__*/React.createElement("circle", {
    cx: 915.7,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3232 || (_circle3232 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.9,
    cy: 83.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3233 || (_circle3233 = /*#__PURE__*/React.createElement("circle", {
    cx: 906.1,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3234 || (_circle3234 = /*#__PURE__*/React.createElement("circle", {
    cx: 901.3,
    cy: 80.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3235 || (_circle3235 = /*#__PURE__*/React.createElement("circle", {
    cx: 896.5,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3236 || (_circle3236 = /*#__PURE__*/React.createElement("circle", {
    cx: 891.8,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3237 || (_circle3237 = /*#__PURE__*/React.createElement("circle", {
    cx: 887,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3238 || (_circle3238 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.2,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3239 || (_circle3239 = /*#__PURE__*/React.createElement("circle", {
    cx: 877.5,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3240 || (_circle3240 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.8,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3241 || (_circle3241 = /*#__PURE__*/React.createElement("circle", {
    cx: 868.2,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3242 || (_circle3242 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.5,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3243 || (_circle3243 = /*#__PURE__*/React.createElement("circle", {
    cx: 858.9,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3244 || (_circle3244 = /*#__PURE__*/React.createElement("circle", {
    cx: 854.2,
    cy: 64.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3245 || (_circle3245 = /*#__PURE__*/React.createElement("circle", {
    cx: 849.5,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3246 || (_circle3246 = /*#__PURE__*/React.createElement("circle", {
    cx: 844.8,
    cy: 61.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3247 || (_circle3247 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.1,
    cy: 59.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3248 || (_circle3248 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.4,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3249 || (_circle3249 = /*#__PURE__*/React.createElement("circle", {
    cx: 830.6,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3250 || (_circle3250 = /*#__PURE__*/React.createElement("circle", {
    cx: 825.7,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3251 || (_circle3251 = /*#__PURE__*/React.createElement("circle", {
    cx: 820.8,
    cy: 55,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3252 || (_circle3252 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.9,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3253 || (_circle3253 = /*#__PURE__*/React.createElement("circle", {
    cx: 811,
    cy: 53,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3254 || (_circle3254 = /*#__PURE__*/React.createElement("circle", {
    cx: 806,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3255 || (_circle3255 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.1,
    cy: 53.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3256 || (_circle3256 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.1,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3257 || (_circle3257 = /*#__PURE__*/React.createElement("circle", {
    cx: 791.1,
    cy: 54.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3258 || (_circle3258 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.1,
    cy: 54.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3259 || (_circle3259 = /*#__PURE__*/React.createElement("circle", {
    cx: 781.2,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3260 || (_circle3260 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.2,
    cy: 55.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3261 || (_circle3261 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.2,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3262 || (_circle3262 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.4,
    cy: 56.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3263 || (_circle3263 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.6,
    cy: 58.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3264 || (_circle3264 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.8,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3265 || (_circle3265 = /*#__PURE__*/React.createElement("circle", {
    cx: 752,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3266 || (_circle3266 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.2,
    cy: 62.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3267 || (_circle3267 = /*#__PURE__*/React.createElement("circle", {
    cx: 742.4,
    cy: 63.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3268 || (_circle3268 = /*#__PURE__*/React.createElement("circle", {
    cx: 737.6,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3269 || (_circle3269 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.8,
    cy: 66.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3270 || (_circle3270 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.1,
    cy: 68.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3271 || (_circle3271 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.4,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3272 || (_circle3272 = /*#__PURE__*/React.createElement("circle", {
    cx: 718.7,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3273 || (_circle3273 = /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3274 || (_circle3274 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.3,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3275 || (_circle3275 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.7,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3276 || (_circle3276 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3277 || (_circle3277 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.3,
    cy: 80.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3278 || (_circle3278 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.6,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3279 || (_circle3279 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.9,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3280 || (_circle3280 = /*#__PURE__*/React.createElement("circle", {
    cx: 681.1,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3281 || (_circle3281 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.3,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3282 || (_circle3282 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.5,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3283 || (_circle3283 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.8,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3284 || (_circle3284 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3285 || (_circle3285 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.2,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3286 || (_circle3286 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.4,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3287 || (_circle3287 = /*#__PURE__*/React.createElement("circle", {
    cx: 647.6,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3288 || (_circle3288 = /*#__PURE__*/React.createElement("circle", {
    cx: 642.7,
    cy: 95.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3289 || (_circle3289 = /*#__PURE__*/React.createElement("circle", {
    cx: 637.7,
    cy: 95.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3290 || (_circle3290 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.8,
    cy: 96.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3291 || (_circle3291 = /*#__PURE__*/React.createElement("circle", {
    cx: 627.8,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3292 || (_circle3292 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.8,
    cy: 97.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3293 || (_circle3293 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.9,
    cy: 97.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3294 || (_circle3294 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.9,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3295 || (_circle3295 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.9,
    cy: 98.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3296 || (_circle3296 = /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 98.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3297 || (_circle3297 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.1,
    cy: 97.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3298 || (_circle3298 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.2,
    cy: 96.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3299 || (_circle3299 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.3,
    cy: 95.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3300 || (_circle3300 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.4,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3301 || (_circle3301 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.5,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3302 || (_circle3302 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.6,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3303 || (_circle3303 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.8,
    cy: 91.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3304 || (_circle3304 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.2,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3305 || (_circle3305 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.5,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3306 || (_circle3306 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.9,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3307 || (_circle3307 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.3,
    cy: 84.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3308 || (_circle3308 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.7,
    cy: 82.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3309 || (_circle3309 = /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 80.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3310 || (_circle3310 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.4,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3311 || (_circle3311 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.9,
    cy: 76.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3312 || (_circle3312 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.4,
    cy: 74.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3313 || (_circle3313 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.9,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3314 || (_circle3314 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.4,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3315 || (_circle3315 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.9,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3316 || (_circle3316 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.4,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3317 || (_circle3317 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.8,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3318 || (_circle3318 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.3,
    cy: 61.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3319 || (_circle3319 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.6,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3320 || (_circle3320 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.9,
    cy: 58.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3321 || (_circle3321 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.3,
    cy: 56.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3322 || (_circle3322 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.6,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3323 || (_circle3323 = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 52.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3324 || (_circle3324 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.3,
    cy: 51,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3325 || (_circle3325 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.6,
    cy: 49.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3326 || (_circle3326 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.7,
    cy: 48.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3327 || (_circle3327 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.8,
    cy: 47.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3328 || (_circle3328 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.9,
    cy: 46.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3329 || (_circle3329 = /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 46.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3330 || (_circle3330 = /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 45.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3331 || (_circle3331 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.1,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3332 || (_circle3332 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.2,
    cy: 43.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3333 || (_circle3333 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.3,
    cy: 42.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3334 || (_circle3334 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.3,
    cy: 42.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3335 || (_circle3335 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.4,
    cy: 42,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3336 || (_circle3336 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.4,
    cy: 42.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3337 || (_circle3337 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.4,
    cy: 42.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3338 || (_circle3338 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.4,
    cy: 42.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3339 || (_circle3339 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.4,
    cy: 43,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3340 || (_circle3340 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.5,
    cy: 43.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3341 || (_circle3341 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.5,
    cy: 43.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3342 || (_circle3342 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.5,
    cy: 43.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3343 || (_circle3343 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.5,
    cy: 43.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3344 || (_circle3344 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.6,
    cy: 44.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3345 || (_circle3345 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.7,
    cy: 45.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3346 || (_circle3346 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.8,
    cy: 46.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3347 || (_circle3347 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.9,
    cy: 47.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3348 || (_circle3348 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 48.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3349 || (_circle3349 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.1,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3350 || (_circle3350 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.2,
    cy: 50,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3351 || (_circle3351 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.3,
    cy: 50.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3352 || (_circle3352 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.4,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3353 || (_circle3353 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.5,
    cy: 52.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3354 || (_circle3354 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.6,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3355 || (_circle3355 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.8,
    cy: 55.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3356 || (_circle3356 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 56.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3357 || (_circle3357 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.2,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3358 || (_circle3358 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.4,
    cy: 59.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3359 || (_circle3359 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.6,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3360 || (_circle3360 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.8,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3361 || (_circle3361 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.9,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3362 || (_circle3362 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.1,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3363 || (_circle3363 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.3,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3364 || (_circle3364 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.6,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3365 || (_circle3365 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.8,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3366 || (_circle3366 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3367 || (_circle3367 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.2,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3368 || (_circle3368 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.4,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3369 || (_circle3369 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.7,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3370 || (_circle3370 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.9,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3371 || (_circle3371 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.1,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3372 || (_circle3372 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.3,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3373 || (_circle3373 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.5,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3374 || (_circle3374 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.7,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3375 || (_circle3375 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.9,
    cy: 82.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3376 || (_circle3376 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3377 || (_circle3377 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.2,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3378 || (_circle3378 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.4,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3379 || (_circle3379 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.6,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3380 || (_circle3380 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.8,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3381 || (_circle3381 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.9,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3382 || (_circle3382 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.1,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3383 || (_circle3383 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.3,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3384 || (_circle3384 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.4,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3385 || (_circle3385 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.4,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3386 || (_circle3386 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3387 || (_circle3387 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 95.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3388 || (_circle3388 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.6,
    cy: 96.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3389 || (_circle3389 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.7,
    cy: 96.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3390 || (_circle3390 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.7,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3391 || (_circle3391 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.8,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3392 || (_circle3392 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.8,
    cy: 99,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3393 || (_circle3393 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.9,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3394 || (_circle3394 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 100.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3395 || (_circle3395 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 100.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3396 || (_circle3396 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 100,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3397 || (_circle3397 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 99.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3398 || (_circle3398 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3399 || (_circle3399 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 99.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3400 || (_circle3400 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 99.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3401 || (_circle3401 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.1,
    cy: 99.2,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3402 || (_circle3402 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1,
    cy: 98.4,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3403 || (_circle3403 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.2,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3404 || (_circle3404 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.3,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3405 || (_circle3405 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.4,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3406 || (_circle3406 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 95.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3407 || (_circle3407 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.6,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3408 || (_circle3408 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.6,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3409 || (_circle3409 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.8,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3410 || (_circle3410 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3411 || (_circle3411 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.2,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3412 || (_circle3412 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.4,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3413 || (_circle3413 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.6,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3414 || (_circle3414 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8,
    cy: 85.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3415 || (_circle3415 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3416 || (_circle3416 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3417 || (_circle3417 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3418 || (_circle3418 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1,
    cy: 78.5,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3419 || (_circle3419 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3420 || (_circle3420 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st15"
  })), _circle3421 || (_circle3421 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.8,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3422 || (_circle3422 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.9,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3423 || (_circle3423 = /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3424 || (_circle3424 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030.1,
    cy: 90.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3425 || (_circle3425 = /*#__PURE__*/React.createElement("circle", {
    cx: 1025.2,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3426 || (_circle3426 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.3,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3427 || (_circle3427 = /*#__PURE__*/React.createElement("circle", {
    cx: 1015.4,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3428 || (_circle3428 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010.5,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3429 || (_circle3429 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.6,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3430 || (_circle3430 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3431 || (_circle3431 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3432 || (_circle3432 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3433 || (_circle3433 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3434 || (_circle3434 = /*#__PURE__*/React.createElement("circle", {
    cx: 980.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3435 || (_circle3435 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3436 || (_circle3436 = /*#__PURE__*/React.createElement("circle", {
    cx: 970.7,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3437 || (_circle3437 = /*#__PURE__*/React.createElement("circle", {
    cx: 965.8,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3438 || (_circle3438 = /*#__PURE__*/React.createElement("circle", {
    cx: 960.8,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3439 || (_circle3439 = /*#__PURE__*/React.createElement("circle", {
    cx: 955.9,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3440 || (_circle3440 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.9,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3441 || (_circle3441 = /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3442 || (_circle3442 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.1,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3443 || (_circle3443 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.1,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3444 || (_circle3444 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.2,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3445 || (_circle3445 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.3,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3446 || (_circle3446 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.4,
    cy: 88.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3447 || (_circle3447 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.5,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3448 || (_circle3448 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.8,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3449 || (_circle3449 = /*#__PURE__*/React.createElement("circle", {
    cx: 907,
    cy: 84.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3450 || (_circle3450 = /*#__PURE__*/React.createElement("circle", {
    cx: 902.2,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3451 || (_circle3451 = /*#__PURE__*/React.createElement("circle", {
    cx: 897.4,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3452 || (_circle3452 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.6,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3453 || (_circle3453 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.9,
    cy: 78.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3454 || (_circle3454 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.1,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3455 || (_circle3455 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.4,
    cy: 75.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3456 || (_circle3456 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.8,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3457 || (_circle3457 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.1,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3458 || (_circle3458 = /*#__PURE__*/React.createElement("circle", {
    cx: 864.5,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3459 || (_circle3459 = /*#__PURE__*/React.createElement("circle", {
    cx: 859.9,
    cy: 68.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3460 || (_circle3460 = /*#__PURE__*/React.createElement("circle", {
    cx: 855.3,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3461 || (_circle3461 = /*#__PURE__*/React.createElement("circle", {
    cx: 850.7,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3462 || (_circle3462 = /*#__PURE__*/React.createElement("circle", {
    cx: 846,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3463 || (_circle3463 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.4,
    cy: 60.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3464 || (_circle3464 = /*#__PURE__*/React.createElement("circle", {
    cx: 836.8,
    cy: 58.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3465 || (_circle3465 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.1,
    cy: 57.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3466 || (_circle3466 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.3,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3467 || (_circle3467 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.4,
    cy: 54.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3468 || (_circle3468 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.6,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3469 || (_circle3469 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.7,
    cy: 52.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3470 || (_circle3470 = /*#__PURE__*/React.createElement("circle", {
    cx: 807.8,
    cy: 51.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3471 || (_circle3471 = /*#__PURE__*/React.createElement("circle", {
    cx: 802.9,
    cy: 51.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3472 || (_circle3472 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.9,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3473 || (_circle3473 = /*#__PURE__*/React.createElement("circle", {
    cx: 792.9,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3474 || (_circle3474 = /*#__PURE__*/React.createElement("circle", {
    cx: 787.9,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3475 || (_circle3475 = /*#__PURE__*/React.createElement("circle", {
    cx: 783,
    cy: 52.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3476 || (_circle3476 = /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3477 || (_circle3477 = /*#__PURE__*/React.createElement("circle", {
    cx: 773,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3478 || (_circle3478 = /*#__PURE__*/React.createElement("circle", {
    cx: 768,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3479 || (_circle3479 = /*#__PURE__*/React.createElement("circle", {
    cx: 763.1,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3480 || (_circle3480 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.4,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3481 || (_circle3481 = /*#__PURE__*/React.createElement("circle", {
    cx: 753.6,
    cy: 57.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3482 || (_circle3482 = /*#__PURE__*/React.createElement("circle", {
    cx: 748.8,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3483 || (_circle3483 = /*#__PURE__*/React.createElement("circle", {
    cx: 744,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3484 || (_circle3484 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.2,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3485 || (_circle3485 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.4,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3486 || (_circle3486 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.7,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3487 || (_circle3487 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.9,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3488 || (_circle3488 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.2,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3489 || (_circle3489 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.6,
    cy: 69.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3490 || (_circle3490 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.9,
    cy: 71.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3491 || (_circle3491 = /*#__PURE__*/React.createElement("circle", {
    cx: 706.3,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3492 || (_circle3492 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.6,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3493 || (_circle3493 = /*#__PURE__*/React.createElement("circle", {
    cx: 696.9,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3494 || (_circle3494 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.3,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3495 || (_circle3495 = /*#__PURE__*/React.createElement("circle", {
    cx: 687.6,
    cy: 80.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3496 || (_circle3496 = /*#__PURE__*/React.createElement("circle", {
    cx: 683,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3497 || (_circle3497 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.2,
    cy: 83.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3498 || (_circle3498 = /*#__PURE__*/React.createElement("circle", {
    cx: 673.5,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3499 || (_circle3499 = /*#__PURE__*/React.createElement("circle", {
    cx: 668.7,
    cy: 86.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3500 || (_circle3500 = /*#__PURE__*/React.createElement("circle", {
    cx: 664,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3501 || (_circle3501 = /*#__PURE__*/React.createElement("circle", {
    cx: 659.2,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3502 || (_circle3502 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.5,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3503 || (_circle3503 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.7,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3504 || (_circle3504 = /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 94.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3505 || (_circle3505 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.2,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3506 || (_circle3506 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.2,
    cy: 95.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3507 || (_circle3507 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.2,
    cy: 96.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3508 || (_circle3508 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.3,
    cy: 97,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3509 || (_circle3509 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.3,
    cy: 97.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3510 || (_circle3510 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.4,
    cy: 98.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3511 || (_circle3511 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.4,
    cy: 98.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3512 || (_circle3512 = /*#__PURE__*/React.createElement("circle", {
    cx: 605.5,
    cy: 99.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3513 || (_circle3513 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.5,
    cy: 99.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3514 || (_circle3514 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.6,
    cy: 99.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3515 || (_circle3515 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.7,
    cy: 98.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3516 || (_circle3516 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.8,
    cy: 97.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3517 || (_circle3517 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 96.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3518 || (_circle3518 = /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 95.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3519 || (_circle3519 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.1,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3520 || (_circle3520 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.2,
    cy: 93.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3521 || (_circle3521 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.3,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3522 || (_circle3522 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.7,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3523 || (_circle3523 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.1,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3524 || (_circle3524 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.5,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3525 || (_circle3525 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.8,
    cy: 85.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3526 || (_circle3526 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.2,
    cy: 83.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3527 || (_circle3527 = /*#__PURE__*/React.createElement("circle", {
    cx: 533.6,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3528 || (_circle3528 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 79.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3529 || (_circle3529 = /*#__PURE__*/React.createElement("circle", {
    cx: 524.4,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3530 || (_circle3530 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.9,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3531 || (_circle3531 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.4,
    cy: 73.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3532 || (_circle3532 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.9,
    cy: 71,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3533 || (_circle3533 = /*#__PURE__*/React.createElement("circle", {
    cx: 506.4,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3534 || (_circle3534 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.9,
    cy: 66.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3535 || (_circle3535 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.4,
    cy: 64.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3536 || (_circle3536 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.9,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3537 || (_circle3537 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.3,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3538 || (_circle3538 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.6,
    cy: 58.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3539 || (_circle3539 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3540 || (_circle3540 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.3,
    cy: 55.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3541 || (_circle3541 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.6,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3542 || (_circle3542 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 51.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3543 || (_circle3543 = /*#__PURE__*/React.createElement("circle", {
    cx: 460.3,
    cy: 49.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3544 || (_circle3544 = /*#__PURE__*/React.createElement("circle", {
    cx: 455.7,
    cy: 48.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3545 || (_circle3545 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.7,
    cy: 47.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3546 || (_circle3546 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.8,
    cy: 46.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3547 || (_circle3547 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.9,
    cy: 45.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3548 || (_circle3548 = /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 44.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3549 || (_circle3549 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 44.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3550 || (_circle3550 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.1,
    cy: 43.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3551 || (_circle3551 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.2,
    cy: 42.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3552 || (_circle3552 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.3,
    cy: 41.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3553 || (_circle3553 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.4,
    cy: 40.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3554 || (_circle3554 = /*#__PURE__*/React.createElement("circle", {
    cx: 406.4,
    cy: 41,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3555 || (_circle3555 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.4,
    cy: 41.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3556 || (_circle3556 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.4,
    cy: 41.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3557 || (_circle3557 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.4,
    cy: 41.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3558 || (_circle3558 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.4,
    cy: 41.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3559 || (_circle3559 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.5,
    cy: 42.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3560 || (_circle3560 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 42.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3561 || (_circle3561 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.5,
    cy: 42.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3562 || (_circle3562 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 42.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3563 || (_circle3563 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.6,
    cy: 43.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3564 || (_circle3564 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.7,
    cy: 44.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3565 || (_circle3565 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.8,
    cy: 45.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3566 || (_circle3566 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.9,
    cy: 46.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3567 || (_circle3567 = /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 47.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3568 || (_circle3568 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.1,
    cy: 48,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3569 || (_circle3569 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.2,
    cy: 48.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3570 || (_circle3570 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.3,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3571 || (_circle3571 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.4,
    cy: 50.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3572 || (_circle3572 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3573 || (_circle3573 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.7,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3574 || (_circle3574 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.9,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3575 || (_circle3575 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.1,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3576 || (_circle3576 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.3,
    cy: 57.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3577 || (_circle3577 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.5,
    cy: 58.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3578 || (_circle3578 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.7,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3579 || (_circle3579 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.9,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3580 || (_circle3580 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.1,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3581 || (_circle3581 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.3,
    cy: 63.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3582 || (_circle3582 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3583 || (_circle3583 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.8,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3584 || (_circle3584 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3585 || (_circle3585 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.3,
    cy: 70,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3586 || (_circle3586 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 71.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3587 || (_circle3587 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.8,
    cy: 73,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3588 || (_circle3588 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3589 || (_circle3589 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.3,
    cy: 76.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3590 || (_circle3590 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.5,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3591 || (_circle3591 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.7,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3592 || (_circle3592 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 80.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3593 || (_circle3593 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.2,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3594 || (_circle3594 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.4,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3595 || (_circle3595 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.6,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3596 || (_circle3596 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.9,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3597 || (_circle3597 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.1,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3598 || (_circle3598 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.3,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3599 || (_circle3599 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3600 || (_circle3600 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.7,
    cy: 91.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3601 || (_circle3601 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3602 || (_circle3602 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.1,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3603 || (_circle3603 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.2,
    cy: 95.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3604 || (_circle3604 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.2,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3605 || (_circle3605 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.3,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3606 || (_circle3606 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.4,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3607 || (_circle3607 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 98.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3608 || (_circle3608 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.6,
    cy: 99.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3609 || (_circle3609 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.7,
    cy: 100.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3610 || (_circle3610 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.7,
    cy: 101,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3611 || (_circle3611 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.8,
    cy: 101.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3612 || (_circle3612 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.9,
    cy: 102.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3613 || (_circle3613 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.9,
    cy: 102.5,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3614 || (_circle3614 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.9,
    cy: 102.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3615 || (_circle3615 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.9,
    cy: 102.3,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3616 || (_circle3616 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 102.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3617 || (_circle3617 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 102,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3618 || (_circle3618 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 101.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3619 || (_circle3619 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 101.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3620 || (_circle3620 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1,
    cy: 100.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3621 || (_circle3621 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2,
    cy: 99.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3622 || (_circle3622 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3,
    cy: 99,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3623 || (_circle3623 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.4,
    cy: 98.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3624 || (_circle3624 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3625 || (_circle3625 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6,
    cy: 96.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3626 || (_circle3626 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7,
    cy: 95.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3627 || (_circle3627 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3628 || (_circle3628 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.2,
    cy: 92.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3629 || (_circle3629 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3630 || (_circle3630 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.7,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3631 || (_circle3631 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3632 || (_circle3632 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3633 || (_circle3633 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8,
    cy: 83.7,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3634 || (_circle3634 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3635 || (_circle3635 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3636 || (_circle3636 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 77,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3637 || (_circle3637 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.9,
    cy: 74.8,
    r: 0.8,
    className: "soundwave_svg__st16"
  })), _circle3638 || (_circle3638 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040.2,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3639 || (_circle3639 = /*#__PURE__*/React.createElement("circle", {
    cx: 1035.3,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3640 || (_circle3640 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030.4,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3641 || (_circle3641 = /*#__PURE__*/React.createElement("circle", {
    cx: 1025.5,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3642 || (_circle3642 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.6,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3643 || (_circle3643 = /*#__PURE__*/React.createElement("circle", {
    cx: 1015.8,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3644 || (_circle3644 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010.9,
    cy: 94.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3645 || (_circle3645 = /*#__PURE__*/React.createElement("circle", {
    cx: 1006,
    cy: 95.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3646 || (_circle3646 = /*#__PURE__*/React.createElement("circle", {
    cx: 1001.1,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3647 || (_circle3647 = /*#__PURE__*/React.createElement("circle", {
    cx: 996.1,
    cy: 96.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3648 || (_circle3648 = /*#__PURE__*/React.createElement("circle", {
    cx: 991.1,
    cy: 96.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3649 || (_circle3649 = /*#__PURE__*/React.createElement("circle", {
    cx: 986.1,
    cy: 96.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3650 || (_circle3650 = /*#__PURE__*/React.createElement("circle", {
    cx: 981.1,
    cy: 96.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3651 || (_circle3651 = /*#__PURE__*/React.createElement("circle", {
    cx: 976.1,
    cy: 96.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3652 || (_circle3652 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.1,
    cy: 96.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3653 || (_circle3653 = /*#__PURE__*/React.createElement("circle", {
    cx: 966.2,
    cy: 96.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3654 || (_circle3654 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.2,
    cy: 96.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3655 || (_circle3655 = /*#__PURE__*/React.createElement("circle", {
    cx: 956.2,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3656 || (_circle3656 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.3,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3657 || (_circle3657 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.4,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3658 || (_circle3658 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.4,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3659 || (_circle3659 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.5,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3660 || (_circle3660 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.6,
    cy: 92.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3661 || (_circle3661 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.6,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3662 || (_circle3662 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.7,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3663 || (_circle3663 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.8,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3664 || (_circle3664 = /*#__PURE__*/React.createElement("circle", {
    cx: 912.1,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3665 || (_circle3665 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.3,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3666 || (_circle3666 = /*#__PURE__*/React.createElement("circle", {
    cx: 902.6,
    cy: 85.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3667 || (_circle3667 = /*#__PURE__*/React.createElement("circle", {
    cx: 897.8,
    cy: 83.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3668 || (_circle3668 = /*#__PURE__*/React.createElement("circle", {
    cx: 893,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3669 || (_circle3669 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.3,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3670 || (_circle3670 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.5,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3671 || (_circle3671 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.7,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3672 || (_circle3672 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.1,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3673 || (_circle3673 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.6,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3674 || (_circle3674 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 72,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3675 || (_circle3675 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.5,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3676 || (_circle3676 = /*#__PURE__*/React.createElement("circle", {
    cx: 855.9,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3677 || (_circle3677 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.3,
    cy: 65.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3678 || (_circle3678 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.7,
    cy: 63.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3679 || (_circle3679 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.2,
    cy: 62,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3680 || (_circle3680 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.6,
    cy: 60,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3681 || (_circle3681 = /*#__PURE__*/React.createElement("circle", {
    cx: 833,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3682 || (_circle3682 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.4,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3683 || (_circle3683 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.6,
    cy: 54.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3684 || (_circle3684 = /*#__PURE__*/React.createElement("circle", {
    cx: 818.7,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3685 || (_circle3685 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.9,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3686 || (_circle3686 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 51.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3687 || (_circle3687 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.2,
    cy: 50.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3688 || (_circle3688 = /*#__PURE__*/React.createElement("circle", {
    cx: 799.3,
    cy: 49.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3689 || (_circle3689 = /*#__PURE__*/React.createElement("circle", {
    cx: 794.3,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3690 || (_circle3690 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.3,
    cy: 50,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3691 || (_circle3691 = /*#__PURE__*/React.createElement("circle", {
    cx: 784.3,
    cy: 50.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3692 || (_circle3692 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.3,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3693 || (_circle3693 = /*#__PURE__*/React.createElement("circle", {
    cx: 774.3,
    cy: 50.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3694 || (_circle3694 = /*#__PURE__*/React.createElement("circle", {
    cx: 769.4,
    cy: 50.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3695 || (_circle3695 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.5,
    cy: 51.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3696 || (_circle3696 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.6,
    cy: 52.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3697 || (_circle3697 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.8,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3698 || (_circle3698 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3699 || (_circle3699 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.2,
    cy: 56.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3700 || (_circle3700 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.3,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3701 || (_circle3701 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.5,
    cy: 58.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3702 || (_circle3702 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.7,
    cy: 60.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3703 || (_circle3703 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.1,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3704 || (_circle3704 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.4,
    cy: 63.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3705 || (_circle3705 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.8,
    cy: 65.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3706 || (_circle3706 = /*#__PURE__*/React.createElement("circle", {
    cx: 712.1,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3707 || (_circle3707 = /*#__PURE__*/React.createElement("circle", {
    cx: 707.5,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3708 || (_circle3708 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.8,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3709 || (_circle3709 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.2,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3710 || (_circle3710 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.5,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3711 || (_circle3711 = /*#__PURE__*/React.createElement("circle", {
    cx: 688.9,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3712 || (_circle3712 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.3,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3713 || (_circle3713 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.6,
    cy: 80.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3714 || (_circle3714 = /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 82.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3715 || (_circle3715 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.4,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3716 || (_circle3716 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.7,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3717 || (_circle3717 = /*#__PURE__*/React.createElement("circle", {
    cx: 661,
    cy: 87.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3718 || (_circle3718 = /*#__PURE__*/React.createElement("circle", {
    cx: 656.2,
    cy: 88.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3719 || (_circle3719 = /*#__PURE__*/React.createElement("circle", {
    cx: 651.5,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3720 || (_circle3720 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.7,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3721 || (_circle3721 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.9,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3722 || (_circle3722 = /*#__PURE__*/React.createElement("circle", {
    cx: 637.1,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3723 || (_circle3723 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.4,
    cy: 96.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3724 || (_circle3724 = /*#__PURE__*/React.createElement("circle", {
    cx: 627.5,
    cy: 97.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3725 || (_circle3725 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 97.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3726 || (_circle3726 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.6,
    cy: 98.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3727 || (_circle3727 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.6,
    cy: 98.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3728 || (_circle3728 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.7,
    cy: 99.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3729 || (_circle3729 = /*#__PURE__*/React.createElement("circle", {
    cx: 602.7,
    cy: 99.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3730 || (_circle3730 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.8,
    cy: 100.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3731 || (_circle3731 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.8,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3732 || (_circle3732 = /*#__PURE__*/React.createElement("circle", {
    cx: 587.9,
    cy: 99.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3733 || (_circle3733 = /*#__PURE__*/React.createElement("circle", {
    cx: 583,
    cy: 98.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3734 || (_circle3734 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.1,
    cy: 98,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3735 || (_circle3735 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.2,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3736 || (_circle3736 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.3,
    cy: 96.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3737 || (_circle3737 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.3,
    cy: 95.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3738 || (_circle3738 = /*#__PURE__*/React.createElement("circle", {
    cx: 558.4,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3739 || (_circle3739 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.6,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3740 || (_circle3740 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3741 || (_circle3741 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.4,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3742 || (_circle3742 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.7,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3743 || (_circle3743 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.1,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3744 || (_circle3744 = /*#__PURE__*/React.createElement("circle", {
    cx: 530.5,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3745 || (_circle3745 = /*#__PURE__*/React.createElement("circle", {
    cx: 525.9,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3746 || (_circle3746 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.2,
    cy: 80.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3747 || (_circle3747 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.7,
    cy: 78.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3748 || (_circle3748 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.2,
    cy: 76.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3749 || (_circle3749 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.7,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3750 || (_circle3750 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.2,
    cy: 71.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3751 || (_circle3751 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.7,
    cy: 69.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3752 || (_circle3752 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.2,
    cy: 67.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3753 || (_circle3753 = /*#__PURE__*/React.createElement("circle", {
    cx: 489.7,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3754 || (_circle3754 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.2,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3755 || (_circle3755 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.7,
    cy: 61.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3756 || (_circle3756 = /*#__PURE__*/React.createElement("circle", {
    cx: 476,
    cy: 59.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3757 || (_circle3757 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.4,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3758 || (_circle3758 = /*#__PURE__*/React.createElement("circle", {
    cx: 466.7,
    cy: 55.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3759 || (_circle3759 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.1,
    cy: 54,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3760 || (_circle3760 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.4,
    cy: 52.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3761 || (_circle3761 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.8,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3762 || (_circle3762 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.1,
    cy: 48.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3763 || (_circle3763 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.4,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3764 || (_circle3764 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.5,
    cy: 46.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3765 || (_circle3765 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.5,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3766 || (_circle3766 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.6,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3767 || (_circle3767 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.7,
    cy: 43.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3768 || (_circle3768 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.8,
    cy: 42.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3769 || (_circle3769 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.9,
    cy: 42.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3770 || (_circle3770 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 41.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3771 || (_circle3771 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 40.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3772 || (_circle3772 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.1,
    cy: 39.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3773 || (_circle3773 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.1,
    cy: 40,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3774 || (_circle3774 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.1,
    cy: 40.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3775 || (_circle3775 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.1,
    cy: 40.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3776 || (_circle3776 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.2,
    cy: 40.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3777 || (_circle3777 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.2,
    cy: 40.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3778 || (_circle3778 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.2,
    cy: 40.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3779 || (_circle3779 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.2,
    cy: 41.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3780 || (_circle3780 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.2,
    cy: 41.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3781 || (_circle3781 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.3,
    cy: 41.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3782 || (_circle3782 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.4,
    cy: 42.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3783 || (_circle3783 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.4,
    cy: 43.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3784 || (_circle3784 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.5,
    cy: 44.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3785 || (_circle3785 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.6,
    cy: 45.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3786 || (_circle3786 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.7,
    cy: 46.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3787 || (_circle3787 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.8,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3788 || (_circle3788 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.9,
    cy: 47.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3789 || (_circle3789 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 48.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3790 || (_circle3790 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.1,
    cy: 49.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3791 || (_circle3791 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.3,
    cy: 51.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3792 || (_circle3792 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3793 || (_circle3793 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.7,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3794 || (_circle3794 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.9,
    cy: 55.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3795 || (_circle3795 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.1,
    cy: 56.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3796 || (_circle3796 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.3,
    cy: 58,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3797 || (_circle3797 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 59.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3798 || (_circle3798 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.7,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3799 || (_circle3799 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3800 || (_circle3800 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.2,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3801 || (_circle3801 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3802 || (_circle3802 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.8,
    cy: 66.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3803 || (_circle3803 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.1,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3804 || (_circle3804 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.3,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3805 || (_circle3805 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.6,
    cy: 71.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3806 || (_circle3806 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.9,
    cy: 73.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3807 || (_circle3807 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.2,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3808 || (_circle3808 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3809 || (_circle3809 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.8,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3810 || (_circle3810 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.1,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3811 || (_circle3811 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.4,
    cy: 81.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3812 || (_circle3812 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.7,
    cy: 83.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3813 || (_circle3813 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3814 || (_circle3814 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.3,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3815 || (_circle3815 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.6,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3816 || (_circle3816 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.9,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3817 || (_circle3817 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.1,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3818 || (_circle3818 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.3,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3819 || (_circle3819 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3820 || (_circle3820 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.8,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3821 || (_circle3821 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 97.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3822 || (_circle3822 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.2,
    cy: 98.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3823 || (_circle3823 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.4,
    cy: 99.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3824 || (_circle3824 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 100.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3825 || (_circle3825 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 101.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3826 || (_circle3826 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.6,
    cy: 102,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3827 || (_circle3827 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.7,
    cy: 102.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3828 || (_circle3828 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.7,
    cy: 103.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3829 || (_circle3829 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.8,
    cy: 104.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3830 || (_circle3830 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.9,
    cy: 104.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3831 || (_circle3831 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.9,
    cy: 104.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3832 || (_circle3832 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.9,
    cy: 104.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3833 || (_circle3833 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.9,
    cy: 104.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3834 || (_circle3834 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9,
    cy: 104.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3835 || (_circle3835 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.9,
    cy: 103.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3836 || (_circle3836 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.9,
    cy: 103.8,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3837 || (_circle3837 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 103.1,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3838 || (_circle3838 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1,
    cy: 102.2,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3839 || (_circle3839 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.2,
    cy: 101.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3840 || (_circle3840 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.3,
    cy: 100.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3841 || (_circle3841 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.4,
    cy: 99.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3842 || (_circle3842 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 98.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3843 || (_circle3843 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.6,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3844 || (_circle3844 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3845 || (_circle3845 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.2,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3846 || (_circle3846 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3847 || (_circle3847 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.8,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3848 || (_circle3848 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3849 || (_circle3849 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3850 || (_circle3850 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1,
    cy: 85,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3851 || (_circle3851 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3852 || (_circle3852 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6,
    cy: 79.9,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3853 || (_circle3853 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 77.3,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3854 || (_circle3854 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.1,
    cy: 74.7,
    r: 0.8,
    className: "soundwave_svg__st17"
  })), _circle3855 || (_circle3855 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039.9,
    cy: 88.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3856 || (_circle3856 = /*#__PURE__*/React.createElement("circle", {
    cx: 1035,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3857 || (_circle3857 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030.2,
    cy: 90.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3858 || (_circle3858 = /*#__PURE__*/React.createElement("circle", {
    cx: 1025.3,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3859 || (_circle3859 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.4,
    cy: 92.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3860 || (_circle3860 = /*#__PURE__*/React.createElement("circle", {
    cx: 1015.6,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3861 || (_circle3861 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010.7,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3862 || (_circle3862 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.9,
    cy: 96.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3863 || (_circle3863 = /*#__PURE__*/React.createElement("circle", {
    cx: 1001,
    cy: 97.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3864 || (_circle3864 = /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3865 || (_circle3865 = /*#__PURE__*/React.createElement("circle", {
    cx: 991,
    cy: 97.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3866 || (_circle3866 = /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 97.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3867 || (_circle3867 = /*#__PURE__*/React.createElement("circle", {
    cx: 981,
    cy: 97.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3868 || (_circle3868 = /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 97.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3869 || (_circle3869 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.1,
    cy: 98,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3870 || (_circle3870 = /*#__PURE__*/React.createElement("circle", {
    cx: 966.1,
    cy: 98.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3871 || (_circle3871 = /*#__PURE__*/React.createElement("circle", {
    cx: 961.1,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3872 || (_circle3872 = /*#__PURE__*/React.createElement("circle", {
    cx: 956.1,
    cy: 97.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3873 || (_circle3873 = /*#__PURE__*/React.createElement("circle", {
    cx: 951.2,
    cy: 97.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3874 || (_circle3874 = /*#__PURE__*/React.createElement("circle", {
    cx: 946.3,
    cy: 96.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3875 || (_circle3875 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.3,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3876 || (_circle3876 = /*#__PURE__*/React.createElement("circle", {
    cx: 936.4,
    cy: 94.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3877 || (_circle3877 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.5,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3878 || (_circle3878 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.5,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3879 || (_circle3879 = /*#__PURE__*/React.createElement("circle", {
    cx: 921.6,
    cy: 92.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3880 || (_circle3880 = /*#__PURE__*/React.createElement("circle", {
    cx: 916.7,
    cy: 92,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3881 || (_circle3881 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.9,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3882 || (_circle3882 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.2,
    cy: 89,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3883 || (_circle3883 = /*#__PURE__*/React.createElement("circle", {
    cx: 902.4,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3884 || (_circle3884 = /*#__PURE__*/React.createElement("circle", {
    cx: 897.7,
    cy: 85.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3885 || (_circle3885 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.9,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3886 || (_circle3886 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.2,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3887 || (_circle3887 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.4,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3888 || (_circle3888 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.7,
    cy: 79.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3889 || (_circle3889 = /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3890 || (_circle3890 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.5,
    cy: 75.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3891 || (_circle3891 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 73.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3892 || (_circle3892 = /*#__PURE__*/React.createElement("circle", {
    cx: 860.5,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3893 || (_circle3893 = /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 69.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3894 || (_circle3894 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.5,
    cy: 67.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3895 || (_circle3895 = /*#__PURE__*/React.createElement("circle", {
    cx: 847,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3896 || (_circle3896 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.4,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3897 || (_circle3897 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.9,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3898 || (_circle3898 = /*#__PURE__*/React.createElement("circle", {
    cx: 833.3,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3899 || (_circle3899 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.8,
    cy: 57,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3900 || (_circle3900 = /*#__PURE__*/React.createElement("circle", {
    cx: 824.2,
    cy: 55,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3901 || (_circle3901 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.4,
    cy: 53.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3902 || (_circle3902 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.6,
    cy: 52.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3903 || (_circle3903 = /*#__PURE__*/React.createElement("circle", {
    cx: 809.8,
    cy: 51.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3904 || (_circle3904 = /*#__PURE__*/React.createElement("circle", {
    cx: 805,
    cy: 49.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3905 || (_circle3905 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.2,
    cy: 48.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3906 || (_circle3906 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.2,
    cy: 48.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3907 || (_circle3907 = /*#__PURE__*/React.createElement("circle", {
    cx: 790.3,
    cy: 48.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3908 || (_circle3908 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.3,
    cy: 48.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3909 || (_circle3909 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.3,
    cy: 48.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3910 || (_circle3910 = /*#__PURE__*/React.createElement("circle", {
    cx: 775.3,
    cy: 48.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3911 || (_circle3911 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.3,
    cy: 48.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3912 || (_circle3912 = /*#__PURE__*/React.createElement("circle", {
    cx: 765.3,
    cy: 48.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3913 || (_circle3913 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.4,
    cy: 49.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3914 || (_circle3914 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.6,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3915 || (_circle3915 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.8,
    cy: 51.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3916 || (_circle3916 = /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3917 || (_circle3917 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.2,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3918 || (_circle3918 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.3,
    cy: 55.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3919 || (_circle3919 = /*#__PURE__*/React.createElement("circle", {
    cx: 731.5,
    cy: 57.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3920 || (_circle3920 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.8,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3921 || (_circle3921 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.1,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3922 || (_circle3922 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.5,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3923 || (_circle3923 = /*#__PURE__*/React.createElement("circle", {
    cx: 712.9,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3924 || (_circle3924 = /*#__PURE__*/React.createElement("circle", {
    cx: 708.3,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3925 || (_circle3925 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.6,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3926 || (_circle3926 = /*#__PURE__*/React.createElement("circle", {
    cx: 699,
    cy: 69.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3927 || (_circle3927 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.4,
    cy: 71.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3928 || (_circle3928 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.8,
    cy: 73.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3929 || (_circle3929 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.2,
    cy: 75.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3930 || (_circle3930 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.6,
    cy: 77.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3931 || (_circle3931 = /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 79.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3932 || (_circle3932 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.4,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3933 || (_circle3933 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.8,
    cy: 83.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3934 || (_circle3934 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.2,
    cy: 85.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3935 || (_circle3935 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.6,
    cy: 87,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3936 || (_circle3936 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.8,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3937 || (_circle3937 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.1,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3938 || (_circle3938 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.3,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3939 || (_circle3939 = /*#__PURE__*/React.createElement("circle", {
    cx: 638.6,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3940 || (_circle3940 = /*#__PURE__*/React.createElement("circle", {
    cx: 633.8,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3941 || (_circle3941 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.1,
    cy: 96.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3942 || (_circle3942 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.3,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3943 || (_circle3943 = /*#__PURE__*/React.createElement("circle", {
    cx: 619.4,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3944 || (_circle3944 = /*#__PURE__*/React.createElement("circle", {
    cx: 614.4,
    cy: 98.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3945 || (_circle3945 = /*#__PURE__*/React.createElement("circle", {
    cx: 609.5,
    cy: 99.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3946 || (_circle3946 = /*#__PURE__*/React.createElement("circle", {
    cx: 604.5,
    cy: 99.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3947 || (_circle3947 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.6,
    cy: 100.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3948 || (_circle3948 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.6,
    cy: 101,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3949 || (_circle3949 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.6,
    cy: 101.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3950 || (_circle3950 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.7,
    cy: 101.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3951 || (_circle3951 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.8,
    cy: 100.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3952 || (_circle3952 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.9,
    cy: 99.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3953 || (_circle3953 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 98.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3954 || (_circle3954 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.1,
    cy: 97.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3955 || (_circle3955 = /*#__PURE__*/React.createElement("circle", {
    cx: 560.2,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3956 || (_circle3956 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.3,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3957 || (_circle3957 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.3,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3958 || (_circle3958 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.6,
    cy: 93.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3959 || (_circle3959 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.9,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3960 || (_circle3960 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.3,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3961 || (_circle3961 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.7,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3962 || (_circle3962 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.1,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3963 || (_circle3963 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.4,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3964 || (_circle3964 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.8,
    cy: 82.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3965 || (_circle3965 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.2,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3966 || (_circle3966 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.6,
    cy: 78.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3967 || (_circle3967 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.1,
    cy: 76.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3968 || (_circle3968 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.6,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3969 || (_circle3969 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.1,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3970 || (_circle3970 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.6,
    cy: 70.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3971 || (_circle3971 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.1,
    cy: 67.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3972 || (_circle3972 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.6,
    cy: 65.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3973 || (_circle3973 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.1,
    cy: 63.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3974 || (_circle3974 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.6,
    cy: 61.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3975 || (_circle3975 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.9,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3976 || (_circle3976 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.3,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3977 || (_circle3977 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.6,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3978 || (_circle3978 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 54.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3979 || (_circle3979 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.3,
    cy: 52.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3980 || (_circle3980 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.7,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3981 || (_circle3981 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 48.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3982 || (_circle3982 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.4,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3983 || (_circle3983 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.6,
    cy: 45.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3984 || (_circle3984 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.7,
    cy: 44.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3985 || (_circle3985 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.8,
    cy: 44.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3986 || (_circle3986 = /*#__PURE__*/React.createElement("circle", {
    cx: 415.8,
    cy: 43.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3987 || (_circle3987 = /*#__PURE__*/React.createElement("circle", {
    cx: 410.9,
    cy: 42.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3988 || (_circle3988 = /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 41.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3989 || (_circle3989 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.1,
    cy: 40.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3990 || (_circle3990 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.2,
    cy: 39.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3991 || (_circle3991 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.3,
    cy: 39,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3992 || (_circle3992 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.3,
    cy: 38.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3993 || (_circle3993 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.3,
    cy: 39,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3994 || (_circle3994 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.3,
    cy: 39.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3995 || (_circle3995 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.3,
    cy: 39.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3996 || (_circle3996 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.4,
    cy: 39.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3997 || (_circle3997 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.4,
    cy: 39.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3998 || (_circle3998 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.4,
    cy: 39.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle3999 || (_circle3999 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.4,
    cy: 39.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4000 || (_circle4000 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.4,
    cy: 40,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4001 || (_circle4001 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.5,
    cy: 40.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4002 || (_circle4002 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.6,
    cy: 41.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4003 || (_circle4003 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.7,
    cy: 42.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4004 || (_circle4004 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.8,
    cy: 43.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4005 || (_circle4005 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.9,
    cy: 44.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4006 || (_circle4006 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 45.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4007 || (_circle4007 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.1,
    cy: 46.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4008 || (_circle4008 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.1,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4009 || (_circle4009 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.2,
    cy: 47.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4010 || (_circle4010 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.4,
    cy: 49.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4011 || (_circle4011 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.6,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4012 || (_circle4012 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.9,
    cy: 52,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4013 || (_circle4013 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.1,
    cy: 53.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4014 || (_circle4014 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.3,
    cy: 54.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4015 || (_circle4015 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.5,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4016 || (_circle4016 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.7,
    cy: 57.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4017 || (_circle4017 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4018 || (_circle4018 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.1,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4019 || (_circle4019 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.4,
    cy: 62,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4020 || (_circle4020 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.7,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4021 || (_circle4021 = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 65.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4022 || (_circle4022 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.4,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4023 || (_circle4023 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.7,
    cy: 68.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4024 || (_circle4024 = /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 70.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4025 || (_circle4025 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.3,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4026 || (_circle4026 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.6,
    cy: 74,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4027 || (_circle4027 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.9,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4028 || (_circle4028 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.3,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4029 || (_circle4029 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.6,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4030 || (_circle4030 = /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4031 || (_circle4031 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.4,
    cy: 83,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4032 || (_circle4032 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.7,
    cy: 84.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4033 || (_circle4033 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.1,
    cy: 86.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4034 || (_circle4034 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 88.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4035 || (_circle4035 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.8,
    cy: 90.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4036 || (_circle4036 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 91.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4037 || (_circle4037 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.3,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4038 || (_circle4038 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.6,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4039 || (_circle4039 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.9,
    cy: 96.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4040 || (_circle4040 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.2,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4041 || (_circle4041 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.4,
    cy: 99.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4042 || (_circle4042 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.6,
    cy: 101.1,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4043 || (_circle4043 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.7,
    cy: 102,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4044 || (_circle4044 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.8,
    cy: 102.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4045 || (_circle4045 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.9,
    cy: 103.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4046 || (_circle4046 = /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 104.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4047 || (_circle4047 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.1,
    cy: 105.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4048 || (_circle4048 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 106.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4049 || (_circle4049 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.2,
    cy: 107,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4050 || (_circle4050 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.3,
    cy: 106.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4051 || (_circle4051 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.3,
    cy: 106.8,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4052 || (_circle4052 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3,
    cy: 106.7,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4053 || (_circle4053 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.3,
    cy: 106.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4054 || (_circle4054 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3,
    cy: 106.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4055 || (_circle4055 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.3,
    cy: 106.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4056 || (_circle4056 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4,
    cy: 105.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4057 || (_circle4057 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 104.4,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4058 || (_circle4058 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.7,
    cy: 103.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4059 || (_circle4059 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.8,
    cy: 102.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4060 || (_circle4060 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9,
    cy: 101.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4061 || (_circle4061 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4062 || (_circle4062 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.3,
    cy: 98.9,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4063 || (_circle4063 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7,
    cy: 97,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4064 || (_circle4064 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 95.2,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4065 || (_circle4065 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.4,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4066 || (_circle4066 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.8,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4067 || (_circle4067 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4068 || (_circle4068 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4069 || (_circle4069 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 83.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4070 || (_circle4070 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 80.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4071 || (_circle4071 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4072 || (_circle4072 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.2,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st18"
  })), _circle4073 || (_circle4073 = /*#__PURE__*/React.createElement("circle", {
    cx: 1043.9,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4074 || (_circle4074 = /*#__PURE__*/React.createElement("circle", {
    cx: 1039,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4075 || (_circle4075 = /*#__PURE__*/React.createElement("circle", {
    cx: 1034.2,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4076 || (_circle4076 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029.4,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4077 || (_circle4077 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024.5,
    cy: 92.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4078 || (_circle4078 = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.7,
    cy: 93.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4079 || (_circle4079 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.9,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4080 || (_circle4080 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4081 || (_circle4081 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.2,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4082 || (_circle4082 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000.3,
    cy: 98.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4083 || (_circle4083 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.3,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4084 || (_circle4084 = /*#__PURE__*/React.createElement("circle", {
    cx: 990.3,
    cy: 98.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4085 || (_circle4085 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.4,
    cy: 98.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4086 || (_circle4086 = /*#__PURE__*/React.createElement("circle", {
    cx: 980.4,
    cy: 99,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4087 || (_circle4087 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.4,
    cy: 99.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4088 || (_circle4088 = /*#__PURE__*/React.createElement("circle", {
    cx: 970.4,
    cy: 99.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4089 || (_circle4089 = /*#__PURE__*/React.createElement("circle", {
    cx: 965.4,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4090 || (_circle4090 = /*#__PURE__*/React.createElement("circle", {
    cx: 960.4,
    cy: 99.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4091 || (_circle4091 = /*#__PURE__*/React.createElement("circle", {
    cx: 955.5,
    cy: 99.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4092 || (_circle4092 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.5,
    cy: 98.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4093 || (_circle4093 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.6,
    cy: 98.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4094 || (_circle4094 = /*#__PURE__*/React.createElement("circle", {
    cx: 940.7,
    cy: 97.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4095 || (_circle4095 = /*#__PURE__*/React.createElement("circle", {
    cx: 935.7,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4096 || (_circle4096 = /*#__PURE__*/React.createElement("circle", {
    cx: 930.8,
    cy: 96.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4097 || (_circle4097 = /*#__PURE__*/React.createElement("circle", {
    cx: 925.9,
    cy: 95.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4098 || (_circle4098 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.9,
    cy: 94.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4099 || (_circle4099 = /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4100 || (_circle4100 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.2,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4101 || (_circle4101 = /*#__PURE__*/React.createElement("circle", {
    cx: 906.5,
    cy: 91,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4102 || (_circle4102 = /*#__PURE__*/React.createElement("circle", {
    cx: 901.8,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4103 || (_circle4103 = /*#__PURE__*/React.createElement("circle", {
    cx: 897,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4104 || (_circle4104 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.3,
    cy: 86.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4105 || (_circle4105 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.6,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4106 || (_circle4106 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.8,
    cy: 83,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4107 || (_circle4107 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.1,
    cy: 81.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4108 || (_circle4108 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.4,
    cy: 79.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4109 || (_circle4109 = /*#__PURE__*/React.createElement("circle", {
    cx: 868.9,
    cy: 77.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4110 || (_circle4110 = /*#__PURE__*/React.createElement("circle", {
    cx: 864.5,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4111 || (_circle4111 = /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4112 || (_circle4112 = /*#__PURE__*/React.createElement("circle", {
    cx: 855.5,
    cy: 70.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4113 || (_circle4113 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.1,
    cy: 68.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4114 || (_circle4114 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.6,
    cy: 66.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4115 || (_circle4115 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.1,
    cy: 64.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4116 || (_circle4116 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.6,
    cy: 62.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4117 || (_circle4117 = /*#__PURE__*/React.createElement("circle", {
    cx: 833.2,
    cy: 59.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4118 || (_circle4118 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.7,
    cy: 57.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4119 || (_circle4119 = /*#__PURE__*/React.createElement("circle", {
    cx: 824.2,
    cy: 55.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4120 || (_circle4120 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.6,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4121 || (_circle4121 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.8,
    cy: 52.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4122 || (_circle4122 = /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 50.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4123 || (_circle4123 = /*#__PURE__*/React.createElement("circle", {
    cx: 805.2,
    cy: 49.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4124 || (_circle4124 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.4,
    cy: 48.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4125 || (_circle4125 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.7,
    cy: 46.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4126 || (_circle4126 = /*#__PURE__*/React.createElement("circle", {
    cx: 790.7,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4127 || (_circle4127 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.7,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4128 || (_circle4128 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.7,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4129 || (_circle4129 = /*#__PURE__*/React.createElement("circle", {
    cx: 775.7,
    cy: 46.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4130 || (_circle4130 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.8,
    cy: 46.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4131 || (_circle4131 = /*#__PURE__*/React.createElement("circle", {
    cx: 765.8,
    cy: 46.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4132 || (_circle4132 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.8,
    cy: 46.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4133 || (_circle4133 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.9,
    cy: 47.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4134 || (_circle4134 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.1,
    cy: 48.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4135 || (_circle4135 = /*#__PURE__*/React.createElement("circle", {
    cx: 746.3,
    cy: 49.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4136 || (_circle4136 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.4,
    cy: 51.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4137 || (_circle4137 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.6,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4138 || (_circle4138 = /*#__PURE__*/React.createElement("circle", {
    cx: 731.8,
    cy: 53.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4139 || (_circle4139 = /*#__PURE__*/React.createElement("circle", {
    cx: 727,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4140 || (_circle4140 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.2,
    cy: 56.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4141 || (_circle4141 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.6,
    cy: 58.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4142 || (_circle4142 = /*#__PURE__*/React.createElement("circle", {
    cx: 713,
    cy: 60.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4143 || (_circle4143 = /*#__PURE__*/React.createElement("circle", {
    cx: 708.4,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4144 || (_circle4144 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.8,
    cy: 64.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4145 || (_circle4145 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.2,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4146 || (_circle4146 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.6,
    cy: 68,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4147 || (_circle4147 = /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4148 || (_circle4148 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.4,
    cy: 71.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4149 || (_circle4149 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.9,
    cy: 73.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4150 || (_circle4150 = /*#__PURE__*/React.createElement("circle", {
    cx: 676.3,
    cy: 76,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4151 || (_circle4151 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.7,
    cy: 78,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4152 || (_circle4152 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.2,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4153 || (_circle4153 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.6,
    cy: 82,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4154 || (_circle4154 = /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 84,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4155 || (_circle4155 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.5,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4156 || (_circle4156 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.7,
    cy: 87.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4157 || (_circle4157 = /*#__PURE__*/React.createElement("circle", {
    cx: 644,
    cy: 89.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4158 || (_circle4158 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.3,
    cy: 90.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4159 || (_circle4159 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.6,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4160 || (_circle4160 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.9,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4161 || (_circle4161 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.1,
    cy: 95.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4162 || (_circle4162 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.4,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4163 || (_circle4163 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.6,
    cy: 98.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4164 || (_circle4164 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.6,
    cy: 98.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4165 || (_circle4165 = /*#__PURE__*/React.createElement("circle", {
    cx: 605.7,
    cy: 99.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4166 || (_circle4166 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.7,
    cy: 100.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4167 || (_circle4167 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.8,
    cy: 100.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4168 || (_circle4168 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.8,
    cy: 101.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4169 || (_circle4169 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.9,
    cy: 102.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4170 || (_circle4170 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.9,
    cy: 102.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4171 || (_circle4171 = /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 101.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4172 || (_circle4172 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.1,
    cy: 100.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4173 || (_circle4173 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.2,
    cy: 100,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4174 || (_circle4174 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.3,
    cy: 99.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4175 || (_circle4175 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.4,
    cy: 98.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4176 || (_circle4176 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.4,
    cy: 97.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4177 || (_circle4177 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.5,
    cy: 96.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4178 || (_circle4178 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.6,
    cy: 95.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4179 || (_circle4179 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.9,
    cy: 94.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4180 || (_circle4180 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.3,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4181 || (_circle4181 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.7,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4182 || (_circle4182 = /*#__PURE__*/React.createElement("circle", {
    cx: 523,
    cy: 88.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4183 || (_circle4183 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.4,
    cy: 86.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4184 || (_circle4184 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.8,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4185 || (_circle4185 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.2,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4186 || (_circle4186 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.5,
    cy: 81.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4187 || (_circle4187 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.9,
    cy: 79.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4188 || (_circle4188 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.4,
    cy: 77.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4189 || (_circle4189 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.9,
    cy: 74.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4190 || (_circle4190 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.5,
    cy: 72.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4191 || (_circle4191 = /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 70.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4192 || (_circle4192 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.5,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4193 || (_circle4193 = /*#__PURE__*/React.createElement("circle", {
    cx: 473,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4194 || (_circle4194 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.5,
    cy: 64.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4195 || (_circle4195 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 61.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4196 || (_circle4196 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.4,
    cy: 60,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4197 || (_circle4197 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.8,
    cy: 58.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4198 || (_circle4198 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.1,
    cy: 56.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4199 || (_circle4199 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.5,
    cy: 54.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4200 || (_circle4200 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.8,
    cy: 52.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4201 || (_circle4201 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.2,
    cy: 50.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4202 || (_circle4202 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.6,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4203 || (_circle4203 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.9,
    cy: 47.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4204 || (_circle4204 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.3,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4205 || (_circle4205 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.4,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4206 || (_circle4206 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.5,
    cy: 43.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4207 || (_circle4207 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.6,
    cy: 42.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4208 || (_circle4208 = /*#__PURE__*/React.createElement("circle", {
    cx: 402.6,
    cy: 41.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4209 || (_circle4209 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.7,
    cy: 41,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4210 || (_circle4210 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.8,
    cy: 40.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4211 || (_circle4211 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.9,
    cy: 39.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4212 || (_circle4212 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 38.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4213 || (_circle4213 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.1,
    cy: 37.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4214 || (_circle4214 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.1,
    cy: 37.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4215 || (_circle4215 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.1,
    cy: 38,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4216 || (_circle4216 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.1,
    cy: 38.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4217 || (_circle4217 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.1,
    cy: 38.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4218 || (_circle4218 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.1,
    cy: 38.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4219 || (_circle4219 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.1,
    cy: 38.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4220 || (_circle4220 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.2,
    cy: 38.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4221 || (_circle4221 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.2,
    cy: 38.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4222 || (_circle4222 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.2,
    cy: 39.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4223 || (_circle4223 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.3,
    cy: 40.1,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4224 || (_circle4224 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.4,
    cy: 41,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4225 || (_circle4225 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 41.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4226 || (_circle4226 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.6,
    cy: 42.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4227 || (_circle4227 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.7,
    cy: 43.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4228 || (_circle4228 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.8,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4229 || (_circle4229 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.9,
    cy: 45.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4230 || (_circle4230 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.9,
    cy: 46.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4231 || (_circle4231 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.1,
    cy: 47.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4232 || (_circle4232 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.3,
    cy: 48.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4233 || (_circle4233 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.6,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4234 || (_circle4234 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.8,
    cy: 51.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4235 || (_circle4235 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 53.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4236 || (_circle4236 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.2,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4237 || (_circle4237 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.4,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4238 || (_circle4238 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.7,
    cy: 57.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4239 || (_circle4239 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.9,
    cy: 58.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4240 || (_circle4240 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.2,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4241 || (_circle4241 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.6,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4242 || (_circle4242 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.9,
    cy: 64.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4243 || (_circle4243 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.2,
    cy: 66,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4244 || (_circle4244 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.6,
    cy: 67.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4245 || (_circle4245 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.9,
    cy: 69.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4246 || (_circle4246 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.3,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4247 || (_circle4247 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.6,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4248 || (_circle4248 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 75,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4249 || (_circle4249 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.4,
    cy: 77,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4250 || (_circle4250 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.8,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4251 || (_circle4251 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.3,
    cy: 80.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4252 || (_circle4252 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.7,
    cy: 82.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4253 || (_circle4253 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.1,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4254 || (_circle4254 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.6,
    cy: 86.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4255 || (_circle4255 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 88.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4256 || (_circle4256 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.3,
    cy: 90.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4257 || (_circle4257 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.7,
    cy: 92.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4258 || (_circle4258 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 94.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4259 || (_circle4259 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.3,
    cy: 96,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4260 || (_circle4260 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.7,
    cy: 97.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4261 || (_circle4261 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 99.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4262 || (_circle4262 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.4,
    cy: 101.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4263 || (_circle4263 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 102.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4264 || (_circle4264 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.7,
    cy: 103.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4265 || (_circle4265 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.8,
    cy: 104.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4266 || (_circle4266 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.9,
    cy: 105.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4267 || (_circle4267 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 106.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4268 || (_circle4268 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.2,
    cy: 107.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4269 || (_circle4269 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.3,
    cy: 108.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4270 || (_circle4270 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.3,
    cy: 109.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4271 || (_circle4271 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.3,
    cy: 109.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4272 || (_circle4272 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.4,
    cy: 109.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4273 || (_circle4273 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.4,
    cy: 109.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4274 || (_circle4274 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.4,
    cy: 109.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4275 || (_circle4275 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4,
    cy: 109.2,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4276 || (_circle4276 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 108.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4277 || (_circle4277 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.6,
    cy: 107.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4278 || (_circle4278 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7,
    cy: 106.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4279 || (_circle4279 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.8,
    cy: 105.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4280 || (_circle4280 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.9,
    cy: 104.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4281 || (_circle4281 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 103.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4282 || (_circle4282 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.4,
    cy: 101.8,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4283 || (_circle4283 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4284 || (_circle4284 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4285 || (_circle4285 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8,
    cy: 95.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4286 || (_circle4286 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2,
    cy: 93.5,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4287 || (_circle4287 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4288 || (_circle4288 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4289 || (_circle4289 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4290 || (_circle4290 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4291 || (_circle4291 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4292 || (_circle4292 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.3,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st19"
  })), _circle4293 || (_circle4293 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042.4,
    cy: 87.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4294 || (_circle4294 = /*#__PURE__*/React.createElement("circle", {
    cx: 1037.6,
    cy: 89.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4295 || (_circle4295 = /*#__PURE__*/React.createElement("circle", {
    cx: 1032.8,
    cy: 90.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4296 || (_circle4296 = /*#__PURE__*/React.createElement("circle", {
    cx: 1028,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4297 || (_circle4297 = /*#__PURE__*/React.createElement("circle", {
    cx: 1023.2,
    cy: 93.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4298 || (_circle4298 = /*#__PURE__*/React.createElement("circle", {
    cx: 1018.4,
    cy: 94.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4299 || (_circle4299 = /*#__PURE__*/React.createElement("circle", {
    cx: 1013.6,
    cy: 95.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4300 || (_circle4300 = /*#__PURE__*/React.createElement("circle", {
    cx: 1008.8,
    cy: 97,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4301 || (_circle4301 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004,
    cy: 98.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4302 || (_circle4302 = /*#__PURE__*/React.createElement("circle", {
    cx: 999.1,
    cy: 99.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4303 || (_circle4303 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.1,
    cy: 99.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4304 || (_circle4304 = /*#__PURE__*/React.createElement("circle", {
    cx: 989.1,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4305 || (_circle4305 = /*#__PURE__*/React.createElement("circle", {
    cx: 984.1,
    cy: 100,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4306 || (_circle4306 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.1,
    cy: 100.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4307 || (_circle4307 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.2,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4308 || (_circle4308 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.2,
    cy: 100.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4309 || (_circle4309 = /*#__PURE__*/React.createElement("circle", {
    cx: 964.2,
    cy: 101.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4310 || (_circle4310 = /*#__PURE__*/React.createElement("circle", {
    cx: 959.2,
    cy: 101.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4311 || (_circle4311 = /*#__PURE__*/React.createElement("circle", {
    cx: 954.3,
    cy: 101.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4312 || (_circle4312 = /*#__PURE__*/React.createElement("circle", {
    cx: 949.3,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4313 || (_circle4313 = /*#__PURE__*/React.createElement("circle", {
    cx: 944.4,
    cy: 99.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4314 || (_circle4314 = /*#__PURE__*/React.createElement("circle", {
    cx: 939.5,
    cy: 99.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4315 || (_circle4315 = /*#__PURE__*/React.createElement("circle", {
    cx: 934.5,
    cy: 98.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4316 || (_circle4316 = /*#__PURE__*/React.createElement("circle", {
    cx: 929.6,
    cy: 97.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4317 || (_circle4317 = /*#__PURE__*/React.createElement("circle", {
    cx: 924.6,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4318 || (_circle4318 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.7,
    cy: 96.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4319 || (_circle4319 = /*#__PURE__*/React.createElement("circle", {
    cx: 914.8,
    cy: 95.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4320 || (_circle4320 = /*#__PURE__*/React.createElement("circle", {
    cx: 910,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4321 || (_circle4321 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.3,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4322 || (_circle4322 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.5,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4323 || (_circle4323 = /*#__PURE__*/React.createElement("circle", {
    cx: 895.8,
    cy: 89.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4324 || (_circle4324 = /*#__PURE__*/React.createElement("circle", {
    cx: 891.1,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4325 || (_circle4325 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.4,
    cy: 86.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4326 || (_circle4326 = /*#__PURE__*/React.createElement("circle", {
    cx: 881.7,
    cy: 84.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4327 || (_circle4327 = /*#__PURE__*/React.createElement("circle", {
    cx: 877,
    cy: 83,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4328 || (_circle4328 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.3,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4329 || (_circle4329 = /*#__PURE__*/React.createElement("circle", {
    cx: 867.8,
    cy: 79.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4330 || (_circle4330 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.4,
    cy: 76.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4331 || (_circle4331 = /*#__PURE__*/React.createElement("circle", {
    cx: 859,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4332 || (_circle4332 = /*#__PURE__*/React.createElement("circle", {
    cx: 854.6,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4333 || (_circle4333 = /*#__PURE__*/React.createElement("circle", {
    cx: 850.1,
    cy: 69.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4334 || (_circle4334 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.7,
    cy: 67.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4335 || (_circle4335 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.3,
    cy: 65.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4336 || (_circle4336 = /*#__PURE__*/React.createElement("circle", {
    cx: 836.9,
    cy: 63,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4337 || (_circle4337 = /*#__PURE__*/React.createElement("circle", {
    cx: 832.4,
    cy: 60.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4338 || (_circle4338 = /*#__PURE__*/React.createElement("circle", {
    cx: 828,
    cy: 58.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4339 || (_circle4339 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.5,
    cy: 56.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4340 || (_circle4340 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.1,
    cy: 53.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4341 || (_circle4341 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.4,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4342 || (_circle4342 = /*#__PURE__*/React.createElement("circle", {
    cx: 809.6,
    cy: 50.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4343 || (_circle4343 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.9,
    cy: 49.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4344 || (_circle4344 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.1,
    cy: 47.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4345 || (_circle4345 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.4,
    cy: 46.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4346 || (_circle4346 = /*#__PURE__*/React.createElement("circle", {
    cx: 790.6,
    cy: 44.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4347 || (_circle4347 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.6,
    cy: 44.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4348 || (_circle4348 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.7,
    cy: 44.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4349 || (_circle4349 = /*#__PURE__*/React.createElement("circle", {
    cx: 775.7,
    cy: 44.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4350 || (_circle4350 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.7,
    cy: 44.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4351 || (_circle4351 = /*#__PURE__*/React.createElement("circle", {
    cx: 765.7,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4352 || (_circle4352 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.7,
    cy: 44.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4353 || (_circle4353 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.7,
    cy: 44.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4354 || (_circle4354 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.9,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4355 || (_circle4355 = /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 46.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4356 || (_circle4356 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.2,
    cy: 47.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4357 || (_circle4357 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.4,
    cy: 49.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4358 || (_circle4358 = /*#__PURE__*/React.createElement("circle", {
    cx: 731.6,
    cy: 50.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4359 || (_circle4359 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.8,
    cy: 51.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4360 || (_circle4360 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.9,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4361 || (_circle4361 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.2,
    cy: 54.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4362 || (_circle4362 = /*#__PURE__*/React.createElement("circle", {
    cx: 712.6,
    cy: 56.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4363 || (_circle4363 = /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 58.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4364 || (_circle4364 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.5,
    cy: 60.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4365 || (_circle4365 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.9,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4366 || (_circle4366 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.3,
    cy: 64.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4367 || (_circle4367 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.7,
    cy: 66.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4368 || (_circle4368 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.1,
    cy: 68.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4369 || (_circle4369 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.5,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4370 || (_circle4370 = /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 72.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4371 || (_circle4371 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.5,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4372 || (_circle4372 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.9,
    cy: 76.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4373 || (_circle4373 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.4,
    cy: 78.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4374 || (_circle4374 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.9,
    cy: 80.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4375 || (_circle4375 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.3,
    cy: 82.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4376 || (_circle4376 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.8,
    cy: 84.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4377 || (_circle4377 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.1,
    cy: 86.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4378 || (_circle4378 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.4,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4379 || (_circle4379 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.7,
    cy: 90,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4380 || (_circle4380 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.1,
    cy: 91.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4381 || (_circle4381 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.4,
    cy: 93.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4382 || (_circle4382 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.7,
    cy: 95.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4383 || (_circle4383 = /*#__PURE__*/React.createElement("circle", {
    cx: 616,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4384 || (_circle4384 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.2,
    cy: 98.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4385 || (_circle4385 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.3,
    cy: 99,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4386 || (_circle4386 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.4,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4387 || (_circle4387 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.4,
    cy: 100.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4388 || (_circle4388 = /*#__PURE__*/React.createElement("circle", {
    cx: 591.5,
    cy: 101.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4389 || (_circle4389 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.6,
    cy: 101.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4390 || (_circle4390 = /*#__PURE__*/React.createElement("circle", {
    cx: 581.6,
    cy: 102.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4391 || (_circle4391 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.7,
    cy: 103.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4392 || (_circle4392 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.8,
    cy: 103.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4393 || (_circle4393 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.8,
    cy: 102.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4394 || (_circle4394 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.9,
    cy: 101.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4395 || (_circle4395 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.9,
    cy: 101.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4396 || (_circle4396 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4397 || (_circle4397 = /*#__PURE__*/React.createElement("circle", {
    cx: 547,
    cy: 100,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4398 || (_circle4398 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.1,
    cy: 99.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4399 || (_circle4399 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.3,
    cy: 97.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4400 || (_circle4400 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.6,
    cy: 96.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4401 || (_circle4401 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.9,
    cy: 94.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4402 || (_circle4402 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.2,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4403 || (_circle4403 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.5,
    cy: 91.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4404 || (_circle4404 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.8,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4405 || (_circle4405 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 88,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4406 || (_circle4406 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.5,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4407 || (_circle4407 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4408 || (_circle4408 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.5,
    cy: 81.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4409 || (_circle4409 = /*#__PURE__*/React.createElement("circle", {
    cx: 491,
    cy: 79.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4410 || (_circle4410 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.5,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4411 || (_circle4411 = /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 75.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4412 || (_circle4412 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.5,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4413 || (_circle4413 = /*#__PURE__*/React.createElement("circle", {
    cx: 473,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4414 || (_circle4414 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.5,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4415 || (_circle4415 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 66.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4416 || (_circle4416 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.5,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4417 || (_circle4417 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 62.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4418 || (_circle4418 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.5,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4419 || (_circle4419 = /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 58,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4420 || (_circle4420 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.4,
    cy: 56.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4421 || (_circle4421 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.8,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4422 || (_circle4422 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.1,
    cy: 52.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4423 || (_circle4423 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.5,
    cy: 50.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4424 || (_circle4424 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.8,
    cy: 48.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4425 || (_circle4425 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.1,
    cy: 47.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4426 || (_circle4426 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.5,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4427 || (_circle4427 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.7,
    cy: 44,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4428 || (_circle4428 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.8,
    cy: 43.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4429 || (_circle4429 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.9,
    cy: 42.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4430 || (_circle4430 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.9,
    cy: 41.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4431 || (_circle4431 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 41,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4432 || (_circle4432 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.1,
    cy: 40.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4433 || (_circle4433 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.1,
    cy: 39.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4434 || (_circle4434 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.2,
    cy: 38.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4435 || (_circle4435 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.3,
    cy: 37.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4436 || (_circle4436 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.4,
    cy: 37.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4437 || (_circle4437 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.4,
    cy: 36.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4438 || (_circle4438 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.5,
    cy: 36.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4439 || (_circle4439 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.5,
    cy: 36.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4440 || (_circle4440 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.5,
    cy: 37.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4441 || (_circle4441 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.5,
    cy: 37.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4442 || (_circle4442 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.6,
    cy: 38,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4443 || (_circle4443 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.6,
    cy: 38.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4444 || (_circle4444 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.6,
    cy: 38.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4445 || (_circle4445 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.7,
    cy: 39.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4446 || (_circle4446 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.7,
    cy: 39.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4447 || (_circle4447 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.7,
    cy: 40,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4448 || (_circle4448 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.7,
    cy: 40.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4449 || (_circle4449 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.9,
    cy: 41.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4450 || (_circle4450 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.1,
    cy: 42.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4451 || (_circle4451 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.3,
    cy: 44.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4452 || (_circle4452 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.4,
    cy: 45.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4453 || (_circle4453 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.6,
    cy: 46.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4454 || (_circle4454 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.8,
    cy: 47.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4455 || (_circle4455 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.9,
    cy: 49.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4456 || (_circle4456 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.1,
    cy: 50.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4457 || (_circle4457 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.3,
    cy: 51.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4458 || (_circle4458 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.4,
    cy: 52.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4459 || (_circle4459 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.6,
    cy: 54.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4460 || (_circle4460 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 56,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4461 || (_circle4461 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.4,
    cy: 57.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4462 || (_circle4462 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.7,
    cy: 59.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4463 || (_circle4463 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.1,
    cy: 61.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4464 || (_circle4464 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 63.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4465 || (_circle4465 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.8,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4466 || (_circle4466 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.2,
    cy: 67.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4467 || (_circle4467 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.6,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4468 || (_circle4468 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.9,
    cy: 70.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4469 || (_circle4469 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.3,
    cy: 72.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4470 || (_circle4470 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.7,
    cy: 74.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4471 || (_circle4471 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.2,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4472 || (_circle4472 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.7,
    cy: 78.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4473 || (_circle4473 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.2,
    cy: 81,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4474 || (_circle4474 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.7,
    cy: 83.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4475 || (_circle4475 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.2,
    cy: 85.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4476 || (_circle4476 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.7,
    cy: 87.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4477 || (_circle4477 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.2,
    cy: 89.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4478 || (_circle4478 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.6,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4479 || (_circle4479 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 93.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4480 || (_circle4480 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.4,
    cy: 95.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4481 || (_circle4481 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.8,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4482 || (_circle4482 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.2,
    cy: 99.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4483 || (_circle4483 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.6,
    cy: 101.1,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4484 || (_circle4484 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 103,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4485 || (_circle4485 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.1,
    cy: 104.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4486 || (_circle4486 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.3,
    cy: 105.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4487 || (_circle4487 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.4,
    cy: 106.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4488 || (_circle4488 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.6,
    cy: 107.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4489 || (_circle4489 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.7,
    cy: 109,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4490 || (_circle4490 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.9,
    cy: 110.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4491 || (_circle4491 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.1,
    cy: 111.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4492 || (_circle4492 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.1,
    cy: 111.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4493 || (_circle4493 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.1,
    cy: 111.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4494 || (_circle4494 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.1,
    cy: 111.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4495 || (_circle4495 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.1,
    cy: 111.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4496 || (_circle4496 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.1,
    cy: 111.8,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4497 || (_circle4497 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2,
    cy: 111.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4498 || (_circle4498 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.3,
    cy: 110.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4499 || (_circle4499 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4,
    cy: 109.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4500 || (_circle4500 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6,
    cy: 108.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4501 || (_circle4501 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7,
    cy: 107.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4502 || (_circle4502 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.8,
    cy: 106.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4503 || (_circle4503 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.2,
    cy: 104.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4504 || (_circle4504 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7,
    cy: 102.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4505 || (_circle4505 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3,
    cy: 100,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4506 || (_circle4506 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9,
    cy: 97.7,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4507 || (_circle4507 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 95.4,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4508 || (_circle4508 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1,
    cy: 93,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4509 || (_circle4509 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8,
    cy: 89.3,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4510 || (_circle4510 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4,
    cy: 85.6,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4511 || (_circle4511 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1,
    cy: 81.9,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4512 || (_circle4512 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.8,
    cy: 78.2,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4513 || (_circle4513 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.4,
    cy: 74.5,
    r: 0.8,
    className: "soundwave_svg__st20"
  })), _circle4514 || (_circle4514 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040.5,
    cy: 88.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4515 || (_circle4515 = /*#__PURE__*/React.createElement("circle", {
    cx: 1035.7,
    cy: 89.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4516 || (_circle4516 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030.9,
    cy: 91.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4517 || (_circle4517 = /*#__PURE__*/React.createElement("circle", {
    cx: 1026.1,
    cy: 92.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4518 || (_circle4518 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.3,
    cy: 94,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4519 || (_circle4519 = /*#__PURE__*/React.createElement("circle", {
    cx: 1016.5,
    cy: 95.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4520 || (_circle4520 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.8,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4521 || (_circle4521 = /*#__PURE__*/React.createElement("circle", {
    cx: 1007,
    cy: 98.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4522 || (_circle4522 = /*#__PURE__*/React.createElement("circle", {
    cx: 1002.2,
    cy: 99.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4523 || (_circle4523 = /*#__PURE__*/React.createElement("circle", {
    cx: 997.3,
    cy: 100.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4524 || (_circle4524 = /*#__PURE__*/React.createElement("circle", {
    cx: 992.3,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4525 || (_circle4525 = /*#__PURE__*/React.createElement("circle", {
    cx: 987.3,
    cy: 101,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4526 || (_circle4526 = /*#__PURE__*/React.createElement("circle", {
    cx: 982.3,
    cy: 101.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4527 || (_circle4527 = /*#__PURE__*/React.createElement("circle", {
    cx: 977.4,
    cy: 101.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4528 || (_circle4528 = /*#__PURE__*/React.createElement("circle", {
    cx: 972.4,
    cy: 102.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4529 || (_circle4529 = /*#__PURE__*/React.createElement("circle", {
    cx: 967.4,
    cy: 102.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4530 || (_circle4530 = /*#__PURE__*/React.createElement("circle", {
    cx: 962.5,
    cy: 102.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4531 || (_circle4531 = /*#__PURE__*/React.createElement("circle", {
    cx: 957.5,
    cy: 103.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4532 || (_circle4532 = /*#__PURE__*/React.createElement("circle", {
    cx: 952.5,
    cy: 102.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4533 || (_circle4533 = /*#__PURE__*/React.createElement("circle", {
    cx: 947.6,
    cy: 102.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4534 || (_circle4534 = /*#__PURE__*/React.createElement("circle", {
    cx: 942.6,
    cy: 101.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4535 || (_circle4535 = /*#__PURE__*/React.createElement("circle", {
    cx: 937.7,
    cy: 100.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4536 || (_circle4536 = /*#__PURE__*/React.createElement("circle", {
    cx: 932.8,
    cy: 100.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4537 || (_circle4537 = /*#__PURE__*/React.createElement("circle", {
    cx: 927.8,
    cy: 99.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4538 || (_circle4538 = /*#__PURE__*/React.createElement("circle", {
    cx: 922.9,
    cy: 98.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4539 || (_circle4539 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.9,
    cy: 98.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4540 || (_circle4540 = /*#__PURE__*/React.createElement("circle", {
    cx: 913,
    cy: 97.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4541 || (_circle4541 = /*#__PURE__*/React.createElement("circle", {
    cx: 908.2,
    cy: 96.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4542 || (_circle4542 = /*#__PURE__*/React.createElement("circle", {
    cx: 903.5,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4543 || (_circle4543 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.8,
    cy: 92.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4544 || (_circle4544 = /*#__PURE__*/React.createElement("circle", {
    cx: 894.1,
    cy: 91.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4545 || (_circle4545 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.4,
    cy: 89.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4546 || (_circle4546 = /*#__PURE__*/React.createElement("circle", {
    cx: 884.7,
    cy: 87.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4547 || (_circle4547 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.1,
    cy: 86,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4548 || (_circle4548 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.4,
    cy: 84.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4549 || (_circle4549 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.7,
    cy: 82.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4550 || (_circle4550 = /*#__PURE__*/React.createElement("circle", {
    cx: 866.2,
    cy: 80.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4551 || (_circle4551 = /*#__PURE__*/React.createElement("circle", {
    cx: 861.8,
    cy: 78.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4552 || (_circle4552 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.5,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4553 || (_circle4553 = /*#__PURE__*/React.createElement("circle", {
    cx: 853.1,
    cy: 73.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4554 || (_circle4554 = /*#__PURE__*/React.createElement("circle", {
    cx: 848.7,
    cy: 70.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4555 || (_circle4555 = /*#__PURE__*/React.createElement("circle", {
    cx: 844.3,
    cy: 68.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4556 || (_circle4556 = /*#__PURE__*/React.createElement("circle", {
    cx: 840,
    cy: 66.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4557 || (_circle4557 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.6,
    cy: 63.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4558 || (_circle4558 = /*#__PURE__*/React.createElement("circle", {
    cx: 831.2,
    cy: 61.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4559 || (_circle4559 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.8,
    cy: 59,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4560 || (_circle4560 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.4,
    cy: 56.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4561 || (_circle4561 = /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 54.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4562 || (_circle4562 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.5,
    cy: 52.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4563 || (_circle4563 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.8,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4564 || (_circle4564 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.1,
    cy: 49,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4565 || (_circle4565 = /*#__PURE__*/React.createElement("circle", {
    cx: 799.3,
    cy: 47.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4566 || (_circle4566 = /*#__PURE__*/React.createElement("circle", {
    cx: 794.6,
    cy: 45.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4567 || (_circle4567 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.9,
    cy: 44.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4568 || (_circle4568 = /*#__PURE__*/React.createElement("circle", {
    cx: 785.1,
    cy: 43.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4569 || (_circle4569 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.1,
    cy: 43,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4570 || (_circle4570 = /*#__PURE__*/React.createElement("circle", {
    cx: 775.1,
    cy: 42.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4571 || (_circle4571 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.1,
    cy: 42.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4572 || (_circle4572 = /*#__PURE__*/React.createElement("circle", {
    cx: 765.1,
    cy: 42.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4573 || (_circle4573 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.1,
    cy: 42.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4574 || (_circle4574 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.2,
    cy: 42.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4575 || (_circle4575 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.2,
    cy: 42.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4576 || (_circle4576 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.4,
    cy: 43.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4577 || (_circle4577 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 44.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4578 || (_circle4578 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.7,
    cy: 46.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4579 || (_circle4579 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.9,
    cy: 47.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4580 || (_circle4580 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.1,
    cy: 48.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4581 || (_circle4581 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.3,
    cy: 50.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4582 || (_circle4582 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.5,
    cy: 51.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4583 || (_circle4583 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.8,
    cy: 53.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4584 || (_circle4584 = /*#__PURE__*/React.createElement("circle", {
    cx: 707.2,
    cy: 55.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4585 || (_circle4585 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.7,
    cy: 57.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4586 || (_circle4586 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.1,
    cy: 59.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4587 || (_circle4587 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.5,
    cy: 61.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4588 || (_circle4588 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 63.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4589 || (_circle4589 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.4,
    cy: 65.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4590 || (_circle4590 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.8,
    cy: 67.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4591 || (_circle4591 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.3,
    cy: 69.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4592 || (_circle4592 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.8,
    cy: 71.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4593 || (_circle4593 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.3,
    cy: 73.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4594 || (_circle4594 = /*#__PURE__*/React.createElement("circle", {
    cx: 661.8,
    cy: 75.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4595 || (_circle4595 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.3,
    cy: 77.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4596 || (_circle4596 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.8,
    cy: 80,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4597 || (_circle4597 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.3,
    cy: 82.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4598 || (_circle4598 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.8,
    cy: 84.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4599 || (_circle4599 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.2,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4600 || (_circle4600 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.5,
    cy: 87.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4601 || (_circle4601 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.8,
    cy: 89.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4602 || (_circle4602 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.2,
    cy: 91.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4603 || (_circle4603 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.5,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4604 || (_circle4604 = /*#__PURE__*/React.createElement("circle", {
    cx: 615.8,
    cy: 95,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4605 || (_circle4605 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.2,
    cy: 96.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4606 || (_circle4606 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.5,
    cy: 98.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4607 || (_circle4607 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.6,
    cy: 99.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4608 || (_circle4608 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.7,
    cy: 100.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4609 || (_circle4609 = /*#__PURE__*/React.createElement("circle", {
    cx: 591.7,
    cy: 100.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4610 || (_circle4610 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.8,
    cy: 101.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4611 || (_circle4611 = /*#__PURE__*/React.createElement("circle", {
    cx: 581.9,
    cy: 102.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4612 || (_circle4612 = /*#__PURE__*/React.createElement("circle", {
    cx: 577,
    cy: 103.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4613 || (_circle4613 = /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 104,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4614 || (_circle4614 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.1,
    cy: 104.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4615 || (_circle4615 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.1,
    cy: 103.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4616 || (_circle4616 = /*#__PURE__*/React.createElement("circle", {
    cx: 557.2,
    cy: 103,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4617 || (_circle4617 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.2,
    cy: 102.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4618 || (_circle4618 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.3,
    cy: 101.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4619 || (_circle4619 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.3,
    cy: 101.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4620 || (_circle4620 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.4,
    cy: 100.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4621 || (_circle4621 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 99.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4622 || (_circle4622 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.8,
    cy: 98.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4623 || (_circle4623 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.1,
    cy: 96.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4624 || (_circle4624 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.4,
    cy: 94.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4625 || (_circle4625 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.7,
    cy: 93.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4626 || (_circle4626 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.9,
    cy: 91.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4627 || (_circle4627 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.2,
    cy: 89.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4628 || (_circle4628 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.5,
    cy: 88.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4629 || (_circle4629 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 86.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4630 || (_circle4630 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.5,
    cy: 83.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4631 || (_circle4631 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 81.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4632 || (_circle4632 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.5,
    cy: 79.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4633 || (_circle4633 = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 77.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4634 || (_circle4634 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.5,
    cy: 75.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4635 || (_circle4635 = /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 73.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4636 || (_circle4636 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.5,
    cy: 71.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4637 || (_circle4637 = /*#__PURE__*/React.createElement("circle", {
    cx: 459,
    cy: 68.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4638 || (_circle4638 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.6,
    cy: 66.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4639 || (_circle4639 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.1,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4640 || (_circle4640 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.6,
    cy: 62.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4641 || (_circle4641 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.1,
    cy: 60.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4642 || (_circle4642 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.6,
    cy: 58,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4643 || (_circle4643 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.1,
    cy: 55.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4644 || (_circle4644 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.4,
    cy: 54.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4645 || (_circle4645 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.8,
    cy: 52.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4646 || (_circle4646 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.1,
    cy: 50.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4647 || (_circle4647 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.4,
    cy: 48.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4648 || (_circle4648 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.8,
    cy: 47,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4649 || (_circle4649 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.1,
    cy: 45.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4650 || (_circle4650 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 43.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4651 || (_circle4651 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.6,
    cy: 42.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4652 || (_circle4652 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.6,
    cy: 41.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4653 || (_circle4653 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.7,
    cy: 41,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4654 || (_circle4654 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.8,
    cy: 40.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4655 || (_circle4655 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.9,
    cy: 39.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4656 || (_circle4656 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.9,
    cy: 38.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4657 || (_circle4657 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 37.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4658 || (_circle4658 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.1,
    cy: 37.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4659 || (_circle4659 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.2,
    cy: 36.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4660 || (_circle4660 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.2,
    cy: 35.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4661 || (_circle4661 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.3,
    cy: 35.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4662 || (_circle4662 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.3,
    cy: 35.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4663 || (_circle4663 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.3,
    cy: 36,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4664 || (_circle4664 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.4,
    cy: 36.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4665 || (_circle4665 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.4,
    cy: 36.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4666 || (_circle4666 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.4,
    cy: 37.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4667 || (_circle4667 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.4,
    cy: 37.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4668 || (_circle4668 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.5,
    cy: 37.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4669 || (_circle4669 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.5,
    cy: 38.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4670 || (_circle4670 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 38.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4671 || (_circle4671 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.6,
    cy: 38.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4672 || (_circle4672 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.7,
    cy: 40.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4673 || (_circle4673 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.9,
    cy: 41.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4674 || (_circle4674 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.1,
    cy: 42.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4675 || (_circle4675 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.2,
    cy: 43.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4676 || (_circle4676 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.4,
    cy: 45.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4677 || (_circle4677 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.6,
    cy: 46.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4678 || (_circle4678 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.8,
    cy: 47.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4679 || (_circle4679 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.9,
    cy: 48.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4680 || (_circle4680 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.1,
    cy: 50.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4681 || (_circle4681 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.3,
    cy: 51.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4682 || (_circle4682 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 52.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4683 || (_circle4683 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.9,
    cy: 54.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4684 || (_circle4684 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.3,
    cy: 56.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4685 || (_circle4685 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.7,
    cy: 58.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4686 || (_circle4686 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.1,
    cy: 60.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4687 || (_circle4687 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 62.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4688 || (_circle4688 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 64.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4689 || (_circle4689 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.4,
    cy: 66.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4690 || (_circle4690 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.8,
    cy: 68.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4691 || (_circle4691 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.2,
    cy: 70.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4692 || (_circle4692 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.6,
    cy: 72.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4693 || (_circle4693 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.1,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4694 || (_circle4694 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.7,
    cy: 76.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4695 || (_circle4695 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.2,
    cy: 79,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4696 || (_circle4696 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.8,
    cy: 81.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4697 || (_circle4697 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.3,
    cy: 83.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4698 || (_circle4698 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.9,
    cy: 85.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4699 || (_circle4699 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 88.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4700 || (_circle4700 = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 90.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4701 || (_circle4701 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 92.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4702 || (_circle4702 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.9,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4703 || (_circle4703 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.4,
    cy: 96.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4704 || (_circle4704 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.9,
    cy: 98.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4705 || (_circle4705 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.3,
    cy: 100.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4706 || (_circle4706 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.8,
    cy: 102.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4707 || (_circle4707 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.2,
    cy: 104.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4708 || (_circle4708 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.4,
    cy: 106,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4709 || (_circle4709 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.6,
    cy: 107.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4710 || (_circle4710 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.8,
    cy: 108.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4711 || (_circle4711 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4712 || (_circle4712 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.2,
    cy: 111.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4713 || (_circle4713 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.4,
    cy: 112.7,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4714 || (_circle4714 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 113.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4715 || (_circle4715 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 113.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4716 || (_circle4716 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 114.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4717 || (_circle4717 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.6,
    cy: 114.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4718 || (_circle4718 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6,
    cy: 114.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4719 || (_circle4719 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.6,
    cy: 114.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4720 || (_circle4720 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7,
    cy: 113.6,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4721 || (_circle4721 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9,
    cy: 112.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4722 || (_circle4722 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 111.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4723 || (_circle4723 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 110.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4724 || (_circle4724 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3,
    cy: 109.1,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4725 || (_circle4725 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6,
    cy: 107.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4726 || (_circle4726 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4,
    cy: 104.9,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4727 || (_circle4727 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1,
    cy: 102.3,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4728 || (_circle4728 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8,
    cy: 99.8,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4729 || (_circle4729 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 97.2,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4730 || (_circle4730 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4,
    cy: 94.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4731 || (_circle4731 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4,
    cy: 90.5,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4732 || (_circle4732 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 86.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4733 || (_circle4733 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 82.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4734 || (_circle4734 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 78.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })), _circle4735 || (_circle4735 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.6,
    cy: 74.4,
    r: 0.8,
    className: "soundwave_svg__st21"
  })));
};
export default SvgSoundwave;